import { supportEmailaddr } from "../constants";

export const gFRAppsString =
{
    "OK": "OK",
    "Cancel": "Annuler",
    "Yes": "Oui",
    "No": "Non",
    "Reset": "Réinitialiser",
    "Search": "Rechercher",
    "Add": "Ajouter",
    "Delete": "Supprimer",
    "Rename": "Renommer",
    "Up": "Haut",
    "Down": "Bas",
    "Edit": "Modifier",
    "results": "Résultats",
    "Rules": "Règles",
    "Default": "Défaut",
    "Open": "Ouvrir",
    "Save": "Enregistrer",
    "Build": "Construire",
    "Duplicate": "Dupliquer",
    "Min": "Min",
    "To": "À",
    "Max": "Max",
    "Formatting": "Formatage",
    "clickhidden": "Cliquez ici pour afficher les objets cachés",
    "Span": "Envergure",
    "Role": "Rôle",
    "Name": "Nom",
    "Subtract": "Soustraire",
    "Multiply": "Multiplier",
    "Divide": "Diviser",
    "Average": "Moyenne",
    "Count": "Compter",
    "Sum": "Somme",
    "Split": "Divisé",
    "launchmode": "Lancer le mode",
    "Title": "Fonction",
    "topbox": "Case sommet",
    "Location": "Lieu",
    "Department": "Département",
    "WorkPhone": "Téléphone bureau",
    "Orphan": "Orphelin",
    "TopOfSubChart": "Sommet Page",
    "Level": "Niveau",
    "SubChartLevel": "Niveau Page",
    "SpanOfControl": "Rapports directs",
    "Subordinates": "Subordonnès",
    "Headcount": "Effectif",
    "ReportsTo": "Rapports à",
    "INSERT": "INSERER",
    "DATA": "DONNEES",
    "VIEW": "AFFICHAGE",
    "Position": "Poste",
    "Assistant": "Assistant",
    "Root": "Racine",
    "Text": "Texte",
    "Monthly": "Mensuel",
    "AutoText": "TexteAuto",
    "Image": "Image",
    "Table": "Tableau",
    "Legend": "Lègende",
    "Select": "Choisir",
    "Pan": "Panoramique",
    "Insert": "Insérer",
    "Remove": "Supprimer",
    "Wizard": "Assistant",
    "Normal": "Normal",
    "Master": "Masque",
    "Apply": "Appliquer",
    "nofill": "Aucun Remplissage",
    "noborder": "Aucune Bordure",
    "singleborder": "Bordure simple",
    "dblborder": "Bordure double",
    "Value": "Valeur",
    "Label": "Étiquette",
    "labelvalue": "Étiquette:Valeur",
    "Next": "Suivant",
    "Prev": "Préc",
    "Next (short)": "Suiv.",
    "Prev (short)": "Préc",
    "Previous": "Précédent",
    "findwhat": "Trouver quoi",
    "selectmatches": "Tous les résultats",
    "replacewith": "Remplacer par",
    "Replace": "Remplacer",
    "replaceall": "Remplacer Tous",
    "box": "case",
    "boxes": "cases",
    "Box": "Case",
    "Boxes": "Cases",
    "Layout": "Disposition",
    "Setup": "Configuration",
    "Template": "Affichage",
    "Copyright": "Droits d'auteur",
    "Version": "Version",
    "Allrights": "Tous droits réservés.",
    "Edition": "Édition",
    "SupportMsg": "Si ce problème persiste, contacter",
    "SalesMsg": "Pour plus d'information, contacter",
    "comingsoon": "Prochainement !",
    "Help": "Aide",
    "Profile": "Profil",
    "Templates": "Affichages",
    "Parking": "Parking",
    "Box Styles": "Styles",
    "Box Style": "Style",
    "applychanges": "Appliquer les changements à",
    "iwizselectmsg1": "L'Assistant Import crée automatiquement un organigramme à partir d'un fichier Excel.",
    "iwizselectmsg2": "Si vous avez besoin de créer un fichier Excel, téléchargez la feuille Exemple puis modifiez-la si nécessaire.",
    "iwizselectmsg3": "Tous les fichiers de données doivent être remontés sur votre espace de compte cloud avant de pouvoir être utilisés.",
    "iwizselectmsg4": "Cliquez sur le bouton 'Importer Données' pour importer un fichier de l'espace de stockage.",
    "iwizselectsample": "Exemple",
    "iwizselectupload": "Remonter des fichiers",
    "iwizselectimport": "Importer des données",
    "iwizfiltermsg1": "Optionnellement, vous pouvez filtrer votre source de données.",
    "iwizfiltermsg2": "Seuls les enregistrements correspondant au filtre défini seront importés.",
    "iwizfilterchk": "Définissez votre filtre de données",
    "buildhier2": "Si vos données n'incluent pas des champs de hiérarchie (ID Employé et ID Superviseur), vous pouvez manuellement",
    "buildhier3": "glisser & déposer des cases pour créer un organigramme après que les données ont été importées.",
    "buildhier4": "Les données contiennent des champs de hiérarchie",
    "PersonID": "IDEmployé",
    "SupervisorID": "IDResponsable",
    "NewSuperID": "NouveauIDResponsable",
    "iwizerr1": "Le filtre ne correspond à aucun enregistrement.",
    "iwizerr2": "Référence circulaire trouvée.",
    "iwizsc1": "Si votre organigramme contient trop de cases pour tenir sur une seule page, vous pouvez découper votre organigramme en plusieurs pages.",
    "matchonly": "Correspondances seulement",
    "directsubs": "Inclure les subordonnés directs",
    "allsubs": "Inclure tous les subordonnés",
    "Back": "Retour",
    "Field": "Champ",
    "Comparison": "Comparaison",
    "Upload": "Remonter",
    "Download": "Télécharger",
    "Files": "Fichiers",
    "files": "fichiers",
    "Folders": "Dossiers",
    "sysstyles": "Styles système",
    "userstyles": "Styles utilisateur",
    "sharedstyles": "Styles partagés",
    "System": "Système",
    "Shared": "Partagé",
    "User": "Utilisateur",
    "charttemplate": "Affichage d'organigramme",
    "nobreaks": "Ne pas insérer de rupture",
    "breakbylevel": "Découper par niveau",
    "breakbyfield": "Découper selon le champ",
    "entirechart": "Organigramme entier",
    "selection": "Sélection",
    "boxwidth": "Largeur de case",
    "Fixed": "Fixe",
    "Auto": "Auto",
    "boxheight": "Hauteur de case",
    "Gutter": "Gouttière",
    "Options": "Options",
    "Custom": "Personnalisée",
    "aligncells": "Aligner les Cellules",
    "Preview": "Aperçu",
    "setasdef": "Disposition par défaut",
    "Standard": "Standard",
    "Dense": "Dense",
    "Manual": "Manuel",
    "fieldeditor": "Editeur de champs",
    "andor": "Et/Ou",
    "Height": "Hauteur",
    "Width": "Largeur",
    "curpagesize": "Taille de page actuelle",
    "minpagesize": "Taille de page minimum",
    "showmarg": "Afficher les lignes de marge",
    "Margins": "Marges",
    "Orientation": "Orientation",
    "headfoot": "Entête & Pied de page",
    "showheadfoot": "Afficher les lignes des entête & pied de page",
    "Top": "Haut",
    "Bottom": "Bas",
    "Right": "Droite",
    "Left": "Gauche",
    "letterps": "Lettre US",
    "legalps": "Legal US",
    "tabloidps": "Tabloïd",
    "a0ps": "A0",
    "a1ps": "A1",
    "a2ps": "A2",
    "a3ps": "A3",
    "a4ps": "A4",
    "ppt1ps": "PowerPoint 4:3",
    "ppt2ps": "PowerPoint 16:9",
    "ppt3ps": "PowerPoint 16:10",
    "customps": "Personnalisé",
    "standardm": "Standard",
    "widem": "Large",
    "narrowm": "Etroit",
    "customm": "Personnalisé",
    "landscape": "Paysage",
    "portrait": "Portrait",
    "standardh": "Entête standard",
    "noheader": "Aucun entête",
    "customh": "Personnalisé",
    "standardf": "Pied de page standard",
    "nofooter": "Aucun pied de page",
    "Footer": "Pied de page",
    "customf": "Personnalisé",
    "breakfield": "Découper sur le champ :",
    "breakevery": "Découper tous les :",
    "minbreak": "Minimum de cases pour découper :",
    "selecttemplate": "Sélectionner un affichage à appliquer à l'organigramme. Après l'organigramme est généré, vous pouvez sélectionner un autre affichage du panneau des affichages.",
    "createchart": "Créer un organigramme",
    "importerr": "La source de données sélectionnée ne peut être importée. Le problème suivant a besoin d'être résolu avant de pouvoir importer le fichier :",
    "unknownerr": "<Erreur inconnue>",
    "Retry": "Réessayer",
    "importwiz": "Assistant Import",
    "selectimportfile": "Choisir le fichier à importer",
    "filterdata": "Filtrer les données",
    "subchartbr": "Assistant Sous-organigramme",
    "selectctemplate": "Sélectionner l'affichage d'organigramme",
    "unableimport": "Impossible d'importer les données",
    "unablebuildhier": "Impossible de construire la hiérarchie",
    "wirehiererr": "Les champs IDEmployé et/ou IDResponsable ne sont pas définis.",
    "Levels": "Niveaux",
    "and": "et",
    "or": "ou",
    "Middle": "Milieu",
    "ruleorder": "Règle (appliquée dans l'ordre affiché)",
    "equals": "égal à",
    "notequal": "pas égal à",
    "startswith": "commence par",
    "contains": "contient",
    "doesnotcontain": "ne contient pas",
    "isempty": "est vide",
    "isnotempty": "n'est pas vide",
    "greater": "plus grand que",
    "less": "plus petit",
    "greaterequal": "plus grand ou égal à",
    "lessequal": "plus petit ou égal à",
    "pagenum": "Page n°",
    "totalpages": "Total de pages",
    "pagex": "Page x",
    "pagexy": "Page x de y",
    "today": "Aujourd'hui",
    "subchartname": "Nom de page",
    "subchartnum": "Sous-Page #",
    "subchartpath": "Chemin de page",
    "filename": "Nom de fichier",
    "january": "janvier",
    "february": "février",
    "march": "mars",
    "april": "avril",
    "may": "Mai",
    "june": "juin",
    "july": "juillet",
    "august": "août",
    "september": "septembre",
    "october": "octobre",
    "november": "novembre",
    "december": "décembre",
    "jan": "janv",
    "feb": "févr",
    "mar": "mars",
    "apr": "avril",
    "jun": "juin",
    "jul": "juil",
    "aug": "août",
    "sep": "sept",
    "oct": "oct",
    "nov": "nov",
    "dec": "déc",
    "alignleft": "Aligner à Gauche",
    "aligncenter": "Aligne au Centre",
    "alignright": "Aligner à Droite",
    "aligntop": "Aligner en Haut",
    "alignmiddle": "Aligner au Milieu",
    "alignbottom": "Aligner en Bas",
    "bringtofront": "Mettre au premier plan",
    "sendtoback": "Mettre en arrière-plan",
    "bringforward": "Avancer",
    "sendbackward": "Reculer",
    "pinoff": "Détacher",
    "managefields": "Gérer les champs",
    "of": "de",
    "Untitled": "Sans Titre",
    "allboxes": "Toutes les cases",
    "allmgr": "Tous les responsables",
    "allassist": "Tous les assistants",
    "allnonmgr": "Tous les non responsables",
    "allconn": "Toutes les liaisons",
    "Peers": "Collègues",
    "Branch": "Branche",
    "boxsame": "Cases avec même format",
    "boxsimiliar": "Cases avec format similaire",
    "textboxes": "Cases Texte",
    "lockedboxes": "Cases verrouillées",
    "Clipboard": "Presse-papiers",
    "Tools": "Outils",
    "Alignment": "Alignement",
    "Line": "Ligne",
    "Chart": "Organigramme",
    "Charts": "Organigrammes",
    "Editing": "Edition",
    "Page": "Page",
    "rowscols": "Lignes & Colonnes",
    "Merge": "Fusionner",
    "cellborder": "Bordure de cellule",
    "closeeditor": "Fermer l'Éditeur",
    "Views": "Vues",
    "Navigation Sidebar": "Barre latérale de navigation",
    "Extras": "Extras",
    "Subcharts": "Sections",
    "datarefresh": "Rafraîchir les données",
    "Fields": "Champs",
    "Connectors": "Connecteurs",
    "Export": "Exporter",
    "saveas": "Enregistrer sous",
    "saveas (short)": "Enreg. sous",
    "Auto-save": "Enregistrer auto.",
    "uploadfile": "Remonter/Télécharger des fichiers",
    "selectimport": "Choisir le fichier à importer",
    "bsapply": "Style de case à appliquer :",
    "notset": "<Non défini>",
    "selectbs": "Veuillez sélectionner un style de case",
    "ctloaderr": "Erreur pendant le chargement des affichages d'organigramme. Veuillez essayer de nouveau.",
    "helploaderr": "Erreur de chargement du fichier aide. Veuillez réessayer.",
    "bsloaderr": "Erreur de chargement de styles de case. Veuillez réessayer.",
    "fileloaderr": "Erreur de chargement de fichier. Veuillez réessayer.",
    "nameblank": "Le nom ne peut pas être vide.",
    "Publisher": "Editeur",
    "createpreview": "Création d'un aperçu...",
    "createpdf": "Création d'un PDF...",
    "createsvg": "Création d'un SVG...",
    "Creating": "Création",
    "Bkgrnd": "ArrPlan",
    "Crop": "Recadrer",
    "Exit": "Sortir",
    "Close": "Fermer",
    "exporto": "Exporter vers",
    "folderadderr": "Impossible d'ajouter un dossier. Veuillez réessayer.",
    "permdel": "Êtes-vous sûr de vouloir supprimer définitivement les fichiers sélectionnés ?",
    "deleteerr": "Impossible de supprimer les fichiers sélectionnés. Veuillez réessayer.",
    "deletefoldererr": "Impossible de supprimer le dossier. Veuillez réessayer.",
    "duperr": "Impossible de dupliquer les fichiers sélectionnés. Veuillez réessayer.",
    "moveerr": "Impossible de déplacer les fichiers sélectionnés. Veuillez réessayer.",
    "filenotfound": "Fichier non trouvé. Veuillez entrer un nom de fichier valide.",
    "saveerror": "Erreur d'enregistrement de fichier. Veuillez réessayer.",
    "uploaderror": "Impossible de remonter le fichier. Veuillez réessayer.",
    "bssaveerror": "Erreur d'enregistrement des styles de case.",
    "bsreload1": "Êtes-vous sûr de vouloir recharger les styles de case ?",
    "bsreload2": "Tous les changements seront annulés.",
    "ctsaveerror": "Erreur lors de l'enregistrement des affichages d'organigramme. Veuillez réessayer.",
    "ctreload1": "Voulez-vous vraiment recharger les affichages d'organigramme ?",
    "ctreload2": "Tous les changements seront annulés.",
    "deletect": "Voulez-vous vraiment supprimer les affichages d'organigramme sélectionnés ?",
    "replacemsg": "Le fichier existe déjà. Voulez-vous remplacer le fichier ?",
    "delbsmsg1": "Êtes-vous sûr de vouloir supprimer les styles de case sélectionnés ?",
    "delbsmsg2": "Avertissement : Certaines styles de case sont référencés par les affichages d'organigramme.",
    "delctmsg1": "Voulez-vous vraiment supprimer les affichages d'organigramme sélectionnés ?",
    "saveconfirm1": "Voulez-vous enregistrer les changements de",
    "saveconfirm2": "?",
    "ql1": "Créer manuellement un nouvel organigramme.",
    "ql2": "Ouvrir un organigramme existant.",
    "ql3": "Télécharger un exemple de données Excel.",
    "ql4": "Remonter un fichier Excel.",
    "ql5": "Lancer l'Assistant Import.",
    "ql6": "Publier l'organigramme actuel vers PNG, SVG ou PDF.",
    "ql7": "Progresser à travers les tutoriels.",
    "ql8": "Examiner les fichiers exemple.",
    "ql9": "Regarder les vidéos 'Comment faire'.",
    "ql10": "Télécharger le Guide de Démarrage rapide.",
    "quicklinks": "Liens Rapides",
    "showql": "Afficher les Liens Rapides après connexion",
    "freetrialtl1": "Votre évaluation gratuite de",
    "freetrialtl2": "est terminée.",
    "freetrial1": "Evaluation Gratuite",
    "freetrial2": "Merci d'avoir évalué",
    "freetrial4": "Votre compte d'essai vous permet d'importer jusqu'à 1000 enregistrements. Contactez-nous si vous avez besoin de plus de capacité.",
    "freetrial5": "A la fin de votre essai, vous serez déclassé à un compte de lecture seule et vous continuerez d'avoir accès à tous vos documents.",
    "freetrial6": "Il n'y a aucune obligation pour vous.",
    "Day": "Jour",
    "Days": "Jours",
    "signout": "Déconnecter",
    "Continue": "Continuer",
    "Purchase": "Acheter",
    "acctdisable1": "Compte désactivé",
    "acctdisable2": "Votre compte est désactivé.",
    "acctdisable3": "Veuillez nous écrire à",
    "acctdisable4": "Si vous souhaitez réactiver votre compte.",
    "acctexpired1": "Période d'évaluation terminée",
    "acctexpired2": "Merci d'avoir évalué",
    "acctexpired3": "Votre période d'évaluation est terminée.",
    "acctexpired4": "Votre compte a été déclassé en compte lecture seule. Vous avez encore accès à tous vos documents.",
    "msgpostlogin": "Afficher ce message la prochaine fois que je me connecte.",
    "oldpass": "Ancien mot de passe",
    "newpass": "Nouveau mot de passe",
    "passinvalid": "Ancien mot de passe invalide.",
    "passnomatch": "Les mots de passe ne correspondent pas.",
    "passmin": "La longueur minimum est",
    "passmin2": "caractères",
    "reenteremail": "Veuillez entrer une adresse email valide.",
    "Reset password": "Réinitialiser le mot de passe",
    "needid": "Commencer un essai gratuit",
    "welcometo": "Bienvenue à",
    "usernamet": "Entrez le nom utilisateur",
    "passwordt": "Entrez le mot de passe",
    "autologon": "Se connecter automatiquement",
    "Log in": "Connexion",
    "loginfail": "La connexion a échoué. Veuillez réessayer.",
    "pwemail": "Entrez une adresse email",
    "Reset Password": "Réinitialiser le mot de passe",
    "backlogin": "Retour à l'écran de connexion",
    "resetpwsuccess": "Vérifiez votre email pour des certificats mis à jour.",
    "resetpwfail": "L'utilisateur avec cette addresse e-mail est introuvable. Contactez votre administrateur système pour vos coordonnées d'accès.",
    "loaderr1": "Le format de fichier de données est invalide.",
    "loaderr2": "La première ligne du fichier de données contient des noms de champ.",
    "loaderr3": "Le champ 'ID' est réservé pour un usage interne et ne peut pas être utilisé comme nom de champ.",
    "loaderr4a": "Les noms de champ doivent être uniques. Le champ",
    "loaderr4b": "est utilisé plus d'une fois dans le fichier de données.",
    "loaderr5": "Le fichier ne contient aucune donnée.",
    "loaderr6a": "Vous êtes limité à importer un maximum de",
    "loaderr6b": "enregistrements. Vous aurez besoin de mettre à jour votre compte pour importer plus d'enregistrements.",
    "loaderr7": "Le nombre d'éléments donné sur une ligne doit correspondre au nombre de champs (Vérifiez la ligne :",
    "loaderr8": "Les définitions de champ sont manquantes.",
    "removebreaks": "Supprimer tous les sauts de page",
    "renamebreaks": "Renommer tous les sauts",
    "maketop": "Devenir sommet",
    "hierlock": "Verrouiller comme subordonné à un responsable",
    "lockmsg": "Le rafraîchissement de données ne mettra pas à jour les articles verrouillés.",
    "Locking": "Verrouiller",
    "New": "Nouveau",
    "Import": "Importer",
    "refreshorg": "Rafraîchir l’organigramme",
    "Configure": "Configurer",
    "EDIT": "ORGANIGRAMME",
    "EDITM": "MASQUE",
    "IMPORT": "IMPORTER DONNEES",
    "REFRESH": "Rafraîchir",
    "SHARE": "PARTAGER",
    "HELP": "Aide",
    "addsubtool": "Ajouter case",
    "moveboxtool": "Déplacer case",
    "moveobjtool": "Déplacer Objet",
    "imageinfo": "Propriétés Image",
    "Header1": "Entête1",
    "Header2": "Entête2",
    "Tutorials": "Tutoriels",
    "Videos": "Vidéos",
    "OnlineDocs": "Documents en ligne",
    "Guide": "Guide",
    "iwizerr0": "En train de télécharger les affichages. Veuillez essayer de nouveau.",
    "Directory": "Répertoire",
    "File": "Fichier",
    "orgcharts": "Organigrammes",
    "Create": "Créer",
    "Settings": "Paramètres",
    "Properties": "Propriétés",
    "includechain": "Inclure chaîne de commande",
    "autofixhier": "Gérer plusieurs chefs de département",
    "addexecteam": "Ajouter 'Equipe de Direction'",
    "pinoptions": "Placement",
    "stickleft": "Coller à gauche",
    "addparams": "Paramètres",
    "stickright": "Coller à droite",
    "sticktop": "Coller en haut",
    "stickbottom": "Coller en bas",
    "summary": "Résumé",
    "Document": "Document",
    "Data": "Données",
    "Web": "Web",
    "Publish": "Publier",
    "toporphans": "Tous les succursales déconnectées",
    "tableprops": "Éditeur de table",
    "legendprops": "Éditeur de légende",
    "OptionsP": "Options…",
    "RefText": "Résumé",
    "Share": "Partager",
    "hyperlink": "hyperlien",
    "includereftbl": "Utiliser Table de Référence",
    "refinvalid": "Invalide",
    "refnotfound": "Pas trouvé",
    "refnotconfig": "Pas configuré",
    "compoundcb": "Créer un document organigrammes multiples",
    "spliton": "Diviser en utilisant",
    "Division": "Division",
    "contentlock": "Verrouiller le contenu",
    "layoutlock": "Verrouiller le format",
    "FILE": "FICHIER",
    "Cloud": "Nuage",
    "Letter": "Lettre",
    "Legal": "Legal",
    "Tabloid": "Tabloïd",
    "A0": "A0",
    "A1": "A1",
    "A2": "A2",
    "A3": "A3",
    "A4": "A4",
    "namescusing": "Nommer en utilisant le champ :",
    "nomaster": "Fond blanc",
    "stdmaster": "Fond classique",
    "custommaster": "Fond personnalisé",
    "subchartwiz": "Assistant Sous-organigramme",
    "selectcmasterIW": "Fond",
    "selectcmasterSA": "Options de fond",
    "selectmasterfile": "Sélectionner le fond",
    "Change Password": "Mot de passe...",
    "companyname": "Nom de l'entreprise",
    "entercompany": "Entrez le nom de l'entreprise",
    "Subchart": "Page",
    "mpdoc": "Indisponible. Le document actuel est un fond.",
    "selectmaster": "Les éléments de fond apparaîtront sur tous les pages de l'organigramme.",
    "savemaster": "fond",
    "Update": "Actualiser",
    "boxlayouteditor": "Éditeur de disposition de case",
    "Box Properties": "Propriétés case",
    "SelectP": "Sélectionner...",
    "orgnamemin": "Le nom de l'entreprise ne peut être vide.",
    "changeimportfile": "Sélectionner la source de données",
    "currentimportfile": "Importer les données de :",
    "rpdatasource": "Source",
    "rpfilter": "Filtrer les données",
    "rpsubcharts": "Sauts de page",
    "rptemplate": "Affichage d'organigramme",
    "rpmaster": "Fond",
    "loading": "[1] Chargement...",
    "buildingchart": "[2] Chargement...",
    "saving": "[1] Enregistrement...",
    "saving2": "[2] Enregistrement...",
    "retrievingdata": "Récupération des données...",
    "loadingdata": "Chargement des données...",
    "creatingchart": "Création de l'organigramme...",
    "iwizerr3": "Les champs IDEmployé et/ou IDResponsable non trouvés dans la source de données.",
    "smartstartlevel": "Commencer à partir du niveau :",
    "nomatches": "Pas de correspondance trouvée.",
    "onematch": "1 correspondance trouvée.",
    "matchesfound": "correspondances trouvées.",
    "nowrap": "Désactivé",
    "oneline": "Limiter à 1 ligne",
    "twolines": "Limiter à 2 lignes",
    "threelines": "Limiter à 3 lignes",
    "fourlines": "Limiter à 4 lignes",
    "unlimited": "Illimité",
    "freetext": "Texte libre",
    "fieldcompblank": "Les champs et les comparateurs ne peuvent être vides.",
    "cursubchart": "Page actuelle",
    "currentpage": "Page actuelle",
    "autoself": "Auto (Soi-même)",
    "autosmart": "Auto (Intelligent)",
    "Arrange": "Agencer",
    "Move": "Déplacer",
    "selectimagefile": "Sélectionner Image",
    "validfile": "Veuillez sélectionner un type de fichier valide.",
    "maxfilesize": "La taille maximum pour ce fichier est de",
    "maximagesize": "La taille maximale du fichier image est de 1 Mo.",
    "openfile": "Ouvrir organigramme",
    "iwizerr4": "Trop d'enregistrements pour une seule page. Ajustez les options de sous-organigramme et réessayez.",
    "miniscarrow": "Mini-flèche",
    "whitescarrow": "Flèche blanche",
    "blackscarrow": "Flèche noire",
    "Cell": "Cellule",
    "scarrowstyle": "Flèches de sous pages",
    "fieldtype": "Type de champ",
    "decimalplaces": "Décimales",
    "Number": "Chiffre",
    "Date": "Date",
    "Photo": "Photo",
    "Performance": "Performance",
    "Potential": "Potentiel",
    "ninebox": "9-Box",
    "Blank": "Vide",
    "Null - Not configured": "Null - Non configuré",
    "nobreakstoomany": "Ne pas insérer de saut (Désactivé - trop d'enregistrements)",
    "removebreakstoomany": "Supprimer tous les sauts (Désactivé - trop d'enregistrements)",
    "Match": "Correspondance",
    "Matches": "Correspondances",
    "clearsearch": "Effacer",
    "selfsubs": "Case + Subordonnés",
    "subsonly": "Subordonnés",
    "selfdirreports": "Case + Subordonnés directs",
    "dirreports": "Subordonnés directs",
    "Range": "Portée",
    "Formulas": "Formules",
    "buildhier1": "Veuillez identifier les champs requis et optionnels.",
    "buildhier": "Définir les champs",
    "orginfochgfail": "Mise à jour échouée. Veuillez réessayer.",
    "rpreqfields": "Définir les champs",
    "refreshnow": "Rafraîchir les données maintenant",
    "reqaccessacct": "Demander l'accès à un compte existant.",
    "requestaccess": "Demander l'accès",
    "requestaccessmsg": "Contactez votre administrateur si l'adresse email n'est pas trouvée.",
    "enteraccessgroup": "Entrez un nom de groupe d'accès",
    "accessgroup": "Groupe d'accès",
    "Access groups": "Groupes d'accès",
    "Manage users": "Gérer les utilisateurs",
    "UI profiles": "Profils d'UI",
    "Chart management": "Gestion des organigrammes",
    "nogroup": "Pas de groupe sélectionné",
    "manageaccessgroups": "Gérer les groupes d'accès",
    "managegroups": "Gérer les groupes",
    "groupfolders": "Dossiers",
    "useringroup": "Les membres de groupe peuvent accéder aux dossiers :",
    "agroupnamemin": "Le nom du groupe d'accès ne peut être vide.",
    "agroupnameused": "Le nom du groupe d'accès doit être unique.",
    "agroupnofolders": "Le groupe d'accès contient tous les dossiers.",
    "agroupdirerr": "Echec de la transaction (GROUPDIRFAIL).",
    "fullaccess": "Accès complet",
    "useradderr": "ID Utilisateur utilisé. Veuillez essayer un autre ID.",
    "maxseats": "Utilisation de tous les sièges en lecture/écriture.",
    "readonlyuser": "Siège en Lecture seule",
    "readwriteuser": "Siège en Lecture/Ecriture",
    "readonly": "Lecture Seule",
    "readwrite": "Lecture/Ecriture",
    "adminuser": "Administrateur",
    "logindisabled": "Login désactivé",
    "deleteself": "L'utilisateur actuel ne peut pas être supprimé.",
    "disablecuruser": "Vous ne pouvez pas désactiver votre propre compte.",
    "curusersysadmin": "Le type de siège ne peut pas être changé pour l'utilisateur actuel.",
    "curuserchgid": "L'ID utilisateur de l'utilisateur actuel ne peut pas être changé.",
    "deluserserr": "Echec de la transaction. Veuillez réessayer (USERDELFAIL).",
    "userlisterr": "Echec de la transaction (USERLISTFAIL).",
    "grouplisterr": "Echec de la transaction (GROUPLISTFAIL).",
    "groupupdateerr": "Echec de la transaction (GROUPUPDATEFAIL).",
    "userid": "ID Utilisateur",
    "Email address": "Adresse email",
    "validuserid": "Longueur minimum de 6 caractères pour l'ID Utilisateur.",
    "initialpass": "Mot de passe initial",
    "seatsused": "Sièges en lecture/écriture utilisés disponibles.",
    "iwizautobreakchk": "Découpez automatiquement de grandes pages",
    "Password": "Mot de passe",
    "manageusers": "Gérer les utilisateurs",
    "customcolor": "Personnaliser couleur",
    "enterrgb": "RRVVBB",
    "colorvalmin": "Couleur invalide",
    "hexcolor": "Entrez couleur HEX",
    "fileloaderr2": "Impossible de charger les données",
    "fileloaderr3": "Fichier manquant ou format invalide.",
    "copypuberr": "Impossible de copier la sortie dans le dossier sélectionné. Veuillez réessayer.",
    "copypubfolder": "Enregistrer sur",
    "pubdest": "Sélectionner la destination de publication",
    "savefolder": "Dossier du compte",
    "nofolderselect": "Pas de dossier sélectionné",
    "loaderr9": "Format de photo invalide (convertir vers jpg).",
    "genlayout": "Générer Disposition",
    "perfreport": "Mesure Performance",
    "Output": "Sortie",
    "prefix": "Préfixe",
    "postfix": "Suffixe",
    "percentage": "Pourcentage",
    "thousandssep": "Utiliser séparateur des milliers",
    "oldInternetExplorer": "Internet Explorer 9 détecté. Veuillez monter de version Internet Explorer ou essayer avec Google Chrome.",
    "Lock": "Verrouiller",
    "Locked": "Verrouillé",
    "Persist": "Persister",
    "filelocked": "Vous n'avez pas la permission de modifier ce fichier. Le fichier ou le dossier est verrouillé.",
    "folderlocked": "Vous n'avez pas la permission de renommer ou de supprimer ce dossier.",
    "datarefreshoptions": "Options de rafraîchissement des données",
    "datarefreshinfo": "Mettre à jour l'organigramme actuel en interrogeant de nouveau la source de données.",
    "persistlock": "Ne pas supprimer (pour les cases ajoutées manuellement)",
    "Refresh": "Rafraîchir",
    "savewhat": "Enregistrer quoi",
    "currentbranch": "Branche actuelle",
    "orphanrecords": "Tous les enregistrements déconnectés",
    "moveobj": "Déplacer objet",
    "movebox": "Déplacer case",
    "addsub": "Ajouter subordonné",
    "addassist": "Ajouter assistant",
    "Cut": "Couper",
    "Copy": "Copier",
    "Paste": "Coller",
    "copyformat": "Copier le format",
    "insertbreak": "Ajouter saut de page",
    "removebreak": "Retirer saut de page",
    "branchstyles": "Styles de branche",
    "resizeimage": "Redimension d'image",
    "nousertemps": "Tous les affichages sont appliqués (ou il n'y a aucun affichage définé). Veuillez utiliser le gestionnaire d'affichages pour en créer un nouveau.",
    "textbox": "Case texte",
    "selectboxprop": "Définissez au moins une propriété de case",
    "delviewmsg1": "Êtes-vous sûr de vouloir supprimer les vues sélectionnées ?",
    "viewdeldmsg": "La vue sélectionnée a été supprimée. Veuillez contacter votre administrateur système.",
    "loaderr4c": "est réservé pour un calcul prédéfini. Veuillez changer le nom de champ dans la source de données.",
    "headerrow": "Texte libre 1 col.",
    "headerrow2": "Texte libre 2 col.",
    "useinches": "Afficher les unités en pouces",
    "usemetric": "Afficher les unités en centimètres",
    "successupload": "remonté avec succès",
    "uploadcncl": "Remontée annulée",
    "uploadfail": "Remontée échouée",
    "successrupload": "Remplacé avec succès",
    "uploadfailtoobig": "Remontée abortée - fichier trop lourd",
    "uploadfailfiletype": "Remontée abortée - type de fichier invalide",
    "extrawidem": "Extra large",
    "loaderr2b": "La première ligne du fichier source contient un nom de champ vide.",
    "currentmaster": "Fond actuel",
    "orgprefs": "Préférences",
    "replacefile": "Il y a déjà un fichier portant le même nom dans le dossier actuel. Cliquez OK pour remplacer le fichier.",
    "unlinkerr1": "Supprimer les sauts de sous-organigramme avant délier une branche.",
    "applyingtemplate": "En train d'appliquer l'affichage…",
    "buildinghierarchy": "Création de la hiérarchie...",
    "API": "API",
    "apikey": "Clé API",
    "orgname": "Nom Org",
    "username": "Nom utilisateur",
    "quickstart": ">>> Télécharger le Guide de Démarrage rapide",
    "ReportsToName": "NomDuRapport",
    "SortP": "Trier...",
    "fieldlabel": "Étiquette de champ",
    "sortorder": "Ordre",
    "sortfield": "Champ de tri",
    "Ascending": "Croissant",
    "Descending": "Décroissant",
    "Sort": "Trier",
    "sortselection": "Sélection",
    "sortsubchart": "Page actuelle",
    "sortchart": "Organigramme entier",
    "blankselection": "Impossible de trier. Sélectionnez au moins une case.",
    "applyto": "Appliquer à :",
    "addcoheadscb": "Créer un organigramme avec co-dirigeants",
    "sortboxescb": "Trier les cases après rafraîchissement",
    "levelchartcb": "Créer un organigramme à niveaux",
    "nameinuse": "Nom déjà utilisé ou réservé.",
    "rpadvoptions": "Avancées",
    "refreshmsg": "Les changements seront appliqués au prochain rafraîchissement.",
    "acctexpired": "Login désactivé. Souscription expirée.",
    "advancedoptions": "Options avancées",
    "textwrapchars": "Retour à la ligne",
    "connmsg1": "Envoyer un email à",
    "connmsg2": "pour de l'aide à la configuration des connecteurs.",
    "checkall": "Tout cocher",
    "uncheckall": "Tout décocher",
    "inlist": "dans la liste",
    "notinlist": "pas dans la liste",
    "loaderr2c": "Cocher la colonne",
    "rows": "lignes",
    "authenticating": "Authentification en cours...",
    "preservebs": "Préserver les changements manuels aux styles de branche",
    "preservebo": "Préserver le tri des cases (passe outre le tri après rafraîchissement)",
    "preservesb": "Préserver les changements utilisateur à la pagination (sauts de page)",
    "preserveassist": "Préserver l'identification manuelle des assistants",
    "preservebl": "Préserver les changements manuels des dispositions de case",
    "selectedtemp": "Sélectionner l'affichage d'organigramme",
    "refreshwarning1a": "Avertissement :",
    "refreshwarning1b": "option n'est pas récommandée pour les organigrammes de plus de 100 cases. Veuillez utiliser le formatage conditionnel (les affichages) ou le verrouillage de case.",
    "testauth": "Test d'authentification",
    "privatefolder": "Ajouter un dossier privé",
    "dateformat": "Format de date",
    "scopechart": "Utiliser l'organigramme sommet",
    "scopebranch": "Utiliser la branche sommet",
    "countif": "COMPTERSI",
    "concatenate": "CONCATENER",
    "rightcalc": "DROITE",
    "leftcalc": "GAUCHE",
    "concatblank": "Le texte ne peut pas être vide.",
    "concatmsg": "Entrez le texte et les champs à concaténer. Entourez les champs avec des crochets.",
    "concatmsg2": "Exemple : '[Prénom] [Nom]'",
    "refreshdate": "Date de rafraîchissement",
    "lastrefresh": "Dernier rafraîchissement",
    "lastrefreshdatetime": "{date}, à {time}",
    "entirechartplus": "Organigramme entier (étendu)",
    "redeployed": "Redéployé seulement",
    "refcirc": "Référence circulaire",
    "invaliddate": "INVALIDE",
    "appenddata": "Ajouter des données",
    "topboxcb": "Spécifier la case sommet",
    "entertopbox": "Entrez une virgule pour des listes séparées d'identifiants",
    "topboxmin": "L'identifiant de la case sommet ne peut pas être vide.",
    "DOCUMENT": "Document",
    "Launch": "Lancer",
    "Access": "Accéder",
    "Scheduler": "Planifier",
    "enablesched": "Rafraîchit automatiquement l'organigramme",
    "frequency": "Fréquence",
    "Daily": "Jour",
    "Weekly": "Semaine",
    "Bi-Weekly": "Bimensuel",
    "Quarterly": "Trimestriel",
    "Annually": "Annuel",
    "First Day": "Premier jour",
    "Last Day": "Dernier jour",
    "gmttime": "Heure (GMT)",
    "dayofweek": "Jour",
    "emailnote": "Notification par email",
    "emailtxt": "Entrez une liste séparée par des virgules",
    "schedulerna": "Le planificateur n'est pas disponible pour les comptes de démo.",
    "lookup": "RECHERCHER",
    "lookupmsg": "Rechercher une valeur à partir d'un autre enregistrement.",
    "LookupField": "Clé de recherche :",
    "LookupValue": "Résultat de recherche :",
    "fieldblank": "Sélectionnez les champs de recherche.",
    "Monday": "Lundi",
    "Tuesday": "Mardi",
    "Wednesday": "Mercredi",
    "Thursday": "Jeudi",
    "Friday": "Vendredi",
    "Saturday": "Samedi",
    "Sunday": "Dimanche",
    "autoopenlogin": "Après connexion :",
    "noautoopen": "Ne prendre aucune action",
    "autoopen": "Ouvrir automatiquement un organigramme spécifié",
    "autoopencur": "Ouvrir automatiquement l'organigramme actuel",
    "genreport": "Générer un Rapport de diagnostic",
    "leftblank": "La valeur ne peut être vide.",
    "fieldblank2": "Sélectionnez un champ.",
    "accesserr1": "Vous n'avez pas la permission d'ouvrir ce fichier.",
    "leftmsg": "Renvoie des caractères à partir de la GAUCHE.",
    "rightmsg": "Renvoie des caractères à partir de la DROITE.",
    "commit": "Valider",
    "accessprivs": "Privilèges d'accès",
    "restrictaccess": "Restreindre l'accès au document actuel",
    "uploadaccess": "Remonter nouveaux droits",
    "downloadaccess": "Télécharger droits actuels",
    "validaccesspriv": "Droits d'accès chargés avec succès.",
    "invalidaccesspriv1": "Erreur - fichier vide.",
    "invalidaccesspriv2": "Erreur - vérifiez la ligne :",
    "invalidaccesspriv3": "Erreur - entête invalide.",
    "solidfill": "Remplissage Solide",
    "gradientfill": "Remplissage Dégradé",
    "Gradient": "Dégradé",
    "Linear Gradient": "Dégradé Linéaire",
    "Radial Gradient": "Dégradé Radial",
    "dashline": "Ligne pointillée",
    "triangle": "Triangle",
    "solidborder": "Bordure pleine",
    "dashedborder": "Bordure pointillée",
    "solidline": "Ligne pleine",
    "dashedline": "Ligne pointillée",
    "iwizselectSAPmsg1": "L'Assistant d'Import crée automatiquement un organigramme à partir d'un fichier SAP XML.",
    "iwizselectSAPmsg2": "Veuillez contacter le Support technique pour l'assistance dans l'export des données à partir de votre système SAP.",
    "iwizselectSAPmsg3": "Tous les fichiers de données doivent être remontés vers votre compte d'espace de stockage avant qu'ils puissent être utilisés.",
    "iwizselectSAPmsg4": "Cliquez sur le bouton 'Importer données' pour importer un fichier à partir de votre espace de stockage.",
    "combinerecords": "Sous-groupe par un champ",
    "filemgr": "Fichiers",
    "sum": "SOMME",
    "average": "MOYENNE",
    "summsg": "Sélectionnez un champ pour la somme.",
    "averagemsg": "Sélectionnez un champ pour la moyenne.",
    "adjboxmarg": "Ajuster les marges de case",
    "adjboxspace": "Ajuster l'Espace de case",
    "adjboxsubs": "Ajuster l'Espacement des subordonnés",
    "enterval": "Entrez une valeur",
    "selectimportsapfile": "Sélectionnez un fichier SAP XML à importer",
    "Unzip": "Désipper",
    "createxml": "Création du XML...",
    "renderpdf": "Interprétation de la page",
    "deleteallmsg": "Êtes-vous sûr de vouloir supprimer tous les fichiers dans ce dossier ?",
    "deleteallpermmsg": "Êtes-vous sûr de vouloir supprimer définitivement {fileCount} fichiers dans le dossier corbeille ?",
    "deleteall": "Supprimer tous les fichiers",
    "unziperr": "Incapable de dézipper le fichier. Vérifiez le fichier ZIP et réessayez.",
    "unzipping": "Dézippage...",
    "clearprops": "Nettoyer les propriétés",
    "twocolortri": "Triangle à deux couleurs",
    "setcolor": "Couleur",
    "setlabel": "Étiquette",
    "setdashed": "Pointillé",
    "worker": "Employé (Workforce Now)",
    "workerdemo": "Démographie des Employés (Vantage)",
    "branchstyleerr1": "Style de branch sélectionné non permis.",
    "branchstyleerr2": "Un minimum de 2 cases doit être sélectionné.",
    "branchstyleerr3": "Sélection invalide. Toutes les cases sélectionnées doivent avoir le même responsable.",
    "branchstyleerr4": "Sélection invalide. Ruptures de sous-organigramme non permises.",
    "hideline": "Cacher",
    "moreoptions": "Plus d'options...",
    "linegroup": "Groupe de ligne",
    "linesubgroup": "Sous-groupe de ligne",
    "clearsubgroup": "Effacer le sous-groupe",
    "nomask": "Pas de masque",
    "cirmask": "Masque circulaire",
    "map": "MAPPE",
    "mapmsg": "Entrez la correspondance.",
    "mapmsg2": "Exemple :'94121':'Richmond','94122':'Sunset'",
    "comparedirs": "Comparer des Dossiers",
    "compare": "Comparer",
    "comgr": "Co-Resp",
    "createcomgr": "Créer un groupe de co-responsables",
    "removecomgr": "Supprimer un groupe de co-responsables",
    "selectfolder": "Sélectionner un dossier",
    "addboxerr1": "Ajout invalide. Descendez pour ajouter une case.",
    "addboxerr2": "Ajout invalide. Ajoutez au premier membre du groupe de co-responsable.",
    "math": "MATH",
    "mathmsg": "Entrez un calcul. Mettez les champs entre crochets.",
    "mathmsg2": "Exemple : '[ChampA]/[ChampB]*100'",
    "enableexporte": "Autoriser l'export vers Excel",
    "piccache": "Recharger les photos des employés",
    "complexpass": "Exige des mots de passe complexes",
    "forcepass": "Forcer le changement de mot de passe",
    "smspass": "SMS pour la récupération du mot de passe",
    "assistwiz1": "Définissez les styles de branche assistant à partir de règles ou des données.",
    "stdassistantrule": "Utilisez les règles pour identifier les assistants standards",
    "peerassistantrule": "Utilisez une règle pour identifier les assistants voisins",
    "assistonleft": "Placez d'abord l'assistant sur la gauche du responsable",
    "optimizebranch": "Optimisez les styles de branche",
    "allowsort": "Trier les cases pour économiser de l'espace",
    "prefstyle": "Style préféré",
    "tree": "Une ligne",
    "twocolumn": "Deux colonnes",
    "fourcolumn": "Quatre colonnes",
    "Optimize": "Optimisez",
    "treesingles": "Utilisez le style une colonne pour les uniques",
    "assistrulemanual": "Définissez manuellement les styles de branche assistant",
    "assistrulefield": "Utilisez le champ 'isAssistant' pour définir les styles de branche assistant",
    "assistruledef": "Utilisez des règles pour définir les styles de branche assistant",
    "assistwiz": "Assistant",
    "passmsg": "Le mot de passe doit avoir une longueur minimum",
    "passmsg2": " caractères et contient un chiffre, une lettre majuscule, et un caractère spécial (!#@*+?).",
    "newpassinvalid": "Le nouveau mot de passe est invalide.",
    "resetpass": "Veuillez réinitialiser le mot de passe.",
    "photoqueue": "Chargement des photos",
    "logintoomany": "Trop de tentatives de connexion. Le compte est bloqué pendant 5 minutes.",
    "passexpired": "Le mot de passe a expiré. Utilisez le lien Mot de passe oublié pour réinitialiser.",
    "rpassistwiz": "Assistants",
    "mobile": "Mobile (Facultatif)",
    "optbs": "Optimiser les styles de branche",
    "optimizeall": "Optimiser toutes les pages",
    "interactive": "Mode interactif",
    "Field Properties": "Propriétés de champ",
    "optpage": "Optimiser la page",
    "showscnum": "Afficher page #",
    "Complex Rule": "Règle complexe",
    "deffilter": "Editer la règle...",
    "enterrule": "Entrez la règle",
    "testrule": "Tester la règle",
    "testmath": "Tester Math",
    "rulevalid": "Règle valide.",
    "mathvalid": "Math valide.",
    "countifdesc": "Compter si l'enregistrement correspond au critère défini.",
    "rightleftmsg": "Entrez # ou un caractère de saut",
    "Utilities": "Utilitaires",
    "Missing": "Manquant(e)s",
    "selectfieldprop": "Sélectionner un champ et au moins une propriété de champ",
    "optimizing": "Optimisation...",
    "outwhat": "Sortir quoi",
    "renamesinglesc": "Renommer la sélection",
    "renameallsc": "Tout renommer",
    "searchdir": "Rechercher",
    "sysadmin": "Admin System",
    "comparecurfile": "Sélectionner la comparaison de fichiers",
    "action": "Action",
    "Link Type": "Type de lien",
    "Email": "Email",
    "skype": "Skype",
    "phone": "portable",
    "file2": "Fichier",
    "docopy": "Copier texte",
    "doemail": "Envoyer Email",
    "docall": "Appeler Téléphone",
    "doskype": "Appeler Skype",
    "dohyperlink": "Ouvrir Hyperlien",
    "dofile": "Ouvrir Fichier",
    "notlinked": "-",
    "splitaltkey": "Touche alternative",
    "xmlformat": "Format XML",
    "pdftype": "PDF",
    "ppttype": "PPT",
    "boxcount": "Comptage de cases",
    "seatcount": "Comptage de sièges :",
    "status": "Statut :",
    "userlookup": "Recherche d'utilisateur :",
    "LookupU": "Recherche",
    "LookupR": "Résultat de recherche",
    "trialstart": "Début d'essai :",
    "invaliddatemsg": "Date invalide",
    "triallen": "Durée de l'essai (jours) :",
    "orginfo": "Information du compte mise à jour avec succès.",
    "userinfo": "Information de l'utilisateur mise à jour avec succès. Les changements sont appliqués à la prochaine connexion.",
    "missingmissing": "Le répertoire photos ne contient pas le fichier 'missing.jpg'.",
    "English": "Anglais",
    "French": "Français",
    "Spanish": "Espanol",
    "German": "Deutsch",
    "SI": "SI",
    "selbranchstyle": "Sélectionner un style de branche",
    "separator": "Séparateur",
    "howto": "Comment ?",
    "spacingmode": "Sélectionner l'espace de case",
    "reloadusers": "Recharger",
    "expiredate": "Date d'expiration :",
    "serverinfo": "Server information :",
    "svrsummary": "Rapport du Locataire",
    "limitfields": "Restreindre la requête aux champs",
    "freetrial4a": "vous permet de créer des organigrammes directement à partir de ADP Workforce Now ou Vantage.",
    "quickstarta": ">>> Définir votre connexion ADP <<<",
    "quickstartb": ">>> Ouvrir le Guide de Démarrage rapide <<<",
    "ufuserfeed": "Dossier UserFeed",
    "ufsystem": "Dossier Système",
    "RestrictP": "Restreindre...",
    "restrictblank": "La liste ne peut pas être vide",
    "retrievingkey": "Récupération des clés...",
    "restrictcb": "Restreindre la requête",
    "accounttype": "Type de compte :",
    "source": "Source :",
    "connector": "Connecteur :",
    "channel": "Canal :",
    "country": "Pays :",
    "startdate": "Date de début :",
    "keycontact": "Contact principal :",
    "contactemail": "Contact email :",
    "notes": "Notes :",
    "sapouoptions": "Options des organigrammes SAP OrgUnit",
    "sapoption1": "Convertir de Position à Position",
    "sapoption2": "Combiner OrgUnits et les Positions de Chef",
    "sapoption3": "Séparer OrgUnits et Positions",
    "max": "MAX",
    "min": "MIN",
    "maxmsg": "Sélectionner le champ pour la fonction max.",
    "minmsg": "Sélectionner le champ pour la fonction min.",
    "loadingpages": "Chargement de la page",
    "generatepdf": "Chargement du PDF",
    "downexcel": "Préparation de Excel...",
    "reload": "Recharger",
    "enableaccesslist": "Activer la sécurité au niveau enregistrement",
    "dynloading": "Construction de l'organigramme...",
    "term": "Terme :",
    "deployment": "Déploiement :",
    "orginfo2": "Info org :",
    "userinfo2": "Info utilisateur :",
    "accountdetails": "Détails du compte mis à jour avec succès.",
    "acctdetails": "Details de compte",
    "section508": "Section 508",
    "excelsubs": "Subordonnés",
    "ruledriven": "Organigramme piloté par les règles (les changements de présentation manuels ne sont pas persistants)",
    "scalingOptions": "Mise à l'échelle",
    "scaleh": "Hauteur de l'échelle %",
    "scalew": "Largeur de l'échelle %",
    "maintainaspect": "Verrouiller le ratio d'aspect",
    "Set Aspect Ratio": "Configurer le ratio d'aspect",
    "freeaspect": "Déverrouiller le ratio d'aspect",
    "scalehorz": "Mettre à l'échelle pour remplir la page (horizontal)",
    "scalevert": "Mettre à l'échelle pour remplir la page (vertical)",
    "scalefill": "Mettre à l'échelle pour remplir toute la page",
    "setposition": "Position à gauche",
    "workerrun": "ADP RUN",
    "excelmgr": "Responsable",
    "querydata": "Requête",
    "Branch Style": "Styles de branche",
    "alllevels": "Tous les niveaux",
    "setascomgr": "Co-responsables",
    "createppt": "Création du PPT...",
    "generateppt": "Téléchargement du PPT",
    "outoptions": "Taille de la diapositive",
    "standardppt": "Standard (4:3)",
    "widescreenppt": "Large (16:9)",
    "publimit1": "Êtes-vous sûr de vouloir publier",
    "publimit2": "pages ?",
    "retrieveuser": "Récupérer le nom d'utilisateur",
    "enabledittemp1": "Actualiser les affichages d'organigramme et les styles de case",
    "enabledittemp2": "styles de branche",
    "orgchartbuild": "Builder OrgChart",
    "querybuildsetuperr": "Le Builder OrgChart n'est pas configuré. Contactez le Support technique pour les étapes suivantes.",
    "querybuilddataerr": "Impossible de charger votre organigramme. ",
    "queryoptions": "Rechercher la position ciblé",
    "displayoptions": "Options d'affichage",
    "filteroptions": "Options de filtre",
    "subchartoptions": "Insérer des ruptures de page",
    "Page size": "Taille de page",
    "pagebreaks": "Ruptures de page",
    "singlepage": "Organigramme sur une seule page",
    "multipage": "Insérer des ruptures de page",
    "queryresults": "Position cible",
    "queryblank": "Pas de cible spécifiée",
    "f_name": "Prénom",
    "l_name": "Nom",
    "s_title": "Titre",
    "noqueryresults": "La requête ne correspond à aucun enregistrement.",
    "unknownqerr": "Erreur inconnue. Contactez le Support technique si le problème persiste.",
    "querytoomanyresults": "Trop d'enregistrements retournés.",
    "includelevels": "Inclure",
    "buildchart": "Aller",
    "None": "Aucun",
    "hidemaster": "Cacher les éléments de fond",
    "customexcel": "Personnaliser...",
    "dynmsg1": "[1] récupération des données...",
    "dynmsg2": "[2] traitement des données...",
    "dynmsg3": "[3] construction de l'organigramme...",
    "Session Timeout": "Session expirée",
    "reloadpic": "Recharger les photos",
    "lefttriangle": "Triangle à gauche",
    "printpdf": "Optimiser pour impression",
    "screenpdf": "Optimiser pour écran",
    "excludebackgrnd": "Arrière-plan blanc",
    "chainofcommand": "Chaîne de commande",
    "leftassist": "Assistant à gauche",
    "rightassist": "Assistant à droite",
    "leftpassist": "Assistant collègue à gauche",
    "rightpassist": "Assistant collègue à droite",
    "passreuse": "Le mot de passe ne peut pas être réutilisé.",
    "querytoomanyresults4": "La limite d'un organigramme sur une seule page est dépassée.",
    "querytoomanyresults3": "La taille maximale pour un organigramme est dépassée.",
    "svrchart": "Mon Organigramme",
    "PLAN": "PLANIFIER",
    "wplan": "Planification du Personnel",
    "wplantools": "Outils de Planification",
    "Manage": "Gérer",
    "includefiltered": "Inclure les responsables filtrés",
    "merge": "Fusionner",
    "Track": "Suivre",
    "tmoved": "Case déplacée",
    "tadded": "Case ajoutée",
    "tdelete": "Case supprimée",
    "tupdated": "Case mise à jour",
    "tmoveupdate": "Case déplacée & mise à jour",
    "webpublish": "Publication web",
    "freetrial4b": "Appeler le +33 1 72 69 01 82 pour une assistance ou pour planifier une démonstration.",
    "quickstartc": ">>> Nous écrire pour toutes questions",
    "adphelpemail": "Assistance pour une Connexion d'Evaluation ADP",
    "servercharterr": "La fonction Mon Organigramme n'est pas configurée. Contactez le Support technique pour les étapes suivantes.",
    "serverqueryerr": "La recherche a échoué. Contactez le Support technique si ce problème persiste.",
    "searching": "En cours de recherche...",
    "pagelimit": "La recherche a dépassé la limite !",
    "mergecurfile": "Selectionnez le fichier à fusionner",
    "applymaster": "Appliquer le fond",
    "orgname2": "Nom légal",
    "usersummary": "Report Utilisateur",
    "pngstdquality": "Qualité standard",
    "pnghiquality": "Haute qualité",
    "validated": "Validé",
    "testlink": "Tester le lien",
    "TestLinkTokenError": "Impossible de tester ce lien pour le moment. Veuillez réessayer.",
    "genlink": "Générer le lien",
    "copylink": "Copier lien",
    "publiclink": "Lien public",
    "privatelink": "Lien privé",
    "restrictedlink": "Lien restreint",
    "onlaunch": "A lancer :",
    "takenoaction": "Ne prendre aucune action",
    "openmychart": "Ouvrir 'Mon Organigramme",
    "portal": "Portail",
    "iframe": "iFrame",
    "presentation": "Présentation",
    "showprofpanel": "Afficher le panneau profil",
    "showscpanel": "Afficher le panneau sous-organigrammes",
    "enablemw": "Activer la roulette de la souris",
    "startpoint": "Point de départ",
    "Additional parameters": "Paramètres supplémentaires",
    "togglesaml": "Activer le lien SAML",
    "entityid": "ID Entité :",
    "Result": "Résultat",
    "confidential": "Confidentiel - Usasge interne seulement",
    "orgchart": "OrgChart",
    "croptochart": "Rogner à l'organigramme",
    "transbk": "Arrière-plan transparent",
    "Filters": "Filtres",
    "stayconnected": "Rester connecté",
    "commalerts": "Alertes",
    "ReleaseNotesLink": "Sorties",
    "Newsletters": "Nouvelles",
    "onCommSet": "Informez-moi des sorties, des changements, et des nouveautés OrgChart",
    "offCommSet": "Ne m'imformez pas de sorties, ni de changements, ni de nouveautés OrgChart.",
    "commDialogueMessage": "Préférence de notifications par email",
    "autobreaks": "Sauts automatiques",
    "sumif": "SOMMESI",
    "averageif": "MOYENNESI",
    "sumifdesc": "Additionner seulement si l'enregistrement correspond au critère défini.",
    "averageifdesc": "Calculer la moyenne seulement si l'enregistrement correspond au critère défini.",
    "pagedensity": "Densité de page :",
    "pagedense": "Dense",
    "pagestandard": "Standard",
    "pageverydense": "Très dense",
    "testpanel": "Panneau de Test",
    "dirtyfilter": "Organigramme modifié par l'utilisateur. Annuler les changements ?",
    "domgraction": "Actions du responsable",
    "doprofile": "Profil employé",
    "usage": "Usage :",
    "ActivityR": "Rapport d'activité",
    "Actions": "Actions",
    "includebkgrndcolor": "Définir la couleur de l'arrière-plan",
    "adpadvopt": "Profil ADP.",
    "adprefropt": "Profil ADP sélectionné :",
    "iwizselectAPDmsg1": "L'assistant d'import créé automatiquement un organigramme en utilisant une connexion directe vers votre compte ADP Workforce ou votre compte ADP Vantage.",
    "iwizselectAPDmsg2": "Cliquez sur le '?' pour obtenir des informations concernant la configuration de votre connexion ADP.",
    "defsubfilter": "Créez des règles de subordination...",
    "valueSelect": "Sélectionnez",
    "fieldSelect": "Sélectionnez un champ",
    "addval": "Ajoutez valeur",
    "selectadpprofile": "Importer des données d'ADP",
    "noFilterName": "Veuillez renseigner un nom de filtre.",
    "refreshtime": "Mettez à jour l'heure et le jour",
    "profloaderr": "Le chargement de votre profil a échoué. Veuillez réessayer.",
    "profsaveerr": "La création de votre profil a échoué. Veuillez réessayer.",
    "profload": "Profil chargé.",
    "profsave": "Profil enregistré.",
    "delfltrwmsg1": "Êtes-vous sûr de vouloir supprimer le filtre sélectionné ?",
    "enablelimitaccess": "Activer la niveau de la succursale",
    "Recent Target Positions": "Positions les plus récentes",
    "savingprofile": "Profil en cours de sauvegarde...",
    "loadingprofile": "Profil en cours de chargement...",
    "aboxcount": "Nombre de cases calculées acceptées :",
    "sysutilities": "Outils :",
    "source2": "Sélectionnez la source de données",
    "edition": "Version :",
    "notSelected": "Veuillez sélectionner une source.",
    "profilesavepanel": "Enregistrer le profil",
    "sandboxupdate": "Votre compte sandbox a été réinitialisé avec succès.",
    "sandboxtool": "Compte Sandbox :",
    "expirytool": "Rapport d'abonnement :",
    "expirybutton": "Télécharger",
    "saveconf": "Êtes-vous sûr de vouloir quitter ? Tous vos changements non enregistrés seront perdus.",
    "benchtoviewer": "Viewer",
    "Shortcuts": "Raccourcis",
    "tab": "Onglet initial :",
    "enablefilemgr": "Activer le gestionnaire de fichiers",
    "enableexcel": "Activer l'export en format excel",
    "enablepublish": "Activer la publication",
    "More": "Plus",
    "newchart": "Nouvel organigramme",
    "Dynamic Navigation": "Flèches de navigation",
    "Background Publish": "Publication de fond",
    "Zoom": "Zoom",
    "zoom": "Zoom",
    "OrgChart Workbench": "OrgChart Workbench",
    "Open Existing Chart": "Ouvrir l'organigramme existant",
    "Default Template": "L'affichage par défaut",
    "Theme": "Thème",
    "Measurements": "Mesures",
    "Enable Right-Click": "Activer le click droit",
    "Mouse wheel": "Roulette de la souris",
    "More Options": "Plus d'options",
    "Fit to Screen": "Ajustez à l'écran",
    "Size": "Taille",
    "Include Master": "Inclure le fond",
    "Size for Printing": "Taille pour imprimer",
    "Scope": "Périmètre",
    "Show fields": "Montrer les champs",
    "showvalues": "Montrer les valeurs",
    "Default view": "Vue par défaut",
    "Support": "Assistance",
    "View": "Visualiser",
    "Help Resources": "Aide",
    "Terms of Service": "Conditions d'utilisations",
    "paywalldropdown": "Surclassez afin de débloquer-Les fonctionnalités Premium",
    "paywallhover": "Fonctionnalité Premium",
    "moreviews": "Contrôlez les accès...",
    "Manage Profile": "Gérez le Profil",
    "Manage Filters": "Gérez les filtres",
    "Chart Background": "Arrière-plan de l'organigramme",
    "Print Current Screen": "Imprimer l'écran actuel",
    "Off": "Désactivé",
    "vscroll": "Faire défiler (Haut/Bas)",
    "hscroll": "Faire défiler (droite/gauche)",
    "function": "Fonction",
    "supportfunction": "Fonction de support",
    "placeholdercb": "Organigramme fonctionnel",
    "filterinvalid": "Règle de filtrage invalide",
    "filtervalid": "Règle de filtrage valide",
    "valuedefvalid": "La valeur du champ est valide",
    "valuedefinvalid": "La valeur du champ est invalide : le champs n'existe pas.",
    "upgradepremiumemail": "Surclassez OrgChart vers la version Premium",
    "ADPKeyFailure": "La récupération des clés ADP a échouée. Veuillez vérifier que la permission vous a été accordée par ADP marketplace",
    "isolvedKeyFailure": "Aucune donnée d'employé isolved n'est encore disponible. Vous devrez peut-être attendre votre prochaine synchronisation des employés. Contactez l'assistance si le problème se reproduit.",
    "Print Preview": "Aperçu avant impression",
    "resettocheckpoint": "Restaurez votre point de contrôle",
    "Type": "Type",
    "Advanced Search Keys": "Champs de Recherche Avancée",
    "Search record": "Recherche d'enregistrement",
    "Mapping": "mappage",
    "Configuration Settings": "Paramètres de configuration",
    "Configuration": "Configuration",
    "CSVRefreshFailure": "Le fichier CSV n'a pu être chargé. Veuillez vérifier que le fichier est associé au bon emplacement.",
    "autoposition": "Démarrez avec votre propre organigramme",
    "setChartDefault": "Définir cet organigramme en tant qu'organigramme par défaut",
    "dumpMetadata": "Créer un nouveau point de contrôle",
    "loadMetadata": "Charger un point de contrôle",
    "Add Access Group": "Ajouter un groupe",
    "Login mode": "Mode de connexion",
    "Launch Workbench": "Plan de travail OrgChart",
    "RefreshConfirm": "Êtes-vous sûr de vouloir mettre à jour cet organigramme à partir de la source de données ?",
    "language": "Langue",
    "AddNewChartDBConfig": "Voulez-vous ajouter de nouveaux organigrammes à partir de votre base de données ?",
    "deleteChart": "Supprimer cet organigramme",
    "deleteConfirm": "Êtes-vous sûr de vouloir supprimer cet organigramme ?",
    "My Settings": "Mes paramètres",
    "Chart Settings": "Paramètres d'organigramme",
    "Account Settings": "Paramètres du compte",
    "Time Format": "Format horaire",
    "Chart Builder Masters": "Fonds de chart builder",
    "Chart Info": "À propos",
    "Current Screen": "Écran actuel",
    "Alert": "Alerte",
    "Chart Template Missing": "L'affichage sélectionné est manquant. Veuillez contacter votre administrateur.",
    "Checkpoints": "Points de contrôle",
    "refreshdata": "Rafraîchir les données",
    "Chart Builder": "Constructeur d'organigramme",
    "paywalldropdownGeneral": "Fonctions Premium-Non Activèes",
    "Security": "Sécurité",
    "Data Refresh Successful!": "Actualisation des données réussie !",
    "7029": "L'action n'est pas disponible. Veuillez rafraîchir votre navigateur, ou contacter l'équipe support si le problème persiste",
    "2016": "Le pré-processeur n'a pas fonctionné",
    "0503": "Le consentement du client n'est pas disponible. Veuillez contacter votre interlocuteur ADP",
    "0429": "Il y a trop de requêtes en même temps. Veuillez réessayer dans quelques minutes",
    "0400": "L'API a renvoyé une erreur d'autorisation ou d'authentification. Vérifiez vos paramètres de connexion.",
    "Refreshing": "Actualisation",
    "Get started with OrgChart Premium!": "Commencer avec OrgChart Premium!",
    "basicROPaywall": `Votre rôle ADP ne vous permet pas d'effectuer des achats sur ADP Marketplace. Pour effectuer un achat, contactez votre administrateur ADP Workforce Now. Pour plus d'informations, envoyez un e-mail à ${supportEmailaddr} ou appelez le 1.415.462.1313.`,
    "basicAdminPaywall": `Pour acheter OrgChart Premium, visitez ADP Marketplace ou, pour plus d'informations, envoyez un e-mail à ${supportEmailaddr} ou appelez le 1.415.462.1313.`,
    "basicPaywallExcl": `OrgChart Premium n'est pas encore disponible dans votre région. Pour plus d'informations, envoyez un e-mail à ${supportEmailaddr} ou appelez le 1.415.462.1313.`,
    "basicPaywallLegacy": `Vous êtes déjà abonné à une ancienne version d'OrgChart. Envoyez un e-mail à ${supportEmailaddr} ou appelez le 1.415.462.1313 pour passer à OrgChart Premium.`,
    "group": "Groupe",
    "selectpersonid": "Saisissez l'identifiant de la personne",
    "concatinvalid": "Règle invalide",
    "validmongouserid": "La longueur minimale de l'ID utilisateur est de 3 caractères.",
    "invalidrange": "Plage de date invalide",
    "Container": "Conteneur",
    "Enterit": "Saisir",
    "createuiprofile": "Nouveau profil UI",
    "scarrowstyles": "Style de flèches pour les sous-organigrammes",
    "Set Font Color": "Changer la couleur de la police",
    "mymap": "Ma carte",
    "Include Active on Leave": "Inclure les actifs absents",
    "occtext": "Titre de poste",
    "canEditTemps": "Modifier les affichages et les styles de case",
    "Load": "Charger",
    "archivefail": "Échec de la requête sur cette archive",
    "exportnotfound": "Archive introuvable pour la date indiquée.",
    "exportfailure": "Échec de l'exportation de l'archive",
    "exportfullaccessonly": "L'exportation de l'archive est réservée aux utilisateurs disposant d'un accès complet à cet organigramme.",
    "Grid": "Grille",
    "appinfo": "Informations sur l'application",
    "Filters Applied": "Filtres appliqués",
    "uiprofile": "Nom du profil",
    "adpoid": "OID ADP",
    "Box Shape": "Forme de la case",
    "Formula": "Formule",
    "ADPKeyFailurePremium": "OrgChart a besoin de votre consentement avant d'importer les données RH. Cliquez sur le lien ci-dessous pour donner votre consentement. Après avoir donner votre consentement, merci de cliquer sur le bouton réessayer pour commencer l'utilisation d'OrgChart.",
    "buildpit": "Construire des archives",
    "Filter values": "Filtrer des valeurs",
    "Point In Time": "Archive",
    "Point in time": "Archive",
    "containstext": "Saisir Texte",
    "copymessage": "Copié",
    "onecolCR": "Une colonne centrée droit",
    "shape": "Forme",
    "adminuser2": "Admin",
    "filemgrfolder": "Dossier",
    "Fields & Formulas": "Champs & formules",
    "customFontCmd": "Nom de la police",
    "Set Fill Color": "Définir la couleur de la police",
    "nosearchresults": "Aucune donnée ne correspond à votre recherche",
    "Link": "Lien",
    "dataresetinprogress": "Réinitialiser la donnée",
    "deltaconfig": "Notifications de Delta Report",
    "Select a date range for your report": "Sélectionnez une plage de dates pour votre rapport",
    "automatic": "Automatique",
    "Authentication": "Authentification",
    "Applied From": "Appliqué de",
    "Load Charts": "Charger des organigrammes",
    "Never": "Jamais",
    "defaultchartlevels": "Niveau par défaut",
    "Fields Included": "Champs inclus",
    "generalchartbuilder": "Paramétres généraux du Chart Builder",
    "Presentation Options": "Présentation",
    "UI Colors": "Couleurs de l'UI",
    "expiredSession": "La session est expirée. Veuillez essayer de vous connecter à nouveau.",
    "usertype": "Type d'utilisateur",
    "ssofail": "La SSO a échoué. Cliquez ici pour plus d'informations",
    "General": "Générale",
    "enterhighlight": "Saisissez la règle de surbrillance ici",
    "mrbprops": "Propriétés du groupe",
    "AddNew": "Ajouter nouveau",
    "Chart Name": "Titre de l'organigramme",
    "Company Name": "Nom de l'entreprise",
    "Highlight": "Surbrillance",
    "highlight": "surbrillance",
    "Browser": "Navigateur",
    "addfields": "Ajouter champs",
    "savescheduler": "Vous devez enregistrer cette organigramme avant de permettre la planification du rafrachissement",
    "Highlights": "Surbrillances",
    "viewerdatafilters": "Importer des filtres",
    "configerror": "Erreur de configuration",
    "CopyChartDBConfig": "Voulez-vous copier une configuration d'organigramme existante ?",
    "unitID": "ID de l'Org Unit",
    "Levels Shown": "Niveaux apparents",
    "invalidconcatfield": "Règle invalide. Une ou plusieurs références n'ont pas été trouvés",
    "Too many matches Expand your search to narrow the results": "Trop de correspondances. Affinez votre recherche.",
    "Box Sorting": "Tri des cases",
    "Border Color": "Couleurs des bords",
    "Headers": "Titres",
    "using": "utilisant",
    "archivenotfound": "Pas d'archive exisrante pour la date indiquée.",
    "deltafailure": "Échec de la génération du rapport delta",
    "Basic Math": "Calcul",
    "resetcharts": "Vide",
    "Self": "Sélection seulement",
    "Description": "Description",
    "selectsupervisorid": "Saisissez l'ID du responsable",
    "Calculation": "Calculs en cours",
    "reenteremailviewer": "La longueur minimale pour i'email est de 4 caractères",
    "Launch File": "Lancer document",
    "acctdetails2": "Détails du compte",
    "return": "Retour",
    "Format": "Format",
    "Master Page": "Fond",
    "allgroups": "Toutes les cases regroupées",
    "Hide Field": "Cacher champ",
    "seed": "Référence",
    "clocktime": "24 heures horloge",
    "launchto": "Lancer vers",
    "folderempty": "Ce dossier est vide",
    "Border Style": "Style des bordures",
    "filterinuse": "Filtre sur les noms déjà utilisé",
    "nofoldersexist": "Pas de dossiers existants",
    "rowsecnocharts": "Aucun organigramme n'a été ajouté. Ajouter un organigramme pour commencer la configuration des règles de sécurité.",
    "dataoptions": "Options des données",
    "dataresetconfirm": "Êtes-vous sûr de vouloir réinitialiser les données de l'organigramme ? Tous changements faits avant ce checkpoint seront perdus",
    "Predefined": "Prédéfini",
    "grouptype3": "Groupe co-managé",
    "GroupName": "Groupe",
    "Values": "Valeurs",
    "formulaerrnoname": "Le nom ne peut être vide",
    "OrgID": "ID de l'organigramme",
    "seattype": "Type d'utilisateur",
    "Merge Data": "Fusionner des données",
    "UserID": "ID de l'utilisateur",
    "Archived Charts": "Archives",
    "copyall": "Tous",
    "on": "Actif",
    "accessgroups": "Groupe d'accès",
    "loadeddate": "Les archives actuellement chargées",
    "invalidaccountdate": "Le format de la date est invalide. Merci d'utiliser le format 'yyyy-mm-dd'",
    "Input": "Saisissez",
    "Application": "Application",
    "Search & Directory": "Recherche & Répertoire",
    "SecurityRules": "Règles de sécurité",
    "users": "utilisateurs",
    "addfolders": "Ajouter dossiers",
    "Filter": "Filtrer",
    "allowallfolders": "Click (+) pour permettre l'accès au dossier",
    "Groups": "Groupes",
    "uploadinprogress": "Document en chargement",
    "Limit to single row": "Limiter à une seule ligne",
    "You do not have permission to view this chart": "Vous n'avez pas la permission de voir cet organigramme",
    "Group Configuration": "Configuration des groupes d'accès",
    "Branch Security": "Sécurité des branches",
    "downloadprep": "Préparation du téléchargement",
    "Auto Apply": "Appliquer automatiquement",
    "Operations": "Opérations",
    "Fast Select": "Sélection rapide",
    "LookUp": "Chercher",
    "defaultgroupname": "Saisissez le titre du groupe",
    "Limit Fields": "Restreindre les requêtes vers les champs",
    "Condition": "Condition",
    "Checkpoint": "Point de contrôle",
    "noitems": "Aucune correspondance trouvée.",
    "copymessage2": "Vers le presse-papier",
    "noemailwarning": "Attention ! Un e-mail est nécessaire pour se connecter. Êtes-vous sûr de vouloir enregistrer les modifications ?",
    "boxlimit": "Limite des cases:",
    "Lookup": "Recherche après",
    "Rule Configuration": "Configuration de la règle :",
    "Saved Filters": "Filtres enregistrés",
    "Additional fields": "Champs additionnels",
    "Concatenate": "Concatener",
    "Container Box Style": "Conteneur style de case",
    "enterfilter": "Saisissez la règle de filtrage ici",
    "Author": "Auteur",
    "No Rule": "Pas de règle",
    "Find": "Trouver",
    "Background": "Arrière-plan",
    "about": "À propos",
    "usernameupdatefail": "Impossible de changer le username de cet utilisateur",
    "alternatetitle": "Titre alternatif",
    "highlightinuse": "Mettre en surbrillance le nom dèja utilisé",
    "ats": "ATS :",
    "selectuser": "Saisissez le service de l'utilsiateur",
    "totalusers": "Total des utlisateurs",
    "Server": "Serveur",
    "Try to pull records from Parking": "Essayer de rècupèrer des enregistrements du parking",
    "Scheduled By": "Plannifié par",
    "assistL": "Assistant gauche",
    "removefolders": "Supprimer les dossiers",
    "Home": "Accueil",
    "chartinfo": "Informations sur l'organigramme",
    "autodelta": "Notifications automatiques",
    "Link Template": "Lier un affichage",
    "Basic Rule": "Règle basique",
    "Time Formats": "Format de la date",
    "Role Assignment": "Assigner des rôles",
    "exclude": "Exclure",
    "endpoint": "Fin",
    "Allow Groups with Managers": "Permettre des groupes avec des managers",
    "unknownerrnoemail": "Erreur inconnue. Essayer de recharger la page, ou contacter le support si le problème persiste",
    "reqpitinfo": "Cliquez ici pour apprendre plus sur les archives",
    "allowedlimit": "Limite permise des cases:",
    "resetdirs": "Réinitialiser les dossiers",
    "selectuiprofile": "Saisissez le profile UI",
    "rowsecrestrictedfields": "Aucun de ces champs peuvent être vus.",
    "nofileresults": "Pas de résultat de recherche dans",
    "fileinfoerr": "Erreur en essayant de récupérer les informations du dossier",
    "customfonts": "Police personnalisées",
    "savingaccountsettings": "Enregistrer les paramétres du compte",
    "Organization ID": "ID de l'organisation",
    "disabledAccount": "Compte désactivée. Cliquez ici pour plus de détails",
    "No chart data loaded - select the Refresh Data Now option to load data": "aucune donnée chargée ^ Sélectionner l'option de rafrahissement des données pour charger des données",
    "emailadderr": "Cet email est déjà utilisé. Merci d'essayer avec un autre email",
    "Not In": "Absent de",
    "newnameuiprofile": "Renommer le profil UI",
    "copyuiprofile": "Copier le profile UI",
    "Rule": "Règle",
    "Allow View": "Permettre cette vue",
    "uploadfailmultiplefiles": "Échec de l'import. Vous ne pouvez pas impoter plusieurs fichiers. Merci d'importer un fichier à la fois.",
    "occcode": "Code de la position",
    "chartaccess": "Permettre cette accès",
    "Chart Management": "Gestion de l'organigramme",
    "All": "Tous",
    "formulaerrdupname": "Ce nom existe déjà",
    "fileinfoerror": "Impossible de rafraichir. Merci d'essayer encore.",
    "parentUnitID": "ID de l'org unit parent",
    "renameuiprofile": "Saisissez le nom du profil UI",
    "assistPL": "Assitant pair gauche",
    "notsandbox": "Ce n'est pas un compte sandbox",
    "Box Flag": "Case marquée",
    "Current top box": "Case sommet actuelle",
    "groupprops": "Propriétés du groupe",
    "nochartsloaded": "Pas d'organigramme importé",
    "Importfiltereditor": "Importer l'éditeur des filtres",
    "UI Profile": "Profil UI",
    "novalue": "La valeur doit avoir au moins 2 caractéres",
    "assistPR": "Assistant paire gauche",
    "needsrefresh": "Une nouvelle version d'OCN est disponible. Merci de rafrachir votre navigateur (Ctrl +Shift+R)",
    "enterhighlightname": "Saisissez le nom de la règle de surbrillance ici",
    "customFontMsg": "e.g Helvetica",
    "Filters & Highlights": "Filtres et Surbrillances",
    "Current View": "Vue actuelle",
    "Filtered Managers": "Les managers filtrés",
    "addafolder": "Aucuns fichiers existants",
    "Enter Name Here": "Saisissez le nom ici",
    "color": "Couleur",
    "pitenabled": "Archive automatique",
    "archiveloadsuccess": "Archive importée avec succès",
    "noheaders": "Vous devez impoter des données avant d'ajouter des liens auxiliares",
    "grouptype1": "Goupe avec les responsables",
    "Font Face": "Style de police",
    "Clear Existing Groups": "Supprimer les groupes existants",
    "preferredlast": "Derniére case voulue",
    "breakcharacter": "Segmenter les caractères",
    "Connecting Line Style": "Connecter le style de la ligne",
    "buildcharton": "Construire l'organigramme à partir de",
    "Excel Settings": "Paramétres excel",
    "chiefID": "ID du responsable",
    "Box Color": "Couleur de la case",
    "Administration": "Administration",
    "used": "utilisée",
    "companynamedd": "Saisissez le nom de l'entreprise",
    "onecolL": "Une colonne gauche",
    "configerrormsg": "Un ou plusieurs champs ne sont pas clairement definis. Merci d'utiliser la fonctionnalite Mapping pour les définir.",
    "renamefolder": "Impossible de renommer le fichier. Merci d'essayer encore.",
    "ungroup": "Dégrouper",
    "ActivityLog": "Logs..",
    "Existing Chart": "Organigramme existants",
    "grouptype2": "Groupe sans responsable",
    "customFontTitle": "Nouveau style de police",
    "Security Profile": "Profil de sécurité",
    "Restricted fields": "Champs restreints",
    "highlightcolor": "Couleur de surbrillance",
    "Notification": "Notifications",
    "advancedSettings": "Paramétres avancés",
    "Definitions": "Définitions",
    "Links": "Liens",
    "refreshorgprops": "Rafrachir les propriétés",
    "selected": "sélectionée",
    "archivesuccess": "Archive crééé avec succès",
    "Section": "Section",
    "createnew": "Créer nouveau",
    "Header": "En-tête",
    "uiprofiles": "Profiles UI",
    "include": "Inclure",
    "customfont": "Personnaliser",
    "occcount": "Compte du nombre de position",
    "Number of Boxes": "Cases montrées",
    "scheduleoptions": "Options de planification du rafraîchissement",
    "grouptype": "Type de groupe",
    "Loading": "Chargement",
    "docut": "Couper texte",
    "Layout Type": "Type de disposition",
    "removefields": "Supprimer des champs",
    "Allowed fields": "Champs permis",
    "Chart Access": "Accès à l'organigramme",
    "Select All": "Tout sélectionner",
    "boxingroup": "Toutes les cases dans ce groupe",
    "onecolCL": "Une colonne centrée gauche",
    "user": "utilisateur",
    "Dynamic": "Dynamique",
    "Local": "Local",
    "Local (time)": "locale",
    "uploadingnow": "Chargement du fchier",
    "6004": "Une ou plusieurs formules contiennent des références invalides. Merci de vérifier les formules (Plus > Paramétres de l'organigramme > Champs & Formules) pour plus de précision, ou contacter l'équipe support si le problème est persistant",
    "Date Format": "Format de la date",
    "Refine": "Affiner par",
    "manual": "Manuellement",
    "Invalid or unset default chart Define the default chart in the database config panel": "Organigramme invalide ou non défini. Merci de définir l'organigramme par défaut dans le panneau de configuration.",
    "Allowed": "Permis",
    "Security Profile Configuration": "Configuration de la sécurité",
    "pleaseReduceNumberLevels": "Merci de réduire le nombre de niveau pour votre organigramme",
    "User Information": "Information de l'utilisateur",
    "viewernochartserr": "Aucun n'organigramme n'a été configuré. Cliquez sur Créer un nouvel organigramme pour commencer",
    "No charts have been configured": "Aucun n'organigramme n'a été configuré",
    "Apply Box Style To Members": "Appliquer des styles de case aux membres",
    "yesfileresults": "Rechercher les résultats dans",
    "banded": "Attaché",
    "copyclipboard": "Copier dans le presse-papier",
    "preferredfirst": "Première case voulue",
    "eightcolumn": "Huit colonnes",
    "Connecting Line Color": "Connecter la couleur de la ligne",
    "enterMyMap": "Ajoutez la cartographie du champ",
    "clicktoadd": "Cliquez (+) pour ajouter",
    "Linked Template": "Affichage lié",
    "Current Chart": "Informations sur l'organigramme",
    "lastpit": "Dernière archive",
    "Main Data Source": "Source de données principale",
    "Data Source": "Source de données",
    "Data sources": "Sources de données",
    "nospaceuiprofile": "Les profiles UI ne peuvent pas contenir des espaces",
    "Columns": "Colonnes",
    "viewernotset": "Pas défini",
    "deltaerr": "Erreur au moment de la génération du rapport delta",
    "Add new chart confirm": "Voulez-vous créer manuellement un nouvel organigramme ? Vous devez être sûr que votre source de données ainsi que la configuration soient correctes",
    "border": "Bordures",
    "entercheckpointname": "Saississez le point de suavegarde",
    "themearrow": "Type de flèches",
    "Map": "Carte",
    "availableviews": "Vues disponibles",
    "twelvecolumn": "Douze colonnes",
    "Row Level Security": "Niveau de sécurité des lignes",
    "stagger": "Décaler",
    "year": "Année",
    "Years": "Années",
    "Set Text Style": "Définir un style",
    "sixcolumn": "Six colonnes",
    "onecolR": "Une colonne droite",
    "Seed Value": "Données de référence pour filtrer",
    "Custom Colors": "Couleurs personnalisables",
    "Records": "Enregistrements",
    "twentycolumn": "Vingt colonnes",
    "allowedviews": "Vues permises",
    "branchlevelsecurity": "Sécurite par branches de l'organigramme",
    "UI Profiles": "Profile UI",
    "unexpectederr": "Échec de la mise à jour. Une erreur interne s'est produite",
    "checkpoint": "sauvegarde",
    "Complex Math": "Calcul complexe",
    "Optional": "Optionnel",
    "assistR": "Assistant droit",
    "fontstyle": "Styles de Police",
    "FieldValue": "Valeur du champ",
    "renameerr": "Impossible de renommer les fichiers sélectionnés. Merci de réessayer",
    "accountinfo": "Détails du compte",
    "selectadpoid": "Ajoutez OID d'ADP",
    "copyitem": "Objet",
    "Details": "Détails",
    "userdetails": "Détails de l'utilisateur",
    "userdetails (short)": "Détails de l'util.",
    "deltareport": "Rapport delta",
    "loadingfolder": "Chargement",
    "enterfontstyle": "Saisissez un nom de police",
    "sixteencolumn": "Seize colonnes",
    "Criteria": "Critères",
    "enterfiltername": "Saisissez le nom du filtre ici",
    "Apply Template": "Appliquer l'affichage",
    "Required": "Requis",
    "savinggroups": "Enregistrements des changements…",
    "Grouping": "Grouper",
    "selectpassword": "Ajoutez le mot de passe de service",
    "Static Formula Editor": "Éditeur de formule statique",
    "from": "De",
    "chartbuildertemplates": "Les affichages de Chart Builder",
    "Custom fields": "Champs personnalisés",
    "Fields shown": "Champs montrés",
    "Always Apply": "Toujours appliquer",
    "Show Username": "Montrer le username",
    "rowsecallowedfields": "Seulement ces champs peuvent être vus.",
    "Private Folder Access": "Accès dossier privé",
    "showFilenames": "Montrer le nom des fichiers",
    "canExportExcel": "Exporter vers Excel",
    "In": "Dans",
    "Conditional rule": "Règle de formatage",
    "AuxSuperID": "AuxSupervisorId",
    "Not Equal": "Inégale",
    "month": "Mois",
    "Equal": "Égal",
    "autochildren": "Auto",
    "Current": "Actuel",
    "DecimalPlaces": "Décimales",
    "items": "Objets",
    "Operation": "Opération",
    "checkdelconfirm": "Êtes-vous sûr de supprimer cette sauvegarde ?",
    "nofieldvalues": "Aucunes valeurs associées avec ce champ",
    "securityoverride": "Forcer le système d'assignement de sécurité",
    "Access Group": "Groupes d'accès",
    "uifont": "Police UI",
    "orgChiefID": "ID du Responsable d'unite",
    "includeorphans": "Inclure les orphelins",
    "filterbuild": "Les filtres sélectionnés seront appliqués au prochain rafraîchissement",
    "maxplimit": "Nombre de cases maximum sur un organigramme",
    "singleplimit": "Nombre de cases maximum sur une seule page",
    "Plan Status": "Rapport sur le",
    "Archive Plan": "Archiver le plan",
    "importsaveconfirm": "Vous êtes sur le point d'importer une nouvelle source de données",
    "Target": "Cible",
    "loadheadersfailure": "Un problème a été detecté avec la cartographie des champs. Cliquez sur configurer la cartographie afin de le résoudre",
    "addrestricted": "Ajouter un champ restreint",
    "Lock Plan": "Verrouiller le plan",
    "Enable Administrator User Impersonation": "Permettre à l'administrateur d'impersoner un utilisateur",
    "Showing results": "Affichage de {firstResult} - {lastResult} sur {totalCount} resultats",
    "Results per page": "Résultats par page",
    "Showing": "Montrer",
    "managers": "responsables",
    "Showing X of Y managers": "Affichage de {visibleCount} sur {totalCount} responsables",
    "Limit": "limite",
    "refreshsaveconfirm": "Vous êtes sur le point de réaliser un rafraîchissement des données",
    "Change": "Changer",
    "Show Overlay": "Montrer la superposition",
    "selectagroup": "Sélectionner un groupe de la liste",
    "Browse": "Naviguer",
    "viewer": "Visionneuse",
    "addnewgroup": "Cliquez sur ajouter pour créer un groupe",
    "generatedelta": "Générer un rapport delta",
    "Additional Tables": "Tables additionnelles",
    "directory": "Répertoire",
    "Compare Plans": "Comparer les plans",
    "Talent Pool": "Répertoire",
    "savemasteras": "Enregistrer la masque de page sous",
    "Date Modified": "Date modifiée",
    "No Plans Alert": "Cliquez ici pour créer votre premier plan",
    "Private": "Privé",
    "addkey": "Ajouter une clé",
    "Online": "En ligne",
    "deleteusers": "Êtes-vous sûr de vouloir supprimer les utilisateurs sélectionnés ?",
    "SystemError": "Échec de l'action",
    "Active Plans": "Plan en cours d'activité",
    "Offline": "Hors ligne",
    "Search Archived Charts": "Rechercher les organigrammes archivés",
    "Minimum Group Size": "Taille minimum du groupe",
    "deletesource": "Supprimer le fichier source après rafraîchissement",
    "Share with others": "Partager avec les autres",
    "Delete Plan": "Supprimer le plan",
    "nosavedfilter": "Aucuns filtres enregistrés trouvés",
    "searchkeys": "Clés de recherche",
    "Edit Plan": "Modifier le plan",
    "Duplicate Plan": "Dupliquer le plan",
    "Save Master": "Enregistrer la master",
    "Last Synchronized": "Dèrnier synchronisé",
    "Away": "Ailleurs",
    "New User": "Nouvel utilisateur",
    "Private Plan": "Plan privé",
    "Plan On": "Plan en cours",
    "Plan Explorer": "Répértoire des plans",
    "Error": "Erreur",
    "Planning": "Planification",
    "Plan": "Plan",
    "keyname": "Nom de la clé",
    "Starting": "En commençant",
    "collaborator": "Collaborateur",
    "owner": "Propriétaire",
    "Archived": "Archivé",
    "Show all": "Montrer tout",
    "Rename plan": "Renommer le plan",
    "Rename profile": "Renommer le profil",
    "No more changes to show": "Pas de changements à montrer",
    "allowcommitsds": "Permettre les changements de la source de donnée",
    "Save Plan": "Enregistrer le plan",
    "Plan Name": "Nom du plan",
    "containsuser": "Saisir le username ou l'email",
    "notsupported": "Pas supporté par",
    "PersonUnitID": "position de l'Org Unit",
    "deleteuser": "Êtes-vous sûr de vouloir supprimer l'utilisateur sélectionné ?",
    "customoutfields": "Utiliser",
    "allowmanualrefresh": "Permettre que cet organigramme soit mis à jour manuellement",
    "saveandcontinue": "Enregistrer les changements et continuer ?",
    "Created": "Créé",
    "Plan Builder": "Constructeur de plan",
    "includeself": "Inclure soi",
    "Rename Plan": "Renommer le plan",
    "Plan Metrics": "Statistiques du plan",
    "createcheck": "Sélectionner 'nouveau' pour créer un point de sauvegarde",
    "Change Levels": "Changer les niveaux",
    "headerssaveconfirm": "Vous êtes sur le point de changer la source de données pour l'organigramme sélectionné",
    "loadtoedit": "Charger un organigramme pour modifier les filtres et la surbrillance",
    "NoPlansExist": "Pas de plans créés encore. Cliquez ici ou sélectionner 'Nouveau Plan' pour commencer",
    "conddefeditor": "Éditeur des règles conditionnelles",
    "Edit Box": "Modifier la case",
    "Comments": "Commentaire",
    "Unlock Plan": "Dévérouiller un plan",
    "people": "personne(s)",
    "person": "personne",
    "(No people)": "(Pas de personnes)",
    "Group \"Full Access\"": "Groupe \"Accès Total\"",
    "selectf": "Sélectionner le champ",
    "Plan Name cannot be left blank": "Le nom du plan ne peut être vide",
    "Team members": "Membres de l'équipe",
    "Distance To Target": "Distance jusqu’à la cible",
    "Status": "Statut",
    "nosavedhighlight": "Pas de surbrillance enregistrés trouvés",
    "Open Plan": "Ouvrir le plan",
    "dropdups": "Supprimer les doublons",
    "Archived Plans": "Plans archivés",
    "Comment": "Commentaire",
    "Enter": "Saisir",
    "Enter (Value)": "Saisir",
    "New Plan": "Nouveau plan",
    "Dashboard": "Tableau de bord",
    "Unable to Save Changes": "Impossible d'enregistrer les changements",
    "SystemError2": "Essayer de rafraichir la page ou contacter le service support si le problème persiste",
    "restrictq": "Restreindre les requetes pour ces champs",
    "Select a user to start sharing": "Sélectionner un utilisateur pour commencer à partager",
    "6000": "Le conncteur n'est pas compatible avec le type du fichier sélectionné",
    "addoperations": "Cliquez sur (+) pour ajouter des opérations",
    "NoValuesAdded": "Pas de valeurs. Cliquez ici pour ajouter",
    "Change Topbox": "Changer la case sommet",
    "piechartprops": "Organigramme en camembert éditeur",
    "Activity Log": "Rapport d'activité",
    "Last Modified": "Dérnier fichier modifié",
    "Active": "Actif",
    "Paused": "En pause",
    "Inactive": "Inactif",
    "Shared Plans": "Plans partagés",
    "background": "Arriére-plan",
    "NoSharedUsers": "Vous ne partager ce plan. Cliquez ici pour commencer à partager",
    "addtemplate": "Ajouter l'affichage",
    "Share Plan": "Partager plan",
    "Target Field": "Champ cible",
    "Enter Plan Name": "Saisir le nom du plan",
    "Change History": "Changer l'historique",
    "Create Metrics": "Créer des indicateurs",
    "Validation Alert": "Alerte de validation",
    "grayscale": "Échelle de gris",
    "Total Changes": "Total des changements",
    "NoMetrics": "Cliquez ici pour ajouter un indicateur",
    "Moves": "Mouvements",
    "Uniform Scaling": "Mise en échelle uniforme",
    "Target Value": "Valeur cible",
    "stageNew": "Aucun enregistrement chargé. Rechercher pour ajouter de nouveaux enregistrements",
    "Hover Profile": "Survoler profil",
    "Add Metric": "Ajouter indicateur",
    "Edits": "Modifications",
    "Metric": "Indicateurs",
    "Index Page": "Page d'index",
    "Loading Plan": "Chargement d'un plan",
    "Last Sync": "Dernière synchro",
    "Building Plan": "Créer un plan",
    "Adds": "Ajouts",
    "Deletes": "Suppressions",
    "No formulas have been created": "Aucunes formules n'ont été créés. Aller à Paramétres de l'organigramme > Champs & Forumles pour ajouter une formule",
    "Add metrics": "Ajouter des indicateurs et suivre l'évolution",
    "Inverted": "Inversé",
    "Fields editable in plan": "Champs en dessous sont modifiables dans le plan",
    "Shortcut Field": "en-têtes inclus",
    "fotm": "le 1er du mois",
    "Included Headers": "les en",
    "Summary": "Table des matières",
    "Fields available": "Les champs qui apparaissent ici sont disponibles pour modifier votre plan",
    "History": "Historique",
    "Sharing & Collaboration": "Partage & collaboration",
    "Share to collaborate": "Donner aux autres utilisateurs d'accès en tant que collaborateur ou en lecture seule.",
    "alldivisions": "Toutes les divisions/départements",
    "Expand": "Étendre",
    "Select a user to share with": "Sélectionner un utilisateur pour partager avec",
    "motm": "15 du mois",
    "No archives have been created": "Pas d'archives ont été créés",
    "Chart Builder & Publisher Subchart Breaks": "Chart Builder & publication de la rupture des sous-organigrammes",
    "Default Fields": "Champs par défaut",
    "Manage Editable Fields": "Gérer les champs modifiables",
    "All plans are shared with you": "Tous les plans/modèles sont partagés avec vous",
    "Metrics & Data Visualization": "Indicateurs et visualisation des données",
    "Collapse": "Effondrer",
    "Syncing Plan": "Plan synchronisé",
    "Effective Dates": "Dates effectives",
    "Effective date": "Date effective",
    "Subcharts & Shortcuts": "Pages & Raccourcis",
    "Timeline": "Chronologie",
    "by": "par",
    "eotm": "Dernier du mois",
    "Editable Fields": "Champs modifiables",
    "Manage metrics": "Gérer les indicateurs",
    "allowedHighlights": "Surbrillances permises",
    "Archive Cleanup": "Nettoyer l'archive",
    "ExportChart": "Exporter l'organigramme",
    "Symbols": "Symbôls",
    "Show Activity": "Montrer l'activité",
    "SFTP": "SFTP",
    "Conflict Detected": "Conflit trouvé entre la source des données et le plan",
    "Chart Documents": "Documents du chart",
    "dateBracket": "Tranche de date",
    "Add Branch Rule": "Ajouter une règle de securité au niveau de la succursale",
    "eqdesc": "Si la valeur d'un record correspond au critère",
    "Auto Format": "Format automatiquement",
    "ownbranch": "Restreindre à propre succursale",
    "Date Bracket": "Tranche de date",
    "Remove Rule": "Supprimer la règle",
    "Employee Removed": "L'enregistrement n'existe plus dans la source des données. Annulez le changement afin de résoudre le conflit.",
    "Documents": "Documents",
    "Dynamic Range": "Portée dynamique",
    "Rule Comparison": "Comparaison des règles",
    "formulareservedname": "est un nom réservé",
    "formulareservedname2": "Veuillez entrer un nom de champ unique.",
    "Use Source": "Utiliser la source des données",
    "Choose Source": "Choisir entre le plan ou les valeurs de la source afin de résoudre le conflit.",
    "Months": "Mois",
    "Older Than": "Supprimer les archives plus vieilles que",
    "confirmAddDelegated": "Cette addresse électronique est déjà associé à un autre organisation. Voulez-vous leur donner l'accès à cette organisation ?",
    "Reserved Field Name": "Nom de champ réservé",
    "Additional Levels": "Niveaux supplémentaires",
    "enumeratedbranch": "Succursales énumérées",
    "indesc": "Les champs conditionnels sont chachés si la valeur d'un enregistrement correspond à n'importe quel critère de la valeur du champ.",
    "documentproperties": "Propriétés du document",
    "branchaccesslist": "Champ d'acces a la succu",
    "Branch Level Security": "Niveau de la succursale",
    "nindesc": "Les champs conditionnels sont chachés si la valeur d'un enregistrement ne correspond à aucun critère de la valeur du champ.",
    "allowedFilters": "Filtres permis",
    "Activity": "Activtié",
    "Select a Profile": "Selectionner un profil",
    "Revert": "Annuler",
    "ViewerLoadChartError": "Seulement les organigrammes produits par un Master Chart peuvent être ajoutés au Viewer. Utilisez le Chart Builder pour construire un organigramme et l'ajouter au Viewer.",
    "Static Range": "Portée statique",
    "neqdesc": "Les champs conditionnels sont cachés si la valeur d'un enregistrement ne correspond pas au critère de la valeur du champ.",
    "Delegated": "Délégué",
    "Weeks": "Semaines",
    "Master Charts": "Organigrammes principaux",
    "Use Plan": "Utiliser le plan",
    "topboxids": "IDs de la case sommet",
    "No activity yet": "Aucune activité pour le moment.",
    "Show Details": "Rapport d'activité",
    "Add to plan": "Ajouter au plan",
    "Move within plan": "Changer position",
    "Remove from pool": "Supprimer du répertoire",
    "About Plan": "À propos du plan",
    "Basic Info": "Informations organisationnelles",
    "Additional Info": "Information additionnelle :",
    "New Record": "Nouvel Enregistrement",
    "Remove Field": "Supprimer Champ",
    "Configure Link Access": "Configurer l'accès au lien",
    "Suppress": "Supprimer",
    "New Table": "Cliquez ici pour crée un tableau.",
    "Allow Public Access": "Permettre l'accès du public",
    "Select UI Profile": "Selectionner un profil IU",
    "Object": "Objet",
    "Source Data": "Données de source",
    "Revert To Source": "Revenir à la source",
    "Authorization": "Autorisation",
    "Table Manager": "Gestionnaire de tableau",
    "Data field used for assignment": "Champ de données utilisé pour l'affectation de groupe",
    "Delete Confirm Append Entry": "Voulez-vous vraiment supprimer cette entrée selectionée ? (Les changements auront lieu après le prochain rafraîchissement).",
    "Automatically assign users to access group upon login": "Attribuer automatiquement les utilisateurs au groupe d'accès lorsqu'ils se connectent.",
    "Export Options": "Options d'exportation",
    "Allowed Referrer Domains": "Les domaines référants permis",
    "tabledeleteconfirm": "Avertissement : Tous les organigrammes qui utilisent ce tableau pour ajouter les données ne seront plus inclure les données ajoutées associées à ce tableau.(Les changements auront lieu après le prochain rafraîchissement).\n\nVoulez-vous vraiment supprimer ce tableau ? Cette action ne peut pas être annulée.",
    "Configure whitelist domains for restricted link access": "Configurer les domains pour les liens d'accès limité",
    "All fields are exported by default": "Par défaut, tous les champs sont exportés",
    "useuiprofile": "Utiliser le profil IU",
    "About Append Tables": "Les tableaux joints vous permettre de changer les valeurs de votre données de source.",
    "No Append Entries": "Aucunne entrées ont été créées. Utiliser les boutons à gauche pour créer la première entrée.",
    "Link User Configuration": "Lier la configuration d'utilisateur",
    "Auto-Assignment Configuration": "La configuration d'attribution automatique",
    "Card": "La carte",
    "Use default group instead of denying access": "Utilisez le groupe défaut au lieu de refuser l'accès.",
    "Append Table": "Tableau joint",
    "Also Reports To": "Aussi rapport à",
    "Left Bound": "Avant",
    "Bounds": "Limites",
    "Right Bound": "Après",
    "Set which groups line up with values in your data": "Definir les groups qui correspondent aux valeurs de données.",
    "Document Settings": "Paramètres du document",
    "Use Presentation": "Utiliser la présentation",
    "Master chart used to validate user": "Le master est utilisé de valider l'utilisateur",
    "Image Settings": "Paramètres d'images",
    "Automated Chart Export": "Exportation automatisée de l'organigramme",
    "Allow public access": "L'accessibilité publique donnera à tous avec ce lien l'acces à OCN. Voulez-vous vraiment continuer ?",
    "Use data field for Row Level Security assignment": "Utiliser le champ de données pour attribuer la sécurité aux niveu ligne.",
    "Find Record": "Trouver un enregistrement",
    "Find record to add to talent pool…": "Rechercer pour ajouter au répertoire…",
    "Append Entry Help": "Ajouter, modifier, déplacer, et supprimer des enregistrements",
    "personidinuse": "IDEmployé déjà utilisé",
    "Bounded": "Délimité",
    "Chart Editor": "Editeur d'organigramme",
    "User Record Retrieval": "La manière de rechercher l'enregistrement d'un utilisateur",
    "Overwrite Existing Data": "Écraser les données existantes",
    "Append Plan": "Plan joint",
    "confirmexit": "Voulez-vous vraiment quitter ?",
    "Filter Options": "Options de filtrage",
    "Error importing views message": "L'importation de vues a échoué. Veuillez utiliser le bouton<<exporter les vues>> dans l'autre compte OrgChart, et puis cliquez sur coller ici.",
    "enablegoogleslides": "Permettre l'exportation vers Google Slides",
    "Please Correct": "Veuillez corriger",
    "Interactive": "Interactif",
    "Configure the fields used to identify a chart record that corresponds with a user.": "Configurer les champs utilisés pour identifier un enregistrement qui correspond à l'utilisateur",
    "Add Branch": "Ajouter une branche",
    "Prebuilt Filters": "Filtres prédéfinis",
    "No filter applied": "Aucun filtre appliqué",
    "Filtering": "Filltrage",
    "View successfully imported. Be sure to save the changes to your shared templates and box styles libraries.": "L'importation de vue a réussi. Veuillez enregistrer les changements dans les bibliothèques partagées pour les modèles et les styles.",
    "addmanualsub": "Ajouter un subordonné",
    "Interactive Filtering": "Filtrage interactif",
    "Confirm Overwrite Manual Data Source": "AVERTISSEMENT ! Le changement de votre fichier source de données écrasera toutes les données existantes, y compris les modifications manuelles. Voulez-vous vraiment écraser vos données sources ?",
    "Overwrite": "Écraser",
    "Return to Chart": "Retourner à l'organigramme",
    "Return to base chart": "Ret. à l'organigramme de base",
    "privateinfotext": "Les liens privés vous permettre de configurer les points d'entrées personalisés à l'organigramme tout en nécessitant l'authentification (SSO ou connexion directe).",
    "Hit the paste shortcut on your keyboard to import templates": "Afin d'importer les affichages, tapez sur le raccourci clavier de coller",
    "linnkuserconfigwarning": "Aucun utilsateurs n'a été configuré pour ce type de lien. Veuillez cliquer sur Plus > Paramètres du compte > Autorisation pour configurer les utilsateurs pour les liens. Cliquez sur ? pour plus d'information.",
    "Are you sure you want to": "Voulez vous vraiment ?",
    "publicinfotext": "Les liens publics peuvent être directement consultés par tous sur l'internet",
    "creategoogleslides": "En train de créer les Google Slides...",
    "Do you want to resume planning in your last open plan?": "Voulez-vous reprendre la plannification du dernier plan ouvert ?",
    "generategoogleslides": "Téléchargement les Google Slides sur Google Drive",
    "restrictedinfotext": "Les liens restreints sont securisés et peuvent être consultés uniquement des sites spécifiés.",
    "navtocell": "Montrer le tableau",
    "Close Plan Builder": "Fermer le Plan Builder",
    "deletemanualbox": "Supprimer la case",
    "Launch Configuration": "Lancer la configuration",
    "Shadow": "Ombre",
    "Get Started": "Commencer",
    "Box Spacing": "Espacement de case",
    "SVG Image": "Image en SVG",
    "Mode": "Mode",
    "Save Alert": "Enregistrer vos modifications ?",
    "Justify": "Justifier",
    "Dynamic Value": "Valeur dynamique",
    "See Plans": "Consulter les plans",
    "Refresh chart now": "Rafrachîr l'organigramme",
    "JPG Image": "Image en JPG",
    "Legacy Chart": "Organigramme hérité",
    "Excel Data": "Données Excel",
    "supportdeskhelp2": "bureau de support",
    "Permission denied to access Planning module. Ensure your role and organization have access to Planning": "L'accès à Planification refusé. Verifez votre rôle et votre organization vous permettre d'y accéder.",
    "Align Chart Top": "Aligner en haut",
    "Last Login": "Dernière connexion",
    "Font Selector": "Police",
    "Metadata Type": "Type de metadonnées",
    "PNG Image": "Image en PNG",
    "Sync Now": "Synchroniser maintenant",
    "Buy Now": "Acheter maintenant",
    "Label Options": "Options d'étiquettes",
    "Do you want to roll up the subordinates from other pages": "Voulez-vous garder les subordonnées des autres pages ?",
    "Unable to locate target box!": "Case ciblée introuvable !",
    "Sync plan": "Synchroniser le plan",
    "Locked plans cannot be synced with base chart data": "Les plans verrouillés ne peuvent pas être synchronisés avec les données de l'organigramme de base",
    "Archived plans cannot be synced with base chart data": "Les plans archivés ne peuvent pas être synchronisés avec les données de l'organigramme de base",
    "Cannot sync with unsaved background changes": "Impossible de synchroniser avec des modifications d'arrière-plan non enregistrées",
    "Launch to Self": "Lancer vers l'enregistrement d'utilisateur",
    "Load Headers": "Télécharger les en-têtes",
    "Standard Search": "Recherche standard",
    "Resume last open plan": "Reprendre le plan dernier",
    "Branch Level": "Niveau de la succursale",
    "Google Slides": "Google Slides",
    "Save Changes": "Enregistrer les modifications",
    "PPT Document": "Document en PPT",
    "Line Thickness": "Style de ligne",
    "Remote": "à distance",
    "Center Chart Horizontal": "Distruber horizontalement",
    "Open Last Plan": "Ouvrir le dernier plan",
    "Box Sort": "Trier les cases",
    "Line Color": "Couleur de ligne",
    "Single Logout": "Déconnexion unique",
    "Click Setup Chart to get started": "Cliquez sur configurer l'organigramme pour commencer",
    "Please Wait": "Attendez",
    "Delete SSO Configuration": "Supprimer la configuration SSO",
    "Confirm delete SSO configuration": "Confirmer la suppression de la configuration SSO",
    "SSO Entity ID": "ID entité SSO",
    "Static Value": "Valeur statique",
    "SSO Configuration": "Configuration SSO",
    "Master Chart Settings": "Paramètres de master",
    "Font Color": "Couleur de police",
    "darkmode": "Mode noir",
    "Planning Access Denied": "Accès à Planification refusé",
    "PDF Document": "Document en PDF",
    "Discard Changes": "Annuler les modifications",
    "Staging": "Organiser",
    "Contact your system administrator if this issue persists": "Si le problème persiste, contactez votre administrateur système.",
    "Session Warning": "Votre session est périmé. Veuillez chossir de rester connecté ou de vous déconnecter. Autrement, nous mettons automatiquement fin à votre session.",
    "Excel Spreadsheet": "Tableur excel",
    "Metadata Location": "Localisation de métadonnées",
    "Create a Workbench document": "Creer un document Workbench",
    "No Shortcuts Found": "Aucun raccourcis trouvés",
    "lightmode": "Mode blanc",
    "Auto Provision": "Provisionnement automatique",
    "User Value": "Valeur utilisateur",
    "Revert Change": "Rétablir les modifications ?",
    "Move Out": "Déplacer à l'extérieur",
    "Font Size": "Taille de police",
    "Use Value from current User Record": "Utiliser la même valeur que l'enregistrement d'utilisateur actuel",
    "Web Link": "Lien web",
    "Cell Fill": "Remplissage de cellule",
    "Confirm New Password": "Verifier le nouveau mot de passe",
    "Wrap Text": "Renvoyer à la ligne automatiquement",
    "leave the Plan Builder": "sortir de Plan Builder",
    "Italic": "Italique",
    "Configure AzureAD Photos": "Configurer les photos AzureAD",
    "Exit Plan Builder": "Sortir de Plan Builder",
    "Enable Workbench": "Activer Workbench",
    "Privacy Policy": "Politique de confidentialité",
    "saveconfirm3": "Toutes les modifications non enregistrées seront perdues.",
    "Master Editor": "Éditeur master",
    "SSO Metadata Location": "Localisation de métadonnées SSO",
    "Group Assigned": "Affecté par groupe",
    "Confirm Delete Plan": "Êtes-vous sûr de vouloir supprimer ce plan ? Cette action est irréversible.",
    "AzureAD Photo Configuration": "Configuration des photos AzureAD",
    "supportdeskhelp": "Si le problème persiste, veuillez contacter notre",
    "Search Name or Title": "Rechercher le nom ou le titre",
    "Password reset successfully. Be sure to update your password manager, if you use one.": "La mot de passe a réinitialisé avec succès. Si vous utilisez un gestionnaire de mots de passe, mettez-le à jour.",
    "Pie Chart": "Organigramme en secteurs",
    "Stay Logged In": "Rester connecté",
    "Plan Needs Sync": "Le plan doit synchroniser",
    "Switch To Branch Level": "Basculer sur le niveau de la succursale",
    "Advanced Search": "Recherche avancée",
    "Switch To Field Level": "Basculer sur le niveau du champ",
    "Continue Working": "Continuer à travailler",
    "Enable Report Issue": "Activer Signaler un problème",
    "Comm Preferences": "Préférences de communication",
    "App Settings": "Paramètres d'appli.",
    "Stay": "Rester",
    "Underline": "Souligner",
    "Bold": "Gras",
    "Plan Updates Available": "Des mises à jour du plan sont disponibles",
    "Revert Confirm": "Êtes-vous sûr de vouloir annuler les modifications effectuées ?",
    "Localization": "Traduction",
    "Set your AzureAD credentials here to import Azure AD photos with your chart data.": "Saisir vos identifiants AzureAD pour importer photos AzureAD avec vos données RH",
    "Exit Builder": "Sortir de Builder",
    "Continue Planning": "Continuer à plannifier",
    "and return to your chart": "et revenir à l'organigramme ?",
    "SSO Metadata Type": "Type de metadonnées SSO",
    "Plan Needs Updates": "Ce plan a été synchronisé depuis la dernière fois que vous l'avez ouvert. Valider pour recevoir les dernières mises à jour.",
    "Open Plan Explorer": "Ouvrir le navigateur de plans",
    "Show different fields depending on user language.": "Montrer les champs differents selon la langue d'utilisateur",
    "Saved Highlights": "Surbrillance sauvgardée",
    "moveoutboxtool": "Déplacer à l'extérieur du plan",
    "Center Chart Vertical": "Distribuer verticalement",
    "Chart Templates": "Les affichages d'organigramme",
    "Presentation": "Présentation",
    "Current Set": "Bibliothèque actuelle",
    "No Recent Documents": "Aucuns documents récents",
    "Enter Hex Value": "Saissir la valeur Hex",
    "Rename view": "Renommer la vue",
    "Rename base chart": "Renommer l'organigramme de base",
    "Rename custom chart": "Renom. l'organigramme pers.",
    "Chart Setting Mismatch": "Avertissement ! L'organigramme qui est en train d'être configuré est différent que l'organigramme actuellement ouvert. L'option de le modifier est désactivée.",
    "Undo": "Annuler",
    "New Append Table": "Nouveau tableau de données jointes",
    "SAML Invalid Mapping": "Les valeurs nulles ou manquantes sont présentes dans l'attribut de groupe SAML",
    "SAML Attribute To": "Groupe de sécurité dans l'application",
    "Manage Views": "Gérer les Vues",
    "SSO Enabled": "SSO activé",
    "No archives found for this chart.": "Aucunes archives trouvées pour cet organigramme",
    "Alter the appearance the chart box layout.": "Modifier le format de la case",
    "No records found outside the scope of the plan": "Auncuns enregistrements trouvés à l'extérieur du plan",
    "Duplicate View": "Dupliquer la Vue",
    "Redo": "Rétablir",
    "SAML Attributes Handling": "Traitement des attributs SAML",
    "Recent documents": "Documents récents",
    "Delete View": "Supprimer la Vue",
    "Save View": "Enregistrer la vue",
    "Field in Record": "Champ d'enregistrement",
    "Missing Photos": "Photos manquantes",
    "Move View": "Déplacer la Vue",
    "File Name": "Nom de fichier",
    "Select a view to start editing": "Sélectionner une vue pour commencer à modifier",
    "Launch Chart Builder": "Lancer Builder",
    "New View": "Nouvelle vue",
    "Automatically create new users if they do not already exist": "Automatiser le provisionnement des comptes utilisateur, si'ils n'existent pas encore dans l'application.",
    "Invalid File Name": "Nom de fichier invalide",
    "SAML Group Attribute": "Attribut de groupe SAML",
    "No File Selected": "Aucun fichier sélectionné",
    "Open document": "Ouvrir le document",
    "File Manager": "Gestionnaire de fichiers",
    "Custom Accent Color": "Couleur accentuée personalisée",
    "Accent": "Accentuée",
    "Roll Up": "Enrouler",
    "Rename Subchart": "Renommer le sous-organigramme",
    "What would you like to do with the subordinates of this manager?": "Qu'est-ce que vous voulez faire avec les subordonnées de ce gérant ?",
    "SSO Enabled Warning": "Voulez-vous vraiment activer SSO ? SSO sera activé pour cet ID d'entité.",
    "System Vew Edit Prompt": "Ceci est un affichage de système. Les affichages de système ne peuvent pas être modifiés.",
    "A file name can't contain": "Le nom de ficher ne doit pas contenir les caractères suivants:",
    "File Preview": "Aperçu du fichier",
    "Rename Field": "Renommer le champ",
    "SSO Disabled Warning": "Voulez-vous vraiment désactiver SSO ? Tous les utilisateurs qui utilisent SSO ne seront plus capable de se connecter avec le fournisseur d'identité.",
    "AdvSecEnterperisePaywall": "La sécurité avancée fait partie uniquement de l'édition Enterprise",
    "New SSO Configuration": "Attention ! Veuillez cocher la case SSO Activé pour activer SSO.",
    "Switch Mode": "Changer le mode",
    "View Manager": "Gestionnaire de Vues",
    "Automatically sign users out of IDP in addition to application sign-out.": "Permettre de la déconnexion unique de l'utilisateur de toutes les applications clientes.",
    "Refresh document": "Rafrachîr le document",
    "Appearance": "Présentation",
    "SAML Attribute From": "Groupe de sécurité d'IDP",
    "Delete Manager": "Suprimer le gérant",
    "Create blank chart": "Créer un organigramme vierge",
    "Custom Background Color": "Couleur de fond personalisée",
    "Compare Charts": "Comparer les organigrammes",
    "Plan Options": "Options du plan",
    "Igloo": "Igloo",
    "Click on a topbox from the list below": "« Votre filtre a retiré tous les cases sur l'écran. Cliquez sur une case sommet dans la liste ci-dessous pour naviguer à une succursale non filtrée, ou modifiez votre filtre. »",
    "Phone": "Portable",
    "sharepointqerr": "La configuration SharePoint a échouée. Veuillez contacter l'équipe de soutien à :",
    "NoSharepointConfig": "Aucunnes informations d'identification ont été configurées. Cliquez ici pour les configurer.",
    "Effective Dating": "Date effective",
    "ViewerNoMasterChartsNotAdmin": "Incapable de charger des données. Veuillez contacter votre administrateur pour configurer votre compte.",
    "unableOpenPlan": "Incapable d'ouvrir le plan. Veuillez vérifier les données de source et l'attribution de champs.",
    "New Mapping": "Nouvelle attribution",
    "Mute": "Muet",
    "Reload Directory": "Recharger",
    "All fields are shown in the Profile Tab by default": "tous les champs sont montrés dans le Profile par défaut.",
    "Photo Source": "Source des photos",
    "AzureAD": "AzureAD",
    "incompletesharepointcreds": "Afin de terminer la configuration SharePoint, veuillez enregistrer vos informations d'identifiant SharePoint dans Paramètres du compte > Autorisation",
    "Snapshot": "Instantané",
    "delegatedsameorgemail": "a déjà eu accès à cet organisation.",
    "This is a Point in Time chart generated": "Ceci est un organigramme point in time",
    "Metrics": "Indicateurs",
    "permanentaction": "Avertissement : Cette action ne peut pas être annulée",
    "Additional photo configuration": "Configuration supplémentaire des photos",
    "Users": "Utilisateurs",
    "No Snapshots found for this chart. Click here to configure automated snapshot generation.": "Aucuns instantanés trouvés pour cet organigramme. Cliquez ici pour configurer la génération automatisée des instantanés.",
    "Sharepoint Domain": "Domaine SharePoint",
    "Move With Manager": "Déplacer avec le gestionnaire",
    "Duplicate EntityID": "Incapable d'enregistrer la configuration SSO. Vérifiez que l'ID entité est correct. Veuillez contacter l'équipe de soutien si le problème persiste.",
    "Invalid SSO Metadata": "Incapable d'enregistrer la configuration SSO. Vérifiez le type et l'emplacement des métadonnées.",
    "No Snapshots found for the above date range.": "Aucun instantané trouvé pour la périoide spécifiée.",
    "ConfigureSharePoint": "Configuration des identifiants SharePoint",
    "Sharepoint Configuration": "Configuration SharePoint",
    "Select the field to translate based on the end-user's language settings.": "Sélectionner le champ à traduire selon les paramètres de langue de l'utilisateur.",
    "Enable Automatic Archives to Begin Configuring Automated Delta Report Emails": "Activer les archives automatisés afin d'ajouter les addresses électroniques pour recevoir les rapports delta.",
    "Skype": "Skype",
    "Move Manager": "Déplacer le gestionnaire",
    "planinfo": "Info du plan",
    "Move Out Manager": "Déplacer le gestionnaire à l'extérieur",
    "Filtered Records will be removed when possible": "Enregistrements filtrés seront retirés chaque fois que possible",
    "Field Mapping": "Attribution de champs",
    "email": "addresse électronique",
    "Create an Archive to begin making use of Delta Reports": "Avant de pouvoir générer un rapport delta, il faut archiver un organigramme",
    "Add Fields to Table": "Ajouter des champs au tableau",
    "Filtered records will show with a filter overlay": "Enregistrements filtrés seront affichés en gris",
    "Hyperlink": "Hyperlien",
    "BuilderNoMasterChartsNotAdmin": "Le Builder nécessite un Master Chart afin de générer rapidement un organigramme. Contactez votre adminstrateur système pour configurer votre compte.",
    "Do you want to create a manual Archive for": "Souhaitez-vous créer manuellement une archive pour",
    "restrictedfiletypeupload": "Pour télécharger ce type de fichier, allez à Workbench --> Document --> Gestionnaire de fichiers",
    "ExportIndexPage": "Quand vous exportez avec une page index, le téléchargement est restreint à l'organigramme entier",
    "Configure dedicated API photo connectors.": "Configurer une source de données dédiée aux photos.",
    "Filtered records other than managers will be removed from the chart when possible": "Les enregistrements filtrés (sauf ceux qui sont gestionnaires) seront retirés de l'organigramme",
    "Desired Holders": "Nombre de titulaires désirés",
    "Edit Fields": "Modifier les champs",
    "Plan Builder Position Directions": "Saissez un nom pour votre plan, choisissez un point de départ, et commencez à plannifier !",
    "Diversity": "Diversité",
    "enterorgsizeh": "Combien d'employés compte votre entreprise ?",
    "selecttopofchart": "Sélectionner l'employé qui devrait au sommet de l'organigramme de la liste ci-dessous",
    "Holder": "Titulaire",
    "Do not automatically format document layout": "Ne pas formater automatiquement la présentation du document",
    "enterAttributeName": "Saisir l'attribut d'assertion SAML pour l'ID de nom",
    "Welcome to OrgChart": "Bienvenue à OrgChart",
    "I Use an HRIS System": "J'utilise un système RH",
    "No API Support": "On n'est pas encore avoir une connexion API à ce système. Veuillez cliquer ici pour signaler votre intérêt.",
    "Select Append Data Source": "Sélectionner la source de données à ajouter",
    "Field Picker": "Rouleau de champs",
    "Refresh Now": "Actualiser",
    "Maximum character limit reached": "La limite maximum de caractères a été atteinte",
    "deleteOpenConfirm2": "Vous-avez supprimé l'organigramme actuel. Afin d'ouvrir un nouveau organigramme, fermez le panneau paramètres du compte, et puis en sélectionnez un nouveau du menu déroulant (marqué Organigramme).",
    "Review": "Réviser",
    "Core": "de base",
    "SAML attributes": "Attributs d'assertion SAML",
    "Open Image": "Ouvrir l'image",
    "Assign Data Source": "Sélectionner une source de données pour commencer",
    "Build Position Plan": "Quel poste devrait être au sommet de l'organigramme pour ce plan",
    "addcoheadsplancb": "Créer un plan avec co-dirigeants",
    "estimateorgsize": "Une estimation suffit. vous pouvez ajouter ou supprimer des employés ultérieurement.",
    "Case Insensitive Match": "Correspondance insensible à la casse",
    "About API": "Synchroniser les données de mon système RH",
    "cohead": "Co-dirigeants",
    "Map positions from source data": "Mapper les postes des données de base",
    "redirectToIDP": "En train de vous rediriger à votre fournisseur d'identité",
    "Currently Applied": "appliqué",
    "SAML NameID Attribute": "Attribut d'assertion SAML pour l'ID de nom",
    "Column Mapping": "Mapping des colonnes",
    "enterAttributeNameID": "Saisir l'attribut d'assertion pour l'ID de nom",
    "deleteOpenConfirm1": "Voulez-vous vraiment supprimer cet organigramme ?L'organigramme actuellement ouvert sera fermé, dès que vous enregistrez vos changements.",
    "FieldAccessReminder": "La sécurité au niveau des lignes s'applique à chaque Master Chart. Les champs et valeurs disponibles dans le rouleau de champs sont associés avec le Master Chart actuellement ouvert. Afin d'y ajouter des champs d'un autre Master Chart, veuillez fermer ce panneau, selectionnez un Master Chart du menu déroulant (marqué « Organigramme »), et puis rouvrez cette interface.",
    "No chart data loaded mobile": "Les données ne chargent pas. Sélectionner le bouton « Actualiser » dans le menu Outils ci-dessous pour charger les données. Si le problème persiste, configurer l'organigramme sur le site web (version complète) d'OrgChart",
    "failedauth": "L'authentication a échouée",
    "Choose Plan Name": "Saisir le nom du plan",
    "Manual Chart": "Organigramme manuel",
    "Launch directory with all records": "Lancer le répertoire avec les enregistrements affichés",
    "navtorec": "Naviguez à l'enregistrement",
    "HRIS Connection": "Connexion SIRH",
    "Select Main Data Source": "Sélectionner la principale source de données",
    "Blank Notification": "Ce message n'a pas de contenu.",
    "Interactive Highlighting": "Surbrillance interactive",
    "Enable Direct Sign-In": "Permettre aux utilisateurs de se connecter directement au serveur",
    "Select Photo Data Source": "Sélectionner la source de données photo",
    "selectfields": "Sélectionner les champs à inclure dans les données de l'organigramme",
    "Legacy": "Système ancien",
    "Select Merge Data Source": "Sélectionner la source de données à fusionner",
    "Org Size": "Taille de l'organisation",
    "AggregatedField": "Champ agrégé",
    "Personal": "Personnel",
    "Start From Scratch": "Partir de zéro",
    "Direct Sign-In": "Connexion directe",
    "StaticFormula": "Formule statique",
    "This chart exceeds your total box limit": "Cet organigramme dépasse la limite du nombre total de cases",
    "reviewmanual": "Si tout est correct, cliquez sur « Terminer » pour finaliser la configuration",
    "enterAttributeEmail": "Saisir l'attribut d'assertion SAML pour l'adresse électronique",
    "Behavior": "Comportement",
    "New Blank": "Document vierge",
    "ssoautoproinfotext": "Créer automatiquement les nouveaux utilisateurs lorsque les utilisateurs (qui n'existent pas déjà dans l'application) se connectent.",
    "Allow Photo Search": "Permettre la recherche des photos",
    "Select File": "Sélectionner le fichier",
    "Start From File": "Commencer avec un fichier",
    "invalidchartappend": "Il faut ouvrir un master chart dans le viewer afin de commencer à configurer un tableau joint.",
    "Blank Message": "Les messages seront affichés ici",
    "genericsave": "Voulez-vous enregistrer vos modifications ? Tous les changements non enregistrés seront perdus.",
    "Editor Tools": "Outils de modification",
    "Select Top of Chart": "Sélectionner le sommet de l'organigramme",
    "Build Position Chart": "Quel poste devrait être au sommet de l'organigramme pour ce plan",
    "Disable Direct Sign-In": "Désactiver la connexion directe",
    "Upload Image": "Télécharger un image",
    "Enable SSO": "Activer la connexion SSO",
    "Select Background": "Sélectionner le fond",
    "SAML Name Attribute": "Attribut d'assertion SAML pour l'ID de nom",
    "openchartdoc": "Ouvrir le document",
    "Notification Center": "Centre de notification",
    "Recently Opened Charts": "Les organigrammes ouverts récemment",
    "Please Select Field": "Veuillez sélectionner un champ valide",
    "Edit Users": "Modifier les utilisateurs",
    "Open Existing": "Ouvrir un fichier existant",
    "Open In Editor": "Ouvrir dans l'éditeur",
    "Delete Sharepoint": "Supprimer la configuration SharePoint",
    "Enum Table": "Tableau énuméré",
    "openbackground": "Ouvrir le fond",
    "About manualchart": "Entrez manuellement les données",
    "Open Editor": "Ouvrir l'éditeur",
    "signInDisabled": "La connexion directe a été désactivée. Pour en savoir plus, veuillez contacter votre administrateur.",
    "About Background Editor": "Configurer les fonds",
    "SAML Email Attribute": "Attribut d'assertion SAML pour l'adresse électronique",
    "Plan Builder Directions": "Saissez un nom pour votre plan, choisissez un point de départ, et commencez à plannifier",
    "Chart Builder Directions": "Choisir un point de départ, et puis cliquer sur « Construire » pour créer un organigramme",
    "Select Build Chart Level": "Combien de niveaux organisationnels sous ce employé voulez-vous inclure",
    "No Subject": "Aucun objet",
    "ssodisableinfotext": "SSO ne peut pas être désactivé pendant que l'option de la connexion directe est désactivée.",
    "addfolder": "Ajouter un dossier",
    "single unread": "message non-lu",
    "Open Background": "Ouvrir le fond",
    "Load Mapping": "Charger le mapping",
    "Chart Builder Info": "Utiliser vos données de base pour créer un organigramme personnalisé",
    "Conflict": "Conflits détectés",
    "I Have an Excel File": "J'ai un fichier Excel",
    "Select Build Position Level": "Combien de niveaux organisationnels sous ce poste voulez-vous inclure ?",
    "Include Background": "Inclure le fond",
    "Change AutoText": "Changer le texte auto",
    "notvalidated": "Pas validé",
    "Where is your data": "Où sont les données des employés",
    "main SAML assertion": "assertion SAML principale",
    "BackgroundEditorQuickLink": "Éditeur de fond",
    "API Connection": "Connexion API",
    "Background Name": "Nom du fond",
    "No Messages": "Aucun message",
    "About Account Settings": "Gérer vos utilisateurs et paramètres de sécurité",
    "ssoenableinfotext": "Permettre/Ne pas permettre aux utilisateurs de se connecter à OrgChart en utilisant le fournisseur d'identité",
    "Default Group": "Groupe par défaut",
    "Employee PositionID": "ID de poste de l'employé",
    "reviewmanualh": "Vérifier la mise en place de l'organigramme",
    "PositionID": "ID de poste",
    "Employee": "Employé",
    "recnavprompt": "Voulez-vous naviguer au nouveau enregistrement ?",
    "multiple unread": "messages non-lus",
    "Unread": "Non-lu",
    "Unread Force Read Messages": "Vous avez un message important. il vous faut lire le message avant de quitter le centre de notification.",
    "Position Management": "Gestion de postes de travail",
    "Preexistingid": "Cet ID existe déjà dans le plan:",
    "SSO Deletion Warning": "Vous êtes en train de supprimer cette configuration SSO. Souhaitez-vous continuer ?",
    "SSO Save Warning": "Cela laissera l'organisation sans connexion SSO active. Veuillez confirmer que vous souhaitez continuer.",
    "Loading Background Editor": "En train de télécharger l'éditeur de fond",
    "Max Char Limit Warning": "Avertissement de la limite maximum de caractères",
    "enterAttributeGroup": "Saisir l'attribut d'assertion SAML pour le groupe",
    "enterorgsize": "Saissez le nombre d'employés dans votre entreprise et puis cliquez sur « Suivant »",
    "Start From Connection": "Commencer avec une connexion API",
    "selectfieldsh": "Quels champs de données voulez-vous inclure ?",
    "ssodirectinfotext": "Permettre/Ne pas permettre aux utilisateurs de se connecter directement à OrgChart.",
    "selectmapping": "Aidez-nous à comprendre vos données",
    "Allow RW Users to Refresh Master Charts": "Permettre aux utilisateurs lecture/écriture d'actualiser les Master Charts",
    "Reference Table": "Tableau de référence",
    "Yesterday": "Hier",
    "Set the group new users are created in by default.": "Définir le groupe auquel les nouveaux utilisateurs seront affectués par défaut.",
    "Picklist": "Liste de sélection",
    "No profiles defined": "Aucun profil ajouté",
    "Welcome Message 2": "On a besoin de données pour construire l'organigramme",
    "Build Employees Chart": "Quel employé devrait être au sommet de l'organigramme pour ce plan",
    "About flatfile": "Utiliser les données Excel ou CSV",
    "pinobj": "Épingler la position",
    "Background Editor": "Éditeur de fond",
    "Value Mismatch": "Décalage des valeurs",
    "sloinfotext": "Déconnecter automatiquement l'utilisateur du fournisseur d'identité lorsque l'utilisateur se déconnecte d'OrgChart.",
    "About View Manager": "Configurer les affichages et les styles de case",
    "Synthesize positional data from employees": "Synthétiser les données de poste des données des employés",
    "What View To Apply": "Quel affichage voulez-vous appliquer",
    "generateSPMetadata": "Metadonnées SAML du fourn. serv.",
    "System views cannot be modified": "Les affichages de système ne peuvent pas être modifiés",
    "Custom Filter": "Filtre personnalisé",
    "Sign-In Disabled Warning": "Voulez-vous vraiment désactiver la connexion directe ? Les utilisateurs ne seront que capable de se connecter avec SSO.",
    "Default Background Info": "Démarrez rapidement avec un fond préconfiguré",
    "Older": "Ancien",
    "Setting Up Background": "Créer un fond",
    "Positions": "Postes",
    "enumeratedtableprops": "Éditeur du tableau énuméré",
    "ManualBlank": "Laissez en blanc pour créer un organigramme de quatre employés",
    "Contact": "Coordonnées",
    "Chart Builder Position Directions": "Choisir un point de départ, et puis cliquer sur « Construire » pour créer un organigramme",
    "Page Breaks": "Saut de page",
    "I have no data": "Partir de zéro",
    "Create Field Map": "Créer une attribution de champ",
    "NameID Handling": "Traitement de l'ID de nom",
    "Recommended": "Recommandé",
    "Disable SSO": "Désactiver la connexion SSO",
    "Backgrounds": "Arrière-plans",
    "Masters": "Arrière-plans",
    "Browse Files": "Parcourir les fichiers",
    "Excel File": "Fichier Excel",
    "No Content": "Aucun contenu",
    "DeleteSharepointConfig": "Voulez-vous vraiment supprimer votre configuration SharePoint ? Cette action ne peut pas être annulée.",
    "Open a chart to begin editing View rules": "Veuillez ouvrir un organigramme afin de modifier les règles de l'affichage",
    "nochartsforplanning": "Aucun organigramme a été configuré. Veuillez cliquer ici pour configurer un organigramme.",
    "Data Fields": "Champs de données",
    "View successfully imported. Be sure to save the changes to your shared views and box styles libraries.": "L'importation de l'affichage a réussi. Veuillez enregistrer les changements dans chaque collection partagée.",
    "About Chart Settings": "Configurer la connexion API et les paramètres des données",
    "Turn On": "Activer",
    "Compensation": "Rémunération",
    "lastvalidation": "Date de dernière validation",
    "Default Background": "Fond classique",
    "Find by username or email": "Trouver par le nom d'utilisateur ou l'adresse électronique",
    "Select Language": "Sélectionner la langue",
    "Flat File": "Fichier plat",
    "BreadCrumbs": "Le fil d'ariane",
    "Build Employees Plan": "Quel employé devrait être au sommet de l'organigramme",
    "All Files": "Tous les fichiers",
    "Sign-In Enabled Warning": "Voulez-vous vraiment activer la connexion directe ? Les utilisateurs seront permettre de se connecter sans SSO.",
    "BackgroundEditorTools": "Outils",
    "Filters and Highlights": "Filtres & Surbrillances",
    "Edit Metrics": "Modifier les indicateurs",
    "Character length cannot exceed": "La longueur de caractères ne dépasse pas",
    "Create New Background": "Créer un nouveau fond",
    "uploaddatafile": "Télécharger le fichier des données",
    "Unhandled Validation": "Impossible de valider les identifiants. Veuillez vérifier que l'information est correcte. Si la validation continue à échouer, veuillez contacter notre équipe de soutien.",
    "About BackgroundEditorQuickLink": "Créer et personnaliser les fonds",
    "Active Background": "Fond actuel",
    "SSO Deletion": "Suppression de SSO",
    "Inbox": "Case de réception",
    "Select Initial Import Method": "Où sont les données des employés ?",
    "Select a message to read": "Sélectionner un message à lire",
    "Parent PositionID": "ID Poste gestionnaire",
    "mfaNotRequired": "Si vous désactivez cette fonction, les utilisateurs dans votre compte auront la capacité de se connecter sans MFA. Êtes-vous certain de vouloir continuer ?",
    "My Highlights": "Mes surbrillances",
    "Doc Settings No Source": "Ce document n'a aucune source de données. Utilisez l'editeur d'organigramme afin de gérer les enregistrements.",
    "MFA Required": "L'authentification multi-facteurs est nécessaire pour se connecter. Si vous avez besoin d'aide, contactez votre admin de compte.",
    "View Unsaved Charts": "On a récupéré un ou plusieurs organigrammes non enregistrés. Voulez-vous les examinez maintenant ?",
    "Setting Controlled by Master Chart": "Ce réglage est déterminé par le Master Chart. Pour modifier les réglages dans cette section, ouvrez le menu réglages organigramme.",
    "Presentation Support": "Cette option n'est pas encore disponible.",
    "Specify Top of Chart": "Définir la case sommet",
    "Child": "Enfant",
    "RenamedBreak": "Section rénommée",
    "viewsets": "Bibliotèques",
    "Chart Document": "Document organigramme",
    "Group Name Exists": "Veuillez utiliser un nom unique pour le groupe de filtres.",
    "Page properties": "Paramètres de page",
    "Plan Access Denied": "Accès non autorisé",
    "Resolve conflict": "Résoudre le conflit",
    "InsertedBreak": "Un saut de page a été inséré sous",
    "mfaInactivePost": "utilisateurs n'ont pas encore configuré MFA et ils ne seront pas capables de se connecter. Êtes-vous certain de vouloir continuer ?",
    "Presentation Support Link": "Si vous-voulez utiliser cette fonction, veuillez contacter notre équipe de Support.",
    "mfaAdminPreReq": "Avant d'activer MFA pour tous les utilisateurs, il vous faut configurer MFA pour votre propre utilisateur. Cliquez sur Configurer pour activer MFA.",
    "mfaStatus": "Statut MFA",
    "backgroundHotLink": "Modifier les fonds",
    "Images": "Images",
    "mfaStep2Long": "Ouvrez l'application d'authentification, et puis appuyez sur le signe plus (+). Scannez l'image à droite avec l'appareil photo.",
    "See More Fields": "Afficher plus de champs",
    "Review Unsaved Charts": "Examiner les organigrammes non enregistrés",
    "Children": "Enfants",
    "switch views": "Changer la bibliothèque",
    "step2": "Étape 2",
    "step1": "Étape 1",
    "Point In Time Chart": "Organigramme temporel",
    "Resolve": "Résoudre",
    "Record Not Found": "Enregistrement introuvable",
    "Authenticator": "Authentificateur",
    "Top of Chart": "Sommet d'organigramme",
    "My Filters": "Mes filtres",
    "ManyExistingAppends": "Plusieurs entrées existent déjà dans ce tableau joint. Cliquez sur OUI pour voir la liste des entrées.",
    "Chart Document Linked To Master Chart": "Ce document organigramme est lié au Master Chart.",
    "validCode": "Vous avez activé MFA avec succès.",
    "Plan Load Record Failure": "Cet enregistrement n'existe plus dans la source de données pour ce plan.",
    "Resolve Conflict Later": "Résoudre le conflit plus tard",
    "No Date Found": "Aucune date n'a é té trouvée",
    "Assistants": "Assistants",
    "Standard Field": "Champ standard",
    "Plan Open Failure": "Impossible d'ouvrir le plan.Vous n'avez pas les permissions néssaires pour accéder au plan ou pour voir les champs utilisés dans ce plan. Contactez votre administrateur.",
    "mfaStep1LongPre": "Téléchargez et installez une application d'authentification sur votre portable ou tablette. Les applications supportées comprennent",
    "Doc Inherits from Master Chart": "Ce document hérite des réglages du Master Chart.",
    "Recover Charts": "Récupérer les organigrammes",
    "mfaSetting": "Paramètres MFA",
    "MFA Enabled": "MFA est active et requise pour se connecter. Pour désactiver ou réconfigurer cette caractéristque de sécurité, cliquez sur le bouton réinistaliser ci-dessous.",
    "overrideMFA": "Outrepasser MFA",
    "QRCodeGen": "Le code QR a été généré avec succès.",
    "groupnamemsg": "Au moins de 3 caractères sont nécessaires pour le nom de groupe.",
    "No Changes Detected": "Aucun changement n'a été constaté.",
    "confirmationCode": "Saisissez le code de confirmation.",
    "agupdatedbody": "Utilisateurs avec ce groupe ne changeront pas avant la connexion prochaine.",
    "Reports": "Rapports",
    "mfaAuthenticator": "Authenticateur actif",
    "mfaRequired": "L'authentification multi-facteurs est nécessaire pour se connecter",
    "Show All": "Afficher Tous",
    "Disconnect": "Déconnecter de l'hiérarchie",
    "directoryHotLink": "Modifier les paramètres du répertoire",
    "switch view prompt": "Cliquez ici pour changer la bibliothèque",
    "invalidConfirmationCode": "Code de vérification non valide.",
    "Enabled": "Activée",
    "Advanced": "Options Avancées",
    "clicktoconfigure": "Cliquez ici pour configurer",
    "Changes": "Changements",
    "Disable MFA Requirement": "Permettre aux utiliasateurs de se connecter sans MFA",
    "invalidemail": "Adresse email non valide.",
    "disableMFAWarning": "Vous avez désactivé MFA avec succès.",
    "ReplaceOrAdd": "Ce tableau joint a déjà des entrées. Est-ce que vous voulez remplacer toutes les entées ou ajouter en plus ? Si vous souhaitez annuler, vous pouvez fermer ce panneau.",
    "mfaConfirmCode": "Saisir le code de vérification",
    "Page Size & Margins": "Taille et marges",
    "wrongextension": "Type de fichier sélectionné est non valide dans ce mode.",
    "Invalid File Type": "Type de fichier non valide",
    "Levels Below Topbox": "Niveaux sous la case sommet",
    "Keep MFA Requirement On": "Laisser active l'obligation de se connecter avec MFA",
    "mfaValidateFirst": "MFA ne sera pas activée avant la validation. 1. Téléchargez une application d'authentification si vous ne l'avez pas déjà fait. 2. Scannez le code QR. 3. Vérifiez le code QR.",
    "Not Configured": "Non configurée",
    "API Timeout Message": "À cause de l'intégration API, l'actualisation sera plus longue que d'habitude. Bien que vous ne puissiez pas actualiser manuellement vos données, vous pouvez toujours programmer l'actualisation automatique dans le menu Réglages organigramme > Rafraîchir",
    "multifactorauth": "Authentification multi-facteurs",
    "Presentation Not Available": "Présentation non disponible",
    "API Timeout": "Temporisation API",
    "Chain of Command Levels": "Niveaux de chaîne de commande au-dessus de la case sommet d'organigramme",
    "ExistingAppend": "L'entrée existe déjà. Cliquez OUI pour voir l'entrée existante.",
    "See Less Fields": "Cacher les champs",
    "Import From": "Importer de",
    "Unsaved Charts": "Documents non-sauvgaurdés",
    "invalidCode": "Code de vérification non valide.",
    "Flat Files": "Fichiers Plats",
    "Levels Below Top of Chart": "Niveaux au-dessous de la case sommet",
    "Confirm Resolve Conflict": "Approuver les changements et résoudre",
    "Code": "Le code",
    "Review Later": "Examiner plus tard",
    "step3": "Étape 3",
    "Required & Not Configured": "Requise et non configurée",
    "Append Remove Duplicates": "Les entrées doubles ont été trouvées. Est-ce que vous voulez consolider les entrées ? Attention: cette action ne peut pas être annulée.",
    "RemovedBreak": "Un saut de page a été enlevé sous",
    "nofilefiltermatches": "fichiers cachés. Cliquez sur le filtre d'affichage des fichiers en bas à droite pour afficher tous les fichiers.",
    "Record Info": "Infos d'enregistrement",
    "GroupNameError": "Erreur dans le nom de groupe",
    "wrongextension2": "Veuillez sélectionner un bon",
    "Revert Change and Resolve": "Annuler le changement et résoudre",
    "mfaStep2Short": "Scannez ce code QR",
    "mfaStep1Short": "Télécharger l'application",
    "Create Group": "Créer un groupe",
    "mfaStep3Long": "Lorsque le code est scanné, saisissez le code à six chiffres fourni par l'application d'authentification.",
    "Bypassed": "Contournée",
    "Email Address Required": "L'addresse email est requise",
    "mfaVerify": "Vérifier le code et activer",
    "resetAuth": "Réinitialiser l'authentificateur",
    "reqMFAWarning": "Tous les utilisateurs ont activé MFA et contineront de se connecter après vous imposez MFA. Cliquez oui pour exiger que les utilisateurs futurs utilisent MFA.",
    "Log in to your": "Connectez-vous à votre",
    "OrgChart account": "compte {gAppName}",
    "Welcome back. Please enter your credentials.": "Ravi de vous revoir. Veuillez saisir vos identifiants.",
    "Don't have an account?": "Vous n'avez pas de compte ?",
    "Sign up": "S'inscrire",
    "Configure link user": "Configurer le lien utilisateur",
    "Edit View": "Modifier la vue",
    "No Changed Fields": "Aucun champ n'a été modifié. Modifiez un champ de l'enregistrement pour créer une nouvelle modification.",
    "Edit Table": "Éditer le tableau",
    "Formula name cannot contain a period": "Le nom de la formule ne peut pas contenir de point",
    "Create filters that can be shared with other users": "Filtres partagés avec d'autres utilisateurs",
    "Create rule condition": "Créer une condition de règle",
    "Search for": "Rechercher",
    "Add folder": "Ajouter un dossier",
    "Search folder": "Rechercher un dossier",
    "Search specific folder": "Rechercher dans {folder}",
    "Search Charts": "Rechercher des organigrammes",
    "Confirm password": "Confirmer le mot de passe",
    "Create new record": "Créer un nouvel enregistrement",
    "aTitle": "Titre alternatif",
    "Include clickable navigation arrows connecting pages of the chart. May not be useful when physically printing": "Inclure des flèches de navigation cliquables reliant les pages de l'organigramme. Peut ne pas être utile lors de l'impression papier.",
    "Source chart": "Organigramme source",
    "What data fields will be used in this plan?": "Quels champs de données seront utilisés dans ce plan ?",
    "Save now": "Enregistrer maintenant",
    "No background": "Pas d'arrière-plan",
    "InvalidName": "Nom invalide",
    "Auto-sync": "Synchro. auto.",
    "Please check the following fields": "Veuillez cocher les champs suivants",
    "Modify UI Profile": "Modifier le Profil UI",
    "Enter email address(es) for notification": "Saisir un e-mail pour notification",
    "Conditional Definition": "Définition conditionnelle",
    "Unsaved": "Non sauv.",
    "Pagination changes": "Modifications de la pagination",
    "Show search fields": "Afficher les champs de recherche",
    "Show source": "Montrer la source",
    "Toggle fields to include": "Basculer les champs à inclure",
    "viewnotfound": "Vue non trouvée",
    "Chart information": "Informations organigramme",
    "Click add rule to start conditionally formatting your chart": "Cliquez sur ajouter une règle pour commencer à formater votre organigramme de manière conditionnelle",
    "Turn off MFA": "Désactiver MFA",
    "Reports filter": "Filtrer les rapports en fonction de l'organigramme de base auquel ils sont liés.",
    "replacefilesnonew": "Cliquez sur \"Remplacer les fichiers existants\" pour mettre à jour les fichiers existants dans ce répertoire ou sur \"Annuler\" pour annuler le téléchargement.",
    "Update the automated rules driving chart presentation.": "Mettre à jour les règles automatisées qui régissent la présentation des organigrammes.",
    "Enter formula rule": "Saisissez ici la règle de la formule :",
    "Plan changes": "Modifications du plan",
    "Do you want to resume work in your last open report?": "Voulez-vous reprendre le travail dans votre dernier rapport ouvert ?",
    "Picklist options": "Options de la liste de sélection",
    "Picklist type": "Type de liste de sélection",
    "Enter email address(es) for auto-export": "Saisissez l'adresse e-mail pour l'export automatique",
    "Delete Table": "Supprimer une table",
    "Create group mapping": "Créer une cartographie de groupe",
    "Hierarchy": "Hiérarchie",
    "Select Build Chart Level Directions": "Choisissez le nombre de niveaux pour modifier la profondeur de votre organigramme",
    "deleterows": "Supprimer des lignes",
    "Box layout editor": "Éditeur de mise en page de cases",
    "Include a page at the end of the export with name and number": "Inclure une page à la fin de l'export avec le nom de chaque employé et le numéro de page correspondant.",
    "autoassignwarningmessage": "Avertissement : Cette fonction s'applique à l'ensemble de votre compte. Si vous activez cette fonction sans la configuration appropriée, vous risquez de vous bloquer et de verrouiller l'accès de tous vos utilisateurs à OrgChart.\n\nÊtes-vous sûr de vouloir continuer ?",
    "Use 24 hour clock": "Utiliser l'horloge 24 heures",
    "Open Last Report": "Ouvrir le dernier rapport",
    "Custom Chart": "Organigramme personnalisé",
    "Discard": "Rejeter",
    "Align Objects Top": "Aligner les objets en haut",
    "Enter confirmation code": "Saisir le code de confirmation",
    "Reset Charts": "Réinitialiser les organigrammeues",
    "Date Time Format": "Format de date et d'heure",
    "You must select a UI profile": "Vous devez sélectionner un profil UI",
    "This plan has changes that are no longer valid": "Ce plan a subi des modifications qui ne sont plus valables",
    "Level up": "Remonter d'un niveau",
    "Saved": "Enregistré",
    "Invalid Date": "Date invalide",
    "insertcolleft": "Insérer 1 colonne à gauche",
    "Position file": "Fiche de poste",
    "Basic info": "Informations générales",
    "Level down": "Niveau inférieur",
    "Rule comparison": "Comparaison des règles",
    "Create new reports of your organization, or run saved reports": "Créer de nouveaux rapports pour votre organisation, ou exécuter des rapports enregistrés",
    "Custom SLO Endpoint": "Point d'accès SLO personnalisé",
    "Username": "Nom d'utilisateur",
    "Choose file": "Choisir un fichier",
    "Create checkpoint": "Créer un point de contrôle",
    "Finish editing your view to update these rules": "Terminer l'édition de votre vue pour mettre à jour ces règles",
    "Add highlights": "Ajouter des surbrillances",
    "Resolve later": "Résoudre ultérieurement",
    "Select sort field": "Sélectionner un champ de tri",
    "Remove value from field": "Supprimer la valeur du champ",
    "minsubbreaksinfo": "Spécifier le nombre minimum de cases requises pour l'insertion d'une rupture de sous-organigramme. Cette option permet de réduire le nombre de pages de l’organigramme généré.",
    "Allowed views": "Vues autorisées",
    "Enter prefix": "Saisir un préfixe",
    "Add field": "Ajouter un champ",
    "Chart details": "Détails de l’organigramme",
    "Top of chart": "Haut de l’organigramme",
    "Show plans not shared with me": "Afficher les plans non partagés avec moi",
    "topRight": "En haut à droite",
    "Notifications": "Notifications",
    "Edit Record": "Modifier l'enregistrement",
    "Would you like to apply layout changes": "Souhaitez-vous appliquer les modifications de la mise en page de la case ?",
    "Delete formula": "Supprimer la formule",
    "Approved positions file": "Fichier des positions approuvées",
    "Automatically save changes": "Enregistrer automatiquement les modifications",
    "Layout Editor": "Éditeur de mise en page",
    "Show conflicts only": "Afficher uniquement les conflits",
    "Invalid name": "Nom non valide. Ne peut pas inclure",
    "Minimum length is 2 characters": "La longueur minimale est de 2 caractères",
    "passcommon": "Le mot de passe est trop commun. Veuillez essayer un autre mot de passe",
    "Save background alert": "Souhaitez-vous enregistrer une copie de votre arrière-plan actuel afin qu'il puisse être utilisé par d'autres organigrammes ?",
    "Background changes will be saved as a new background": "Les modifications apportées à l'arrière-plan seront enregistrées en tant que nouvel arrière-plan.",
    "Add more": "Ajouter plus",
    "Find changes": "Rechercher des modifications",
    "Cannot edit rule background": "Impossible de modifier l'arrière-plan lorsqu'il est appliqué à une vue active.",
    "Finish editing layout": "Terminer l'édition de la mise en page",
    "Filter by status": "Filtrer par statut",
    "Name cannot be blank": "Le nom ne peut pas être vide",
    "Insert break": "Insérer une rupture",
    "Insert field": "Insérer un champ",
    "Language": "Langue",
    "Specify endpoint": "Spécifier le point terminal",
    "Treat UTC 0 as Local Browser Time": "Utiliser l'heure UTC 0 comme heure locale du navigateur",
    "View library": "Voir la bibliothèque",
    "sourcenotfound": "Source non trouvée",
    "Copy link": "Copier le lien",
    "Include elements on the background, such as logos, legends, tables, and page numbers": "Inclure des éléments de l'arrière-plan, tels que des logos, des légendes, des tableaux et des numéros de page.",
    "Click here to select data source": "Cliquez ici pour sélectionner la source de données",
    "Manage available views": "Gérer les vues disponibles",
    "Configure a flag and label for the selected boxes": "Configurer un drapeau et une étiquette pour les cases sélectionnées",
    "Create report": "Créer un rapport",
    "Record": "Enregistrement",
    "Dynamic formula": "Formule dynamique",
    "Reset view": "Réinitialiser la vue",
    "Save copy": "Enregistrer la copie",
    "automaticarchive": "Archivage automatique",
    "No top box specified": "Pas de case supérieure spécifiée",
    "Destination": "Destination",
    "Find branches": "Recherche de branches",
    "Default levels": "Niveaux par défaut",
    "Configure group field mapping": "Configurer la cartographie des champs de groupe",
    "Specify page size": "Spécifiez la taille de la page",
    "No highlights have been added": "Aucune surbrillance n'a été ajoutée",
    "Maps to": "Mises en correspondance avec",
    "Background Settings": "Paramètres d'arrière-plan",
    "No plan description": "Pas de description de plan",
    "Save and run": "Sauv. et exéc.",
    "Select organization": "Sélectionner l'organisation",
    "There are no reference tables": "Il n'y a pas de tables de référence",
    "Open report explorer": "Ouvrir l'explorateur de rapports",
    "Site": "Site",
    "Add data source": "Ajouter une source de données",
    "Change data source": "Changer la source de données",
    "Self level info": "La valeur utilisée est l'enregistrement organigramme de l'utilisateur actuel.",
    "Inserted subchart break": "Insertion d'une rupture dans le sous-organigramme",
    "Resume last open report": "Reprendre le dernier rapport ouvert ?",
    "Powerpoint document": "Document powerpoint",
    "Create rule comparison": "Créer une règle de comparaison",
    "Apply filter": "Appliquer un filtre",
    "Main data": "Données principales",
    "Which boxes should this rule apply to?": "À quelles cases cette règle doit-elle s'appliquer ?",
    "Your chart has an automatic sort configuration applied": "Une configuration de tri automatique a été appliquée à votre organigramme. Pour trier manuellement vos cases, supprimez la configuration de tri automatique dans l'onglet de tri de votre barre latérale.",
    "Selected field label": "Étiquette du champ sélectionné",
    "Select chart to configure": "Sélectionner l'organigramme à configurer",
    "OR": "OU",
    "Deselect All": "Désélectionner tout",
    "reqFieldNotMapped": "Veuillez indiquer le champ obligatoire.",
    "Field value criteria": "Critères de valeur du champ",
    "Remove data source": "Supprimer la source de données",
    "Use OAuth2.0 Authentication": "Utiliser l'authentification OAuth2.0",
    "Edit formula": "Modifier la formule",
    "Chart Explorer": "Explorateur d'organigrammes",
    "Loading archive": "Chargement des archives",
    "Subchart name field": "Champ du nom du sous-organigramme",
    "LinkUserNotSelectedError": "Veuillez sélectionner un lien utilisateur",
    "Notify people": "Notifier les personnes",
    "Creating Archive": "Création d'une archive",
    "Unable to find topbox": "Impossible de trouver la topbox",
    "Select a new topbox": "Sélectionner une nouvelle case sommet",
    "recordField": "Champ d'enregistrement",
    "Privacy policy": "Politique de confidentialité",
    "Selected background": "Arrière-plan sélectionné",
    "Saved filters": "Filtres enregistrés",
    "Delete element": "Supprimer un élément",
    "Create New Table": "Créer un nouveau tableau",
    "CreateFieldMap": "Créer une cartographie des champs",
    "Show less information": "Afficher moins d'informations",
    "Valid Email Address Required": "E-mail valide requis",
    "Return using": "Retourner en utilisant",
    "Branch level security": "Sécurité au niveau de la branche",
    "Create Override": "Créer une dérogation",
    "clearformat": "Effacer le formatage",
    "ChangeAppendInfo": "Mise à jour des informations de l'enregistrement",
    "ComplexRule": "Règle complexe",
    "Create new conditional rule": "Créer vos propres conditions pour définir des critères de règles complexes",
    "Enter formula name": "Saisir le nom de la formule",
    "Add field value to rule criteria": "Ajouter une valeur de champ aux critères de la règle",
    "Refresh from source": "Actualiser à partir de la source",
    "passincnum": "Contient au moins un nombre",
    "Select which charts should use this background by default": "Sélectionnez les organigrammes qui doivent utiliser cet arrière-plan par défaut.",
    "datagroupmapping": "Mappage des groupes de données",
    "Value mismatches": "Non-concordance des valeurs",
    "Duplicate view": "Vue dupliquée",
    "Choose which fields to include in the order in which they will appear. Drag fields from one column to the other.": "Choisissez les champs à inclure dans l'ordre dans lequel ils apparaîtront. Faites glisser les champs d'une colonne à l'autre.",
    "Create custom chart": "Créer un organigramme personnalisé",
    "Apply pagination settings?": "Appliquer les paramètres de pagination ?",
    "Start breaks at": "Démarrer les ruptures à",
    "View rules": "Règles d'affichage",
    "OptFieldMap": "Correspondance des champs facultative",
    "Label and value": "Étiquette et valeur",
    "Default background": "Arrière-plan par défaut",
    "Changes will be applied next data refresh": "Les modifications seront appliquées après la prochaine actualisation des données",
    "Margin": "Marge",
    "Edit Whitelist Domain": "Modifier le domaine de la liste blanche",
    "Save layout changes": "Enregistrer les modifications",
    "Report owner": "Propriétaire du rapport",
    "Saving": "Sauvegarde",
    "Download this screen": "Télécharger cet écran",
    "Clear search filters": "Effacer les filtres de recherche",
    "Some sources require additional photo configuration in order to pull photos": "Certaines sources requièrent une configuration supplémentaire pour l'extraction des photos.",
    "nosubchartupdate": "Le panneau des sous-organigrammes ne sera pas mis à jour tant qu'une actualisation n'aura pas été effectuée.",
    "Set picklist": "Définir la liste de sélection",
    "Choose which boxes (some boxes or all boxes) for this rule to target": "Choisir les cases (certaines cases ou toutes les cases) à cibler pour cette règle",
    "Select formula field": "Sélectionner le champ de la formule",
    "No Name": "Pas de nom",
    "Click + to add an operation": "Cliquez + pour ajouter une opération",
    "Configure field mapping": "Configurer le mapping des champs",
    "Display Name": "Afficher le nom",
    "No rule conditions": "Aucune condition de règle. Cliquez ici pour en ajouter.",
    "Currently used seats": "Sièges actuellement utilisés",
    "Create new user": "Créer un nouvel utilisateur",
    "record": "enregistrement",
    "Create highlights that can be shared with other users": "Mises en évidence partagées avec d'autres utilisateurs",
    "Report explorer": "Explorateur de rapports",
    "Create formula": "Créer une formule",
    "Function": "Fonction",
    "Report Blank": "Le nom du rapport ne peut pas être vide.",
    "Mouse controls": "Réglages souris",
    "Fields and formulas": "Champs et formules",
    "Create new group": "Créer un nouveau groupe",
    "Report information": "Informations sur les rapports",
    "Subchart sorting": "Tri des sous-organigrammes",
    "Export a higher quality image to embed into a Word document or PowerPoint presentation": "Exporter une image de meilleure qualité pour l'intégrer dans un document Word ou une présentation PowerPoint",
    "Data Source Details Unavailable": "Certains détails de l’organigramme peuvent être indisponibles pour les organigrammes plus anciens.",
    "AutoPopulateViewsFailure": "La limite maximale d'affichage a été atteinte (10) pour cet organigramme. Veuillez supprimer une vue avant d'en ajouter une autre.",
    "Distribute Space Vertical": "Distribuer l'espace verticalement",
    "deletefield": "Champ",
    "Validate": "Valider",
    "Reports to": "Se rapporte à",
    "LoadMap": "Charger la cartographie des champs",
    "Enable automatic clean-up": "Activer le nettoyage automatique",
    "Create new filter": "Créer un nouveau filtre",
    "bypasstemplatelistwarning": "Les utilisateurs autorisés à modifier les vues et les styles de cases pourront voir et modifier toutes les vues partagées du compte.",
    "Apply to all subcharts": "Appliquer à tous les sous-organigrammes",
    "Apply to chart": "Appliquer à l'organigramme",
    "Look up using": "Rechercher en utilisant",
    "Filter by chart": "Filtrer par organigramme",
    "Requirement": "Exigence",
    "Value only": "Valeur uniquement",
    "Revert All Changes": "Annuler toutes les modifications ?",
    "Run": "Exécuter",
    "Line weight": "Épaisseur de la ligne",
    "More options view": "Plus d’options de vue",
    "Application details": "Détails de l'application",
    "Select frequency": "Sélectionner la fréquence",
    "mergeall": "Fusionner tout",
    "Match using": "Faire correspondre à l'aide de",
    "Set which formatting or style properties should apply to boxes that meet the criteria above": "Définir les propriétés de formatage ou de style à appliquer aux cases qui répondent aux critères ci-dessus",
    "Edit this chart to adjust the filter": "Modifier cet organigramme pour ajuster le filtre",
    "Wrap text": "Envelopper le texte",
    "Edit this custom chart": "Modifier cet organigramme personnalisé",
    "Reporting": "Rapports",
    "Append Tables": "Annexer des tableaux",
    "Exclude all": "Exclure tout",
    "passincupp": "Contenir au moins un caractère majuscule",
    "lastarchive": "Dernière archive",
    "maxboxlimiterr": "Vous avez dépassé le nombre maximum de cases autorisées sur une seule page. Les administrateurs peuvent modifier cette limite",
    "Filter behavior": "Filtrer le comportement",
    "Manage access": "Gérer l'accès",
    "bottomLeft": "En bas à gauche",
    "insertrowbelow": "Insérer 1 ligne en dessous",
    "Cell formatting": "Formatage des cellules",
    "Conflict detected": "Conflit détecté",
    "Add value to field": "Ajouter une valeur à un champ",
    "autoassignwarningheader": "Activer l'attribution automatique des groupes ?",
    "Box height": "Hauteur de la case",
    "Tenant ID": "ID du titulaire",
    "Allowed highlights": "Surbrillances autorisées",
    "Plans": "Plans",
    "fieldFormatWarning": "Les règles ne peuvent appliquer qu'un seul changement de format de champ à la fois. Créez des règles organigrammes supplémentaires pour appliquer davantage de modifications de format de champ à votre organigramme.",
    "Target field": "Champ cible",
    "Chart background": "Arrière-plan de l'organigramme",
    "Field lookup": "Recherche de champ",
    "Rule definition": "Définition de règle",
    "Ensure all boxes on each page are identically sized. This generally means boxes will be smaller than usual to accomodate large pages": "Assurez-vous que toutes les cases de chaque page sont de taille identique. Cela signifie généralement que les cases seront plus petites que d'habitude pour satisfaire aux exigences des grandes pages.",
    "topLeft": "En haut à gauche",
    "Available views": "Vues disponibles",
    "Elements": "Éléments",
    "App preferences": "Préférences de l'app",
    "Select fields included in delta report": "Sélectionner les champs inclus dans le rapport delta",
    "Photos": "Photos",
    "Top box of chart": "Case supérieure de l'organigramme",
    "Use approved positions table": "Utiliser le tableau des positions approuvées",
    "Schedule Chart Refresh": "Planifier l'actualisation de l'organigramme",
    "Open chart explorer": "Ouvrir l'explorateur d'organigrammes",
    "Please wait": "Veuillez patienter",
    "Shared users": "Utilisateurs partagés",
    "Revert to source": "Revenir à la source",
    "Basic math operation": "Opération mathématique de base",
    "Date from": "Date à partir de",
    "Choose date": "Choisir une date",
    "Unable to sort": "Impossible de trier",
    "Create metrics": "Créer des mesures",
    "Use existing background": "Utiliser l'arrière-plan existant",
    "Select value": "Sélectionner la valeur",
    "Separator": "Séparateur",
    "Enter Target Value": "Saisir la valeur cible",
    "Move element": "Déplacer un élément",
    "Revert to": "Revenir à",
    "Formatting changes": "Modifications de formatage",
    "after": "après",
    "Date to": "Date à",
    "Cannot change background. This view is applying a rule driven background.": "Impossible de modifier l'arrière-plan. Cette vue applique un arrière-plan basé sur des règles.",
    "Use tree style for singles": "Utiliser le style arborescent pour les simples",
    "Treat value as": "Traiter la valeur comme",
    "Value comparison": "Comparaison de valeurs",
    "Branch level info": "Le niveau de la branche vérifiera si un enregistrement est présent dans la branche de l'utilisateur actuel.",
    "Titles": "Titres",
    "New plan": "Nouveau plan",
    "Disable MFA requirement": "Désactiver l'exigence MFA",
    "Create custom rule": "Créer une règle personnalisée",
    "Contact plan owner to add additional fields": "Contactez le propriétaire du plan pour ajouter des champs supplémentaires",
    "Use (Legacy) API Key": "Utiliser une clé API (héritée)",
    "White": "Blanc",
    "Enable MFA requirement": "Activer l'exigence MFA",
    "Target value": "Valeur cible",
    "Recalculating": "Recalculer",
    "Link copied": "Lien copié dans le presse-papiers",
    "See Reports": "Voir rapports",
    "Aux details": "Ajouter des rapports auxiliaires qui existent dans vos données",
    "Vertical align": "Alignement vertical",
    "What would you like to do with this record": "Que souhaitez-vous faire de cet enregistrement ?",
    "Field Label": "Étiquette du champ",
    "Use Table": "Utiliser le tableau",
    "bottomRight": "En bas à droite",
    "Set the top box and add co-heads": "Définir la case supérieure et ajouter des co-titres",
    "Preferred Last": "Dernier préféré",
    "Default mode": "Mode par défaut",
    "Add custom gradient": "Ajouter un dégradé personnalisé",
    "Seat limit": "Limite de sièges",
    "Make a copy": "Faire une copie",
    "Download report": "Télécharger le rapport",
    "Max box limit for single page": "Limite maximale de cases pour une seule page",
    "disconnected record": "enregistrement déconnecté",
    "Disconnected": "Déconnecté",
    "Delimiter": "Délimiteur",
    "Save changes to filter": "Enregistrer les modifications apportées au filtre",
    "Constrained": "Contraint",
    "Upload file": "Télécharger le fichier",
    "Continue Reporting": "Poursuivre le rapport",
    "Edit import filter": "Modifier le filtre d'import",
    "disconnected records": "enregistrements déconnectés",
    "Enter break character": "Saisir un caractère de rupture",
    "Conditions": "Conditions",
    "Create dynamic formula": "Créer une formule dynamique",
    "Refine your search": "Affiner votre recherche",
    "IAT endpoint": "Point terminal de l'IAT",
    "Enter postfix": "Saisir le postfixe",
    "mergeField": "Fusionner les champs",
    "deletevalues": "Valeurs",
    "Choose operation": "Choisir l'opération",
    "reqFieldsNotMapped": "Impossible d'actualiser les données tant que tous les champs obligatoires n'ont pas été mappés.",
    "Data sync automatic": "Les données sont synchronisées automatiquement.",
    "Branch pruning": "Élagage des branches",
    "Clear all": "Effacer tout",
    "Time": "Durée",
    "Revert all changes to": "Rétablir toutes les modifications",
    "Confirm field revert": "Êtes-vous sûr de vouloir rétablir la valeur source de ce champ ?",
    "No values have been added": "Aucune valeur n'a été ajoutée",
    "Model, filter, and build your own custom chart off the shared base chart": "Modéliser, filtrer et créer votre propre organigramme personnalisé à partir de l’organigramme de base partagé.",
    "Edit user": "Modifier l'utilisateur",
    "Email MFA setup link": "E-mail du lien de configuration du MFA",
    "Advanced search fields": "Champs de recherche avancée",
    "Delete criteria": "Supprimer des critères",
    "No Tables Exist": "Aucun tableau n'existe. Cliquez ici pour gérer tous les tableaux.",
    "What should be done to those boxes?": "Que faut-il faire de ces cases ?",
    "Applied by": "Appliqué par",
    "Application Security": "Sécurité de l'application",
    "Append data": "Annexer des données",
    "Merge data": "Fusionner les données",
    "Would you like to save layout changes": "Souhaitez-vous enregistrer les modifications apportées à la mise en page ? Toutes les vues utilisant ce style de case seront mises à jour.",
    "Would you like to save layout changes plural": "Souhaitez-vous enregistrer les modifications apportées à la mise en page ? Toutes les vues utilisant ces styles de case seront mises à jour.",
    "exportusers": "Exporter des utilisateurs",
    "Finish editing your chart to update these rules": "Terminer l'édition de votre organigramme pour mettre à jour ces règles",
    "Include terminated employees": "Inclure les employés licenciés",
    "mfaActive": "L'authentification multi-facteurs est active",
    "Select format": "Sélectionner le format",
    "Included fields": "Champs inclus",
    "Allowed filters": "Filtres autorisés",
    "Renamed Subchart": "Renommer le sous-organigramme",
    "Add sort key": "Ajouter une clé de tri",
    "All changes will be lost": "Toutes les modifications seront perdues",
    "This chart only": "Cet organigramme uniquement",
    "Last run": "Dernière exécution",
    "Active on leave": "Actif en arrêt de travail",
    "Currently used boxes": "Cases actuellement utilisées",
    "List options": "Options de liste",
    "Removed subchart break": "Suppression de la rupture du sous-organigramme",
    "level": "niveau",
    "Please choose how you want background changes to be saved": "Veuillez choisir la manière dont vous souhaitez que les modifications de l'arrière-plan soient enregistrées",
    "deltareportconfiguration": "Configuration du rapport delta",
    "No chart name": "Pas de nom d'organigramme",
    "Name your background": "Nommez votre arrière-plan",
    "fullaccess1": "Accès complet + rôle de lecture/écriture",
    "Only existing OrgChart users can access this link": "Seuls les utilisateurs existants d'OrgChart peuvent accéder à ce lien.",
    "You must select a role": "Vous devez sélectionner un rôle",
    "Allowed folders": "Dossiers autorisés",
    "MFA Setup": "Configuration MFA",
    "Link user": "Lien utilisateur",
    "Invalid input": "Entrée invalide",
    "selectchart": "Sélectionner un organigramme",
    "Data sync not automatic": "Les données ne sont pas synchronisées automatiquement",
    "AuxRepMapping": "Mappage des rapports auxiliaires",
    "Rename failure": "Échec du renommage",
    "Enumerated Table": "Tableau énuméré",
    "MFA status": "Statut MFA",
    "DPR": "DPR",
    "No import filters have been added": "Aucun filtre d'importation n'a été ajouté",
    "People with access": "Personnes ayant accès",
    "Include all": "Inclure tout",
    "insertrowabove": "Insérer 1 ligne au-dessus",
    "Applied by view": "Appliqué par vue",
    "topMiddle": "Centre supérieur",
    "Enable auto-export": "Activer l'exportation automatique",
    "Password must": "Le mot de passe doit",
    "Profile fields": "Champs du profil",
    "Background changes will apply to all charts using this background": "Les modifications de l'arrière-plan s'appliqueront à tous les organigrammes utilisant cet arrière-plan.",
    "Background right spacing": "Ajuster l'espacement par rapport à la marge de droite",
    "is invalid value": "est une valeur invalide",
    "Label only": "Étiquette seulement",
    "Create rule": "Créer une règle",
    "Client ID": "ID Client",
    "Append data sources": "Ajouter des sources de données",
    "Enter description": "Saisir une description",
    "rowsecconditional": "Les champs sont visibles lorsque toutes les conditions sont remplies",
    "Changes will appear here": "Les modifications apparaîtront ici",
    "Currently Viewing": "En cours de visualisation",
    "Terms of service": "Conditions d'utilisation",
    "Enter name here": "Entrez le nom ici",
    "Dates": "Dates",
    "IWizHeadsUp2": "Cliquez ici pour configurer les organigramme maîtres.",
    "Notify on": "Notifier le",
    "Automatically sync with source": "Synchroniser automatiquement avec la source",
    "Employee data updates hourly.":
      "Les données des employés sont mises à jour toutes les heures. Aucune actualisation manuelle n'est disponible. Seules les sources d'ajout et de fusion peuvent être actualisées à la demande.",
    "Delete filter": "Supprimer le filtre",
    "Delete filter?": "Supprimer le filtre ?",
    "Select background": "Sélectionner l'arrière-plan",
    "Show Direct Reports": "Afficher les rapports directs",
    "Revert to prior value": "Revenir à la valeur précédente",
    "Multi-Factor Authentication Settings": "Paramètres d'authentification multi-facteurs",
    "List": "Liste",
    "Open Report Explorer": "Ouvrir l'explorateur de rapports",
    "View manager": "Gestionnaire de vues",
    "DeleteAppendInfo": "Supprimer un enregistrement de l'organigramme",
    "Update existing record": "Mettre à jour un enregistrement existant",
    "Levels up": "Niveaux supérieurs",
    "Editing linked background": "Cet arrière-plan peut être lié à d'autres organigrammes.",
    "Custom chart filter": "Filtre d'organigramme personnalisé",
    "MoveAppendInfo": "Modifier le rapport hiérarchique",
    "Deleted under": "Supprimé sous",
    "Rows": "Lignes",
    "Add field value": "Ajouter une valeur de champ",
    "No background applied": "Aucun arrière-plan n'est appliqué",
    "Create new import filter": "Créer un nouveau filtre d'importation",
    "Include pre-defined system formulas, such as headcount and span of control": "Inclure des formules système prédéfinies, telles que l'effectif et l'étendue du contrôle",
    "Accessibility Report": "Rapport d'accessibilité",
    "accessibilityReportHelper": "Générer un classeur Excel à plat, conforme à la Section 508 et compatible avec les lecteurs d'écran",
    "Maximum 3 additional fields": "Trois champs supplémentaires maximum",
    "accessibilityFieldCapReached": "Maximum de trois champs supplémentaires atteint. Retirez un champ pour en inclure un autre.",
    "exportuserstip": "Exporter les utilisateurs vers un fichier Excel",
    "at": "à",
    "Add rule": "Ajouter une règle",
    "fullaccess2": "Accès complet + rôle d'administrateur",
    "Save View Changes": "Souhaitez-vous enregistrer votre vue actuelle avant de la lier à une carte maîtresse ?",
    "docMappingChanged": "Le fichier que vous avez sélectionné peut avoir un mappage différent. Sélectionnez Enregistrer et continuer pour enregistrer vos modifications actuelles et configurer le mappage.",
    "ResetMap": "Réinitialiser le mappage des champs",
    "Area under construction": "Zone en construction",
    "Border dash": "Tiret de bordure",
    "Use fields from a base chart within this background": "Utiliser les champs d'un organigramme de base dans cet arrière-plan",
    "AutoPopulateFailure": "Échec de la liaison du contenu à l'organigramme maître. Veuillez vérifier les limites de la configuration de l'organigramme et réessayer.",
    "Select fields": "Sélectionner les champs",
    "No reports": "Aucun rapport",
    "Recents": "Récents",
    "Find report": "Rechercher un rapport",
    "Field change history": "Historique des modifications de champs",
    "Show more information": "Afficher plus d'informations",
    "Show more chart details": "Afficher plus de détails sur l'organigramme.",
    "changed to": "Modifié en",
    "changed from": "Modifié de",
    "multiple values": "valeurs multiples",
    "Reassigned from": "Réaffecté de",
    "Created date": "Date de création",
    "No comments": "Aucun commentaire",
    "Your user is not permitted to access this instance of OrgChart": "Votre utilisateur n'est pas autorisé à accéder à cette instance d'OrgChart.",
    "Name your chart before turning on auto save": "Veuillez nommer votre organigramme personnalisé avant d'activer l'enregistrement automatique",
    "Filter out by type": "Filtrer par type",
    "replacefiles": "Cliquez sur \"Remplacer les fichiers existants\" pour mettre à jour les fichiers existants dans ce répertoire ou sur \"Ignorer les doublons\" pour n'ajouter que les nouveaux fichiers.",
    "On leave": "En congé",
    "Automatic delta report notifications": "Notification automatique du rapport delta",
    "Click here to add additional fields": "Cliquez ici pour ajouter des champs supplémentaires",
    "No results found": "Aucun résultat trouvé",
    "Add filters": "Ajouter des filtres",
    "Border type": "Type de bordure",
    "Moved under": "Déplacé sous",
    "This is not normally required": "Ceci n'est normalement pas nécessaire",
    "before": "avant",
    "Download entire chart": "Télécharger l’organigramme complet",
    "Base Charts": "Organigrammes de base",
    "Client secret": "Secret du client",
    "Build Employees Chart Directions": "Choisir une personne clé pour représenter le haut de votre organigramme",
    "Enable anyways": "Activer de toute façon",
    "Enter full URL here": "Entrez l'URL complète ici",
    "Resort boxes to save space": "Réduire les cases pour gagner de l'espace",
    "Create folder": "Créer un dossier",
    "Source data changes": "Modifications des données sources",
    "No description": "Pas de description",
    "beforeequal": "avant ou surle",
    "levels": "niveaux",
    "Edit configuration": "Modifier la configuration",
    "Conflicting field format changes": "Modifications conflictuelles du format des champs",
    "Merge data sources": "Fusionner les sources de données",
    "No additional fields": "Pas de champs supplémentaires",
    "Save background": "Enregistrer l'arrière-plan",
    "Directory result fields": "Répertoire des champs de résultats",
    "Edit group": "Modifier le groupe",
    "Configure Data Source": "Configurer la source de données",
    "Custom Sign-Out URL": "Se déconnecter du site au lieu de retourner à la page de connexion",
    "Box shadow": "Ombre de la case",
    "Select formula span": "Sélectionner la portée de la formule",
    "Knowledge base": "Base de connaissances",
    "Background left spacing": "Ajuster l'espacement de la marge de gauche",
    "No disconnected records": "Pas d'enregistrements déconnectés",
    "Share plan": "Plan partagé",
    "Support portal": "Portail d'assistance",
    "Find users": "Rechercher des utilisateurs",
    "Search plans": "Rechercher des plans",
    "Create security profile": "Créer un profil de sécurité",
    "Index": "Index",
    "customPlacement": "Placement personnalisé",
    "Finish editing": "Term. l'édition",
    "Name your chart": "Nommer votre organigramme",
    "Unable to save additional fields": "Impossible d'enregistrer des champs supplémentaires",
    "Remove filtered records": "Supprimer les enregistrements filtrés",
    "Edit security profile": "Modifier le profil de sécurité",
    "Viewing Chart": "Visualisation du organigramme",
    "Success and failure": "Succès et échec",
    "Set list": "Définir la liste",
    "Additional info": "Informations complémentaires",
    "Chart Builder Filter": "Souhaitez-vous appliquer des filtres pour réduire la portée de votre organigramme ?",
    "Enter name": "Saisir un nom",
    "Revert to checkpoint": "Revenir au point de contrôle",
    "Line subgroup style": "Style de sous-groupe de lignes",
    "Overlay a region of color over boxes that match the criteria": "Superposer une région de couleur sur les cases qui correspondent aux critères.",
    "More Details": "Plus de détails",
    "passinclow": "Contient au moins un caractère minuscule",
    "Text formatting": "Formatage du texte",
    "Launch Settings": "Paramètres de lancement",
    "OrgChart LLC. All rights reserved": "OrgChart LLC. Tous droits réservés",
    "Create from existing": "Créer à partir de l'existant",
    "bottomMiddle": "Centre inférieur",
    "Chart type": "Type d'organigramme",
    "No conditional formatting rules": "Pas de règles de mise en forme conditionnelle",
    "Save Background": "Enregistrer l'arrière-plan",
    "Download this branch": "Téléchargez cette branche",
    "Page Number": "Numéro de page",
    "Document status": "Statut du document",
    "Create highlight": "Créer une surbrillance",
    "Allowed values": "Valeurs autorisées",
    "No box style selected": "Aucun style de case n'est sélectionné",
    "Background changes will only be applied to this chart": "Les modifications de l'arrière-plan ne seront appliquées qu'à cet organigramme",
    "Anyone with access to the web page on which you embed this link can access OrgChart": "Toute personne ayant accès à la page web sur laquelle vous intégrez ce lien peut accéder à OrgChart",
    "Border Weight": "Taille de la bordure",
    "Select an operation to configure": "Sélectionner une opération à configurer",
    "Save as new": "Enregistrer comme nouveau",
    "replacefilenonew": "Cliquez sur \"Remplacer le fichier existant\" pour mettre à jour le fichier existant dans ce répertoire ou sur \"Annuler\" pour annuler le téléchargement.",
    "Choose field value": "Choisir la valeur d'un champ",
    "Filter by role": "Filtrer par rôle",
    "Choose an archive to build off of or create a delta report between two dates": "Choisir une archive à partir de laquelle construire ou créer un rapport delta entre deux dates",
    "Select data source": "Sélectionner la source de données",
    "Update existing": "Mettre à jour les données existantes",
    "Download activity report": "Télécharger le rapport d'activité",
    "fullaccess0": "Accès complet + rôle en lecture seule",
    "Import fields from": "Importer des champs à partir de",
    "Open file explorer": "Ouvrir l'explorateur de fichiers",
    "Moved from": "Déplacé de",
    "boxlimitwar": "Notez que le relèvement de la limite peut avoir un impact négatif sur les performances de l'application.",
    "insertcolright": "Insérer 1 colonne à droite",
    "DynFormWarn": "Ces formules ne fonctionneront pas comme prévu pour les organigrammes de base ou les plans. Veuillez utiliser des formules normales à la place.",
    "Select a new value to resolve the conflict": "Sélectionner une nouvelle valeur pour résoudre le conflit",
    "All fields restricted": "Tous les champs sont limités",
    "Select comparison": "Sélectionner la comparaison",
    "afterequal": "après ou au",
    "Anyone with this link can access OrgChart": "Toute personne ayant ce lien peut accéder à OrgChart",
    "Levels down": "Niveaux inférieurs",
    "Level 2": "Niveau 2",
    "Edit filter": "Modifier le filtre",
    "New value": "Nouvelle valeur",
    "Mute filtered records": "Mettre en sourdine les enregistrements filtrés",
    "Apply layout changes": "Appliquer les changements de présentation",
    "Last ran report": "Dernier rapport exécuté",
    "Changes effective": "Modifications effectives",
    "Include system calculations": "Inclure les calculs du système",
    "Launch chart": "Lancer le organigramme",
    "Org unit file": "Fichier d'unité d'organisation",
    "Branch rule": "Règle de branche",
    "switch to shared views to create new views": "Passer aux vues partagées pour créer de nouvelles vues",
    "BasicRule": "Règle de base",
    "Chart view": "Vue de l'organigramme",
    "Chart Builder Chart": "Organigramme du builder d'organigrammes",
    "Level 4": "Niveau 4",
    "Users with access": "Utilisateurs ayant accès",
    "Export format": "Format d'exportation",
    "Create filter": "Créer un filtre",
    "Remove access": "Supprimer l'accès",
    "UpdatingSC": "Mise à jour des noms de sous-organigrammes",
    "mergecells": "Fusionner des cellules",
    "No filters have been added": "Aucun filtre n'a été ajouté",
    "Edit field format": "Modifier le format des champs",
    "Create metric": "Créer une métrique",
    "Delete plan": "Supprimer un plan",
    "Choose to configure your report from today or select a date range": "Choisissez de configurer votre rapport à partir d'aujourd'hui ou sélectionnez une plage de dates",
    "Preferred First": "Premier choix",
    "View controls background": "Les arrière-plans sont contrôlés par une vue.",
    "Delete view": "Supprimer la vue",
    "Enter custom value": "Saisir une valeur personnalisée",
    "Chart Builder Filter Directions": "Filtrez votre organigramme pour vous concentrer sur des postes spécifiques, des départements ou d'autres critères.",
    "Download plan": "Télécharger le plan",
    "Level 3": "Niveau 3",
    "What would you like to call this plan?": "Comment voulez-vous appeler ce plan ?",
    "Choose field": "Choisir un champ",
    "Add people or groups": "Ajouter des personnes ou des groupes",
    "Conflicts detected": "Conflits détectés",
    "Text align": "Alignement du texte",
    "Saved highlights": "Surbrillances enregistrées",
    "Line style": "Style de ligne",
    "Reset your": "Réinitialiser vos",
    "Favorites": "Favoris",
    "Enter person id of top box": "Entrez l'identifiant de la personne dans la case du haut",
    "Status is current": "Le statut est actuel",
    "confirmViewRemove1": "Vous avez supprimé une ou plusieurs vues qui sont actuellement utilisées par les personnes suivantes",
    "Changes not saved automatically": "Les modifications ne sont pas automatiquement enregistrées",
    "passincspc": "Contient au moins un caractère spécial",
    "No files or folders here": "Il n'y a pas de fichiers ou de dossiers ici",
    "IWizHeadsUp1": "Information : Cette méthode d'importation de données a été remplacée.",
    "Add SSO Configuration": "Ajouter une configuration SSO",
    "Must have a valid profile name": "Le nom du profil doit être valide",
    "First Name": "Prénom",
    "bypasstemplatelist": "Contourner la liste blanche des modèles",
    "Edit highlight": "Modifier la surbrillance",
    "Formula name": "Nom de la formule",
    "Can access chart": "Peut accéder à l'organigramme",
    "Select Custom Chart": "Sélectionner un organigramme personnalisé",
    "Configured": "Configuré",
    "Automatic refresh notifications": "Notifications de rafraîchissement automatique",
    "Unconstrained": "Sans contrainte",
    "Save Report": "Enregistrer le rapport",
    "Add group mapping": "Ajouter un mappage de groupe",
    "Branch preferences": "Préférences de branche",
    "Edit dynamic formula": "Modifier la formule dynamique",
    "to": "à",
    "Use preset query": "Utiliser une requête prédéfinie",
    "Create import filter": "Créer un filtre d'importation",
    "Rule driven background": "Arrière-plan basé sur des règles",
    "Failure only": "Échec seulement",
    "Choose entry type": "Choisir le type d'entrée",
    "Change password": "Mod. mot de passe",
    "Continue editing this custom chart": "Poursuivre l'édition de ce organigramme personnalisé.",
    "Include a field that contains the reporting hierarchy for each employee": "Inclure un champ contenant la hiérarchie de reporting pour chaque employé",
    "Rule criteria": "Critères de règle",
    "No record selected": "Aucun enregistrement sélectionné",
    "duplicateuiprofile": "Le profil UI existe déjà",
    "Delete metric": "Supprimer la métrique",
    "Remove rule": "Supprimer la règle",
    "findfield": "Rechercher un champ",
    "Remove break": "Supprimer la rupture",
    "Choose fields": "Choisir les champs",
    "Show and hide fields": "Afficher et masquer les champs",
    "Subchart breaks": "Coupures dans les sous-groupes",
    "Name your custom chart": "Nommez votre organigramme personnalisé",
    "Chart archives": "Archives des organigrammes",
    "Impersonate user": "Usurper l'identité d'un utilisateur",
    "Person ID required": "L'identifiant de la personne est requis",
    "Pin": "Épingle",
    "Configure metrics": "Configurer les métriques",
    "changed": "modifié",
    "Report name": "Nom du rapport",
    "Untitled Report": "Rapport sans titre",
    "Default users as collaborators": "Utilisateurs par défaut comme collaborateurs",
    "Basic Table": "Tableau de base",
    "Customize your search with various criteria to find the perfect match": "Personnalisez votre recherche à l'aide de divers critères pour trouver la correspondance parfaite",
    "confirmViewRemove2": "avec les organigrammes existants. Une fois que vous aurez enregistré vos modifications, la ou les vues ne seront plus disponibles. Êtes-vous sûr de vouloir enregistrer vos modifications ?",
    "deletecols": "Supprimer des colonnes",
    "Dynamic formulas": "Formules dynamiques",
    "SAP OrgUnit Chart Options": "Options du organigramme SAP OrgUnit",
    "No values added. Click here to add a value": "Aucune valeur ajoutée. Cliquez ici pour ajouter une valeur",
    "Revert all field changes": "Annuler tous les changements de champs",
    "SEARCH": "RECHERCHE",
    "Customer email": "E-mail du client",
    "Chart Security": "Sécurité de l'organigramme",
    "No additional fields added": "Aucun champ supplémentaire n'a été ajouté pour l'instant",
    "Base Chart": "Organigramme de base",
    "Save changes to": "Enregistrer les changements dans",
    "Detailed data query": "Requête de données détaillées",
    "Choose views": "Choisir les vues",
    "Branch pruning info": "Les utilisateurs ne verront que les enregistrements qui correspondent aux critères de la règle spécifiée. (Recommandé pour la règle de branche \"Restreindre à la propre branche\".)",
    "importfiltersdesc": "Spécifier les données (enregistrements et champs) qui doivent être incluses ou exclues de votre organigramme lors de son actualisation. Les données filtrées à l'aide de filtres d'importation ne peuvent pas faire l'objet de recherches et n'ont pas d'incidence sur les effectifs ou d'autres formules",
    "Last Name": "Nom de famille",
    "Add new value": "Ajouter une nouvelle valeur",
    "Add custom solid color": "Ajouter une couleur unie personnalisée",
    "Account details": "Détails du compte",
    "No chart description": "Pas de description d'organigramme",
    "Invalid photo credentials": "Identifiants photo non valides",
    "Keep me signed in": "Gardez ma session ouverte",
    "Select formula type": "Sélectionner le type de formule",
    "selectcdoc": "Sélectionner le document organigramme",
    "New SupervisorID Required": "Nouveau superviseur requis pour le déplacement",
    "Revert All Confirm": "Êtes-vous sûr de vouloir annuler toutes les modifications associées à cette entrée ?",
    "Excluded fields": "Champs exclus",
    "Fields that can be chosen for Excel export": "Champs pouvant être choisis pour l'exportation Excel",
    "Fields that cannot be chosen for Excel export": "Champs qui ne peuvent pas être choisis pour l'exportation Excel",
    "Fields allowed for Excel export": "Champs autorisés pour l'exportation Excel",
    "By default, users can choose any fields permitted by their security overlay to export to excel. This feature allows you to optionally customize the list of fields your users will have access to downloading in their excel file": "Par défaut, les utilisateurs peuvent choisir n'importe quel champ autorisé par leur superposition de sécurité pour l'exportation vers Excel. Cette fonctionnalité vous permet de personnaliser facultativement la liste des champs auxquels vos utilisateurs auront accès pour télécharger dans leur fichier Excel",
    "Status is active": "Le statut est actif",
    "unmergecells": "Annuler la fusion",
    "Create new highlight": "Créer une nouvelle surbrillance",
    "Edit Append Table": "Modifier le tableau des annexes",
    "Black": "Noir",
    "Background top spacing": "Ajuster l'espacement à partir de la marge supérieure",
    "Add element": "Ajouter un élément",
    "Remove box": "Supprimer une case",
    "Enable sort": "Activer le tri",
    "EmpFieldMap": "Mappage des champs de l'employé",
    "Advanced search": "Recherche avancée",
    "Select field": "Sélectionner un champ",
    "Add Whitelist Domain": "Ajouter un domaine en liste blanche",
    "Must have a valid chart name": "Doit disposer d'un nom d'organigramme valide",
    "Pagination wizard": "Assistant de pagination",
    "No refresh history": "Pas d'historique de rafraîchissement",
    "Data changes": "Changements de données",
    "Manage Tables": "Gérer les tableaux",
    "Send Back": "Renvoyer",
    "Add criteria": "Ajouter des critères",
    "Basic math has no configurable settings": "Les mathématiques de base n'ont pas de paramètres configurables",
    "Manually archive": "Archivage manuel",
    "Export to Excel": "Exporter vers Excel",
    "Exporting archive": "Exportation de l'archive",
    "Added under": "Ajouté sous",
    "Changes saved automatically": "Les modifications sont automatiquement enregistrées",
    "Use a white background instead of a color. This option is helpful if you plan to print this file": "Utilisez un arrière-plan blanc au lieu d'une couleur. Cette option est utile si vous prévoyez d'imprimer ce fichier",
    "Remove field value from rule criteria": "Supprimer la valeur d'un champ des critères d'une règle",
    "collabplanalert": "L'accès à la planification collaborative nécessite un siège en lecture/écriture ou un siège d'administrateur. Contactez votre administrateur pour changer de type de siège",
    "Page density": "Densité de la page",
    "Disabled": "Désactivé",
    "New password must": "Le nouveau mot de passe doit",
    "Modified date": "Date modifiée",
    "selectplan": "Sélectionnez un plan",
    "Domain": "Domaine",
    "Linked View will be applied when the top box of the subchart matches the rule criteria": "La vue liée sera appliquée lorsque la case supérieure du sous-organigramme correspond aux critères de la règle",
    "Download this page": "Téléchargez cette page",
    "Background bottom spacing": "Ajuster l'espacement à partir de la marge inférieure",
    "Rules from chart": "Regles de l'organigramme",
    "Rules from view": "Regles de la vue",
    "Source info": "Informations sur la source",
    "Record details": "Details de l'enregistrement",
    "Any unsaved work will be lost.": "Tout travail non enregistré sera perdu.",
    "Trash": "Corbeille",
    "Samples": "Exemples",
    "source(s)": "source(s)",
    "12 AM": "12 du matin",
    "1 AM": "1 du matin",
    "2 AM": "2 du matin",
    "3 AM": "3 du matin",
    "4 AM": "4 du matin",
    "5 AM": "5 du matin",
    "6 AM": "6 du matin",
    "7 AM": "7 du matin",
    "8 AM": "8 du matin",
    "9 AM": "9 du matin",
    "10 AM": "10 du matin",
    "11 AM": "11 du matin",
    "12 PM": "12 de l’après-midi",
    "1 PM": "1 de l’après-midi",
    "2 PM": "2 de l’après-midi",
    "3 PM": "3 de l’après-midi",
    "4 PM": "4 de l’après-midi",
    "5 PM": "5 du soir",
    "6 PM": "6 du soir",
    "7 PM": "7 du soir",
    "8 PM": "8 du soir",
    "9 PM": "9 du soir",
    "10 PM": "10 du soir",
    "11 PM": "11 du soir",
    "change by author": "{changeDatetime} par {author}",
    "Applying filter": "Application du filtre...",
    "Loading chart": "Chargement de l'organigramme...",
    "Update sharing": "Mettre à jour le partage",
    "Entity sharing access saved": "Accès de partage de {entity} enregistré.",
    "Failed to share": "Échec du partage",
    "Shared filter banner": "Il s'agit d'un filtre partagé et toute modification s'appliquera aux utilisateurs qui y ont accès.",
    "Shared highlight banner": "Il s'agit d'une mise en surbrillance partagée et toute modification s'appliquera aux utilisateurs qui y ont accès.",
    "Delete shared filter?": "Supprimer le filtre partagé ?",
    "Delete shared highlight?": "Supprimer la mise en surbrillance partagée ?",
    "Delete shared filter confirm": "La suppression de ce filtre partagé le supprimera pour tous les utilisateurs avec lesquels il a été partagé.",
    "Delete shared highlight confirm": "La suppression de cette mise en surbrillance partagée la supprimera pour tous les utilisateurs avec lesquels elle a été partagée.",
    "Delete filter confirm": "La suppression de ce filtre le retirera de votre liste de filtres.",
    "Delete highlight confirm": "La suppression de cette mise en surbrillance la retirera de votre liste de mises en surbrillance.",
    "Shared filter copied": "{entity} copié dans 'Mes filtres'.",
    "Shared highlight copied": "{entity} copié dans 'Mes mises en surbrillance'.",
    "Entity copy created": "{entity} copié.",
    "importfiltercharterr": "Un ou plusieurs problèmes ont été détectés avec le filtre d'importation appliqué. Modifiez ou supprimez le filtre d'importation.",
    "chartScopeFilterCharterr": "Un ou plusieurs problèmes ont été détectés avec le filtre de portée du graphique appliqué. Modifiez ou supprimez le filtre de portée du graphique.",
    "Chart scope": "Portée du graphique",
    "Chart scope description": "Affichez la portée du graphique et appliquez une règle à ce graphique personnalisé.",
    "Levels under top box": "Niveaux sous l'élément supérieur",
    "Chart scope edit cc to edit": "Modifiez le graphique pour ajuster la portée du graphique.",
    "To remedy this issue: reduce the number of levels shown, adjust subchart break criteria, or apply a filter": "Pour résoudre ce problème : réduisez le nombre de niveaux affichés, ajustez les critères de rupture du sous-organigramme ou appliquez un filtre.",
    "Interactive filters": "Filtres interactifs",
    "Shared filters": "Filtres partagés",
    "Shared highlights": "Mises en surbrillance partagées",
    "My filters": "Mes filtres",
    "My highlights": "Mes mises en surbrillance",
    "Share filter": "Partager le filtre",
    "Share highlight": "Partager la mise en surbrillance",
    "Copy filter": "Copier le filtre",
    "Copy highlight": "Copier la mise en surbrillance",
    "Filter details": "Détails du filtre",
    "Highlight details": "Détails de la mise en surbrillance",
    "Back to filters": "Retour aux filtres",
    "Back to highlights": "Retour aux mises en surbrillance",
    "shared": "partagé",
    "No shared filters yet": "Aucun filtre n'a encore été partagé avec vous.",
    "No shared highlights yet": "Aucune mise en surbrillance n'a encore été partagée avec vous.",
    "A shared filter with this name already exists": "Un filtre partagé avec ce nom existe déjà sur cet organigramme.",
    "A shared highlight with this name already exists": "Une mise en surbrillance partagée avec ce nom existe déjà sur cet organigramme.",
    "Share filter info text": "Lorsqu'un filtre est partagé, seul le propriétaire peut gérer l'accès partagé et supprimer le filtre.",
    "Share highlight info text": "Lorsqu'une mise en surbrillance est partagée, seul le propriétaire peut gérer l'accès partagé et supprimer la mise en surbrillance.",
    "Share this entity with": "Partager ce {entity} avec :",
    "Show highlight": "Afficher la mise en surbrillance",
    "Hide highlight": "Masquer la mise en surbrillance",
    "Show filter": "Afficher le filtre",
    "Hide filter": "Masquer le filtre",
    "boxes for a custom chart. Try building the chart from a smaller section of your organization or apply filters to reduce the number of boxes.": "cases pour un organigramme personnalisé. Essayez de créer l'organigramme à partir d'une section plus petite de votre organisation ou appliquez des filtres pour réduire le nombre de cases.",
    "Do you want to save changes to Filters": "Voulez-vous enregistrer les modifications apportées aux filtres ?",
    "back to filter list": "Retour aux filtres",
    "back to highlight list": "Retour aux mises en surbrillance",
    "Share this plan with": "Facultatif : Partager ce plan maintenant",
    "Share Filters & Highlights": "Partager les filtres et les mises en surbrillance",
    "Filters applied tooltip": "Nombre de filtres appliqués au {document} actuellement ouvert.",
    "Employee filter": "Filtre des employés",
    "Show filter fields": "Afficher les champs de filtre",
    "No filter fields selected": "Aucun champ de filtre sélectionné. Utilisez le bouton 'Champs' pour ajouter des champs.",
    "includefilteredhelper": "Activez cette option pour inclure les responsables dont les subordonnés correspondent aux critères de filtre définis, même si ces responsables ne correspondent pas eux-mêmes à ces critères.",
    "share historical": "Partager l'historique",
    "My filters info": "Créez, gérez et appliquez des filtres sur tout type d'organigramme.",
    "My highlights info": "Créez, gérez et appliquez des mises en surbrillance sur tout type d'organigramme.",
    "Saved highlights info": "Les mises en surbrillance héritées sont gérées par les administrateurs dans les Paramètres de l'organigramme : onglet Filtres et mises en surbrillance.",
    "No highlights created yet": "Aucune mise en surbrillance créée pour le moment",
    "Search filters": "Rechercher des filtres",
    "Search highlights": "Rechercher des mises en surbrillance",
    "Shared filters info": "Ces filtres ont été partagés avec vous et peuvent être appliqués à tout type d'organigramme. La possibilité de modifier certains filtres dépendra de votre niveau d'accès partagé.",
    "Shared highlights info": "Ces mises en surbrillance ont été partagées avec vous et peuvent être appliquées à tout type d'organigramme. La possibilité de modifier certaines mises en surbrillance dépendra de votre niveau d'accès partagé.",
    "Interactive highlights": "Mises en surbrillance interactives",
    "Interactive filters & highlights": "Filtres et mises en surbrillance interactifs",
    "Delete highlight": "Supprimer la mise en surbrillance",
    "Delete highlight?": "Supprimer la mise en surbrillance ?",
    "Legacy filters": "Filtres hérités",
    "Legacy highlights": "Mises en surbrillance héritées",
    "Applies to": "S'applique à",
    "Restricted": "Restreint",
    "Budgeted Headcount": "Effectif budgété",
    "Salary Rollup": "Cumul salarial",
    "Position Budget Rollup": "Cumul budgétaire des postes",
    "Assigned to": "Affecté à",
    "No results found for the selected criteria. Please adjust your selection and try again": "Aucun résultat trouvé pour les critères sélectionnés. Veuillez ajuster votre sélection et réessayer",
    "Create base chart": "Créer un organigramme de base",
    "Pages": "Pages",
    "Could not load page": "Impossible de charger la page",
    "The number of records on the page exceeds the single page limit": "Le nombre d'enregistrements sur la page dépasse la limite d'une page",
    "canvastoolarge": "Cette page est trop grande pour être affichée par le navigateur.",
    "Maximum": "Maximum",
    "No preview": "Aucun aperçu",
    "Select a preview": "Sélectionner un aperçu",
    "Plan settings": "Paramètres du plan",
    "Current view applied": "Vue actuelle appliquée",
    "Chart description": "Description de l'organigramme",
    "Minimum group size": "Taille minimale du groupe",
    "Allow groups with managers": "Autoriser les groupes avec responsables",
    "Co-manager": "Co-responsable",
    "Manager group box style": "Style de case de groupe de responsables",
    "Restore plan": "Restaurer le plan",
    "Locking plan": "Verrouillage du plan",
    "Unlocking plan": "Déverrouillage du plan",
    "Deleting plan": "Suppression du plan",
    "Duplicating plan": "Duplication du plan",
    "Archiving plan": "Archivage du plan",
    "Renaming plan": "Renommage du plan",
    "This field is read-only and cannot be edited": "Ce champ est en lecture seule et ne peut pas être modifié",
    "Edit employee record": "Modifier l'enregistrement de l'employé",
    "formulas": "formules",
    "Add metric": "Ajouter une métrique",
    "Phases": "Phases",
    "Conflicted record": "Enregistrement en conflit",
    "Active append table": "Tableau annexe actif",
    "Copy to My filters": "Copier dans Mes filtres",
    "Copy to My highlights": "Copier dans Mes surlignages",
    "copy": "copier",
    "This user cannot be a collaborator because of their read-only role": "Cet utilisateur ne peut pas être collaborateur en raison de son rôle en lecture seule",
    "Revert changes": "Annuler les modifications",
    "Move to Staging": "Déplacer en préparation",
    "Edit rule criteria": "Modifier les critères de la règle",
    "Duplicate rule criteria": "Dupliquer les critères de la règle",
    "Remove rule criteria": "Supprimer les critères de la règle",
    "EmployeeID": "EmployeeID",
    "Data field": "Champ de données",
    "Create group": "Créer un groupe",
    "account": "compte",
    "Position view library": "Bibliothèque de vues de postes",
    "Employee view library": "Bibliothèque de vues d'employés",
    "Record is disconnected from hierarchy": "L'enregistrement est déconnecté de la hiérarchie",
    "No field": "Aucun champ",
    "Position field mapping": "Mappage des champs de poste",
    "Conflict auto-resolved": "Conflit résolu automatiquement",
    "Apply this formula to": "Appliquer cette formule à",
    "Turn on by default": "Activer par défaut",
    "Turn off by default": "Désactiver par défaut",
    "Page sort order": "Ordre de tri des pages",
    "Keep order as-is": "Conserver l'ordre actuel",
    "Keep pagination as-is": "Conserver la pagination actuelle",
    "A single page export will not need to re-paginate your chart": "Une exportation sur une seule page n'aura pas besoin de repaginer votre organigramme",
    "Sort by field": "Trier par champ",
    "Closed under": "Fermé sous",
    "Reopened under": "Rouvert sous",
    "Released from": "Libéré de",
    "You’ve exceeded the max number of boxes allowed for export. Please reduce the scope of your export, or attempt an export from a different part of your organization, so that the number of boxes will not exceed your limit": "Vous avez dépassé le nombre maximal de cases autorisé pour l'exportation. Veuillez réduire la portée de votre exportation ou tenter une exportation depuis une autre partie de votre organisation, afin de ne pas dépasser votre limite",
    "Administrators can update this limit in the Chart Settings: Presentation panel, though OrgChart does not recommend exporting charts with more than 20,000 records": "Les administrateurs peuvent modifier cette limite dans les paramètres de l'organigramme : panneau Présentation, bien qu'OrgChart ne recommande pas l'exportation d'organigrammes de plus de 20 000 enregistrements",
    "You’ve reached the maximum limit of": "Vous avez atteint la limite maximale de",
    "Admins can adjust this limit in Chart Settings > Presentation Panel, but OrgChart recommends keeping charts under 20,000 records for best performance.": "Les administrateurs peuvent ajuster cette limite dans Paramètres de l'organigramme > Panneau Présentation, mais OrgChart recommande de garder les organigrammes en dessous de 20 000 enregistrements pour de meilleures performances.",
    "Use advanced Entra Query": "Utiliser la requête Entra avancée",
    "Microsoft account type": "Type de compte Microsoft",
    "Standard (.com)": "Standard (.com)",
    "US government (.us)": "Gouvernement américain (.us)",
    "Changes pending": "Modifications en attente",
    "Created by": "Créé par",
    "Manually added": "Ajouté manuellement",
    "Source information not available": "Information source non disponible",
    "Enter field name": "Saisir le nom du champ",
    "Over source limit": "Limite de source dépassée",
    "Could not refresh custom chart": "Impossible d'actualiser l'organigramme personnalisé",
    "Could not open custom chart": "Impossible d'ouvrir l'organigramme personnalisé",
    "Failed to reorder talent": "Échec de la réorganisation des talents",
    "Could not locate employee to add to talent pool": "Impossible de trouver l'employé à ajouter au vivier de talents",
    "Back to all groups": "Retour à tous les groupes",
    "Group name": "Nom du groupe",
    "Group by field": "Grouper par champ",
    "Group style": "Style de groupe",
    "Rename report": "Renommer le rapport",
    "Configure chart": "Configurer l'organigramme",
    "Chart settings": "Paramètres de l'organigramme",
    "Save your current changes to this record": "Enregistrez vos modifications actuelles dans cet enregistrement",
    "Show grouping": "Afficher le regroupement",
    "Invalid email": "Adresse e-mail invalide",
    "Fix email": "Corriger l'adresse e-mail",
    "Reset integration": "Réinitialiser l'intégration",
    "Reset data integration": "Réinitialiser l'intégration de données",
    "One or more fields contain errors": "Un ou plusieurs champs contiennent des erreurs",
    "Confirm delete": "Confirmer la suppression",
    "Cannot re-use previous password": "Impossible de réutiliser un mot de passe précédent",
    "Unable to build preview": "Impossible de générer l'aperçu",
    "An error prevented the preview from being generated. Please try again": "Une erreur a empêché la génération de l'aperçu. Veuillez réessayer",
    "Rebuild preview": "Reconstruire l'aperçu",
    "Record removed": "Enregistrement supprimé",
    "Select a valid reports to": "Sélectionner un superviseur valide",
    "Undo plan change": "Annuler la modification du plan",
    "Create custom charts": "Créer des organigrammes personnalisés",
    "Application, Account, User, and Chart information": "Informations sur l'application, le compte, l'utilisateur et l'organigramme",
    "Refresh base charts (Read/Write users)": "Actualiser les organigrammes de base (utilisateurs lecture/écriture)",
    "Allow language change": "Autoriser le changement de langue",
    "Applying these settings will remove any manual subchart breaks": "L'application de ces paramètres supprimera toutes les coupures manuelles de sous-organigramme",
    "Permission denied": "Accès refusé",
    "Delete background": "Supprimer l'arrière-plan",
    "Move background": "Déplacer l'arrière-plan",
    "Replace Existing File": "Remplacer le fichier existant",
    "Replace Existing Files": "Remplacer les fichiers existants",
    "Skip Duplicate": "Ignorer le doublon",
    "Skip Duplicates": "Ignorer les doublons",
    "Existing": "Existant",
    "Replace or Discard Files": "Remplacer ou ignorer les fichiers",
    "File manager": "Gestionnaire de fichiers",
    "Modify backgrounds": "Modifier les arrière-plans",
    "Delete open chart": "Supprimer l'organigramme ouvert",
    "Not now": "Pas maintenant",
    "Load now": "Charger maintenant",
    "Update mapping": "Mettre à jour le mappage",
    "Keep mapping": "Conserver le mappage",
    "photoviewnophotos": "Aucun de vos employés n'a de photo. Ajoutez des photos dans votre système RH pour qu'elles s'affichent ici.",
    "Unable to delete rule": "Impossible de supprimer la règle",
    "accounts": "comptes",
    "Move to trash": "Déplacer vers la corbeille",
    "Delete all": "Tout supprimer",
    "Move all to trash": "Tout déplacer vers la corbeille",
    "Empty trash": "Vider la corbeille",
    "Save and exit": "Enregistrer et quitter",
    "Box style name in use": "Nom de style de case déjà utilisé",
    "Enter a field name": "Saisir un nom de champ",
    "Show less": "Afficher moins",
    "Show more": "Afficher plus",
    "This custom chart is currently open. Are you sure you want to delete this custom chart": "Cet organigramme personnalisé est actuellement ouvert. Voulez-vous vraiment supprimer cet organigramme personnalisé",
    "Copy file": "Copier le fichier",
    "Download file": "Télécharger le fichier",
    "Delete file": "Supprimer le fichier",
    "Select a table": "Sélectionner un tableau",
    "New Base Chart": "Nouvel organigramme de base",
    "Table Name": "Nom du tableau",
    "Table name cannot be empty": "Le nom du tableau ne peut pas être vide",
    "Table name must be at least 4 characters": "Le nom du tableau doit contenir au moins 4 caractères",
    "Table name already exists": "Ce nom de tableau existe déjà",
    "Create table": "Créer un tableau",
    "Search for table name": "Rechercher un nom de tableau",
    "Search by name or title": "Rechercher par nom ou titre",
    "Modifications": "Modifications",
    "Add record": "Ajouter un enregistrement",
    "Unsaved changes detected": "Modifications non enregistrées détectées",
    "Position fields": "Champs de poste",
    "Employee fields": "Champs d'employé",
    "The system only allows you to add up to three additional co-heads": "Le système ne permet d'ajouter que trois co-responsables supplémentaires au maximum",
    "Add co-head": "Ajouter un co-responsable",
    "Box selected": "Case sélectionnée",
    "Position box": "Case de poste",
    "Employee box": "Case d'employé",
    "Chart styles": "Styles d'organigramme",
    "Additional reports": "Rapports supplémentaires",
    "Additional reports to": "Rapports supplémentaires à",
    "Add assignment": "Ajouter une affectation",
    "Duplicate additional reports are not allowed": "Les rapports supplémentaires en double ne sont pas autorisés",
    "This supervisor is already selected": "Ce superviseur est déjà sélectionné",
    "Chart fields changed": "Champs de l'organigramme modifiés",
    "Invalid reporting structure": "Structure hiérarchique invalide",
    "Manage fields": "Gérer les champs",
    "custom charts": "organigrammes personnalisés",
    "Choose data source": "Choisir la source de données",
    "Employee Chart": "Organigramme d'employés",
    "Position Chart": "Organigramme de postes",
    "Allocation Ratio": "Ratio d'allocation",
    "Position field categories": "Catégories de champs de poste",
    "Data field categories": "Catégories de champs de données",
    "Assign as": "Affecter en tant que",
    "Both": "Les deux",
    "Create plan from": "Créer un plan à partir de",
    "Create custom chart from": "Créer un organigramme personnalisé à partir de",
    "custom chart created": "Organigramme personnalisé {name} créé.",
    "No rule": "Aucune règle",
    "Add a description": "Ajouter une description",
    "this can be done later": "cela peut être fait ultérieurement",
    "Cost reduction": "Réduction des coûts",
    "Headcount reduction": "Réduction des effectifs",
    "Relocation": "Relocalisation",
    "General organization design": "Conception organisationnelle générale",
    "Select objective": "Sélectionner un objectif",
    "Objective": "Objectif",
    "Employees": "Employés",
    "Modify fields": "Modifier les champs",
    "Upload checkpoint": "Téléverser un point de contrôle",
    "Select a chart type to configure data source": "Sélectionner un type d'organigramme pour configurer la source de données",
    "Employee List": "Liste des employés",
    "Unassigned": "Non affecté",
    "Assigned": "Affecté",
    "Released": "Libéré",
    "Unassigned from": "Désaffecté de",
    "Assign": "Affecter",
    "Assign to position": "Affecter au poste",
    "Clone position": "Cloner le poste",
    "Unassign employee": "Désaffecter l'employé",
    "Unassign employees": "Désaffecter les employés",
    "Assign employee": "Affecter l'employé",
    "Release employee": "Libérer l'employé",
    "Release employees": "Libérer les employés",
    "Set as default chart": "Définir comme organigramme par défaut",
    "Open in chart settings": "Ouvrir dans les paramètres de l'organigramme",
    "Create copy": "Créer une copie",
    "Delete chart": "Supprimer l'organigramme",
    "Delete chart disabled isolved": "Vous ne pouvez pas supprimer cet organigramme pour le moment. Veuillez contacter le support isolved pour plus d'informations.",
    "Add additional report field": "Ajouter un champ de rapport supplémentaire",
    "General field mapping": "Mappage général des champs",
    "Reset to default": "Réinitialiser par défaut",
    "This option is disabled due to role assignment restrictions": "Cette option est désactivée en raison de restrictions d'attribution de rôle",
    "Position dataset": "Jeu de données de postes",
    "Employee dataset": "Jeu de données d'employés",
    "I have a single source with employee data": "J'ai une source unique avec des données d'employés",
    "I have multiple sources with employee and position data": "J'ai plusieurs sources avec des données d'employés et de postes",
    "I have a single source with employee and position data": "J'ai une source unique avec des données d'employés et de postes",
    "Budget field mapping": "Mappage des champs de budget",
    "Employee details field mapping": "Mappage des champs de détails d'employé",
    "Position details": "Détails du poste",
    "Start date": "Date de début",
    "End date": "Date de fin",
    "Vacant": "Vacant",
    "Assignment status": "Statut d'affectation",
    "Assignees": "Titulaires",
    "System generated": "Généré par le système",
    "Upgrade to add more": "Mettre à niveau pour en ajouter plus",
    "Learn more": "En savoir plus",
    "Get started": "Commencer",
    "Access groups remaining": "Groupes d'accès restants",
    "Access groups used": "Groupes d'accès utilisés",
    "Source base chart": "Organigramme de base source",
    "Auto-sync enabled": "Synchronisation automatique activée",
    "Auto-save enabled": "Enregistrement automatique activé",
    "All staged records": "Tous les enregistrements en préparation",
    "Unassign": "Retirer",
    "Release": "Libérer",
    "Reopen": "Rouvrir",
    "Assignment": "Affectation",
    "all employees": "tous les employés",
    "Reopen position": "Rouvrir le poste",
    "Close position": "Fermer le poste",
    "Close and release": "Fermer et libérer",
    "Close and unassign": "Fermer et désaffecter",
    "Closed": "Fermé",
    "Search name": "Rechercher un nom",
    "Type and press enter": "Saisir et appuyer sur Entrée",
    "Cost bands": "Fourchettes salariales",
    "Use cost band data": "Utiliser les données de fourchette salariale",
    "System calculate for me": "Calcul automatique par le système",
    "Remove assignment": "Supprimer l'affectation",
    "Search for an employee": "Rechercher un employé",
    "Reassign employee": "Réaffecter l'employé",
    "Budget details": "Détails du budget",
    "Position budget summary": "Résumé du budget du poste",
    "remaining": "restant",
    "total budget": "budget total",
    "Utilization": "Utilisation",
    "Total cost": "Coût total",
    "Employee cost breakdown": "Détail des coûts de l'employé",
    "Cost band max": "Maximum de la fourchette salariale",
    "Current position cost": "Coût actuel du poste",
    "Create position": "Créer un poste",
    "Custom count": "Décompte personnalisé",
    "Copy position": "Copier le poste",
    "Employee changes": "Modifications des employés",
    "Position changes": "Modifications des postes",
    "Custom formulas remaining": "Formules personnalisées restantes",
    "Custom formulas used": "Formules personnalisées utilisées",
    "Enter comment": "Saisir un commentaire",
    "Assigned position": "Poste affecté",
    "Search for a position": "Rechercher un poste",
    "budget": "budget",
    "View budget information": "Afficher les informations budgétaires",
    "Hide details": "Masquer les détails",
    "Confirm assignments": "Confirmer les affectations",
    "Employee {employee} assigned to {position}": "Employé {employee} affecté à {position}",
    "{employee} is unassigned from {position}": "{employee} est désaffecté de {position}",
    "{employee} is released from {position}": "{employee} est libéré de {position}",
    "Selections": "Sélections",
    "Upgrade to create": "Mettre à niveau pour créer",
    "conditional row level": "niveau de ligne conditionnel",
    "Upgrade to group": "Mettre à niveau pour grouper",
    "compact and concise": "compact et concis",
    "multiple": "multiple",
    "Current values": "Valeurs actuelles",
    "Reports to (position)": "Superviseur (poste)",
    "Work Location": "Lieu de travail",
    "Position Title is required": "Le titre du poste est requis",
    "Parent PositionID is required": "L'identifiant du poste parent est requis",
    "Reports To is required": "Le superviseur est requis",
    "Allocation must be a positive number": "L'allocation doit être un nombre positif",
    "Cost Band Minimum must be a number": "Le minimum de la fourchette salariale doit être un nombre",
    "Cost Band Maximum must be a number": "Le maximum de la fourchette salariale doit être un nombre",
    "Cost Band Minimum cannot be greater than Cost Band Maximum": "Le minimum de la fourchette salariale ne peut pas être supérieur au maximum",
    "End Date must be on or after Start Date": "La date de fin doit être égale ou postérieure à la date de début",
    "Copy count must be a positive number": "Le nombre de copies doit être un nombre positif",
    "Position ID is required": "L'identifiant du poste est requis",
    "and {count} more": "et {count} de plus",
    "Base charts": "Organigrammes de base",
    "View and select chart export options": "Afficher et sélectionner les options d'exportation de l'organigramme",
    "User preferences menu": "Menu des préférences utilisateur",
    "Help Center": "Centre d'aide",
    "Data source refresh failures": "Échecs d'actualisation de la source de données",
    "Data Load Failure": "Échec du chargement des données",
    "Append Data Failure": "Échec des données annexes",
    "Merge Data Failure": "Échec de la fusion des données",
    "Main data source": "Source de données principale",
    "Append data source": "Source de données annexe",
    "Merge data source": "Source de données de fusion",
    "Photo data source": "Source de données photo",
    "Data source": "Source de données",
    "Unknown": "Inconnu",
    "Plan no longer exists": "Le plan n'existe plus",
    "Error loading plan": "Erreur lors du chargement du plan",
    "Permission denied to access planning module": "Accès refusé au module de planification",
    "Permission denied to access plan": "Accès refusé au plan",
    "Insufficient role to access planning module": "Rôle insuffisant pour accéder au module de planification",
    "Core fields cannot be hidden in the table": "Les champs principaux ne peuvent pas être masqués dans le tableau",
    "branch level": "niveau de branche",
    "Enable approvals": "Activer les approbations",
    "plan approval system": "système d'approbation des plans",
    "granular control": "contrôle granulaire",
    "calculate metrics": "calculer les métriques",
    "accurate depiction": "représentation fidèle",
    "automatically assign": "affecter automatiquement",
    "Clone": "Cloner",
    "Edit position": "Modifier le poste",
    "Multiple positions": "Postes multiples",
    "Multiple employees": "Employés multiples",
    "Automatically archive charts": "Archiver automatiquement les organigrammes",
    "Org structures": "Structures organisationnelles",
    "Stay audit ready": "Rester prêt pour l'audit",
    "securely captured": "capturé de façon sécurisée",
    "identify patterns": "identifier les tendances",
    "Assignments": "Affectations",
    "Additional data sources remaining": "Sources de données supplémentaires restantes",
    "Upgrade to add": "Mettre à niveau pour ajouter",
    "additional HR systems": "systèmes RH supplémentaires",
    "vacancies or contractors": "postes vacants ou contractuels",
    "secondary managers": "responsables secondaires",
    "Upgrade to plan": "Mettre à niveau pour planifier",
    "Plan with Position Data": "Plan avec données de postes",
    "Track KPIs": "Suivre les KPIs",
    "Collaborate in Real Time": "Collaborer en temps réel",
    "positions and vacancies": "postes et postes vacants",
    "insight": "aperçu",
    "impact": "impact",
    "setting and tracking": "définir et suivre",
    "drag and drop": "glisser-déposer",
    "move groups": "déplacer des groupes",
    "team is aware": "l'équipe est informée",
    "This option is disabled due to package restrictions": "Cette option est désactivée en raison de restrictions de forfait",
    "Core mapped fields must always show to build your base chart": "Les champs mappés principaux doivent toujours être affichés pour construire votre organigramme de base",
    "This field cannot be {status1} as it has already been selected as {status2}": "Ce champ ne peut pas être {status1} car il a déjà été sélectionné comme {status2}",
    "Upgrade": "Mettre à niveau",
    "Employees in deleted position will be unassigned in the Employee List.": "Les employés du poste supprimé seront désaffectés dans la liste des employés.",
    "Would you like to rollup or delete the subordinates for {position}?": "Souhaitez-vous cumuler ou supprimer les subordonnés de {position} ?",
    "Rollup or delete subordinate positions": "Cumuler ou supprimer les postes subordonnés",
    "Rollup subordinates": "Cumuler les subordonnés",
    "Delete subordinates": "Supprimer les subordonnés",
    "Position field": "Champ de poste",
    "Allocation": "Allocation",
    "Holder Count": "Nombre de titulaires",
    "Add subordinate position": "Ajouter un poste subordonné",
    "Add subordinate position(s)": "Ajouter un ou des postes subordonnés",
    "Add employee(s) to position": "Ajouter un ou des employés au poste",
    "Add assistant position": "Ajouter un poste d'assistant",
    "Created and assigned to": "Créé et affecté à",
    "Position profile": "Profil du poste",
    "Employee profile": "Profil de l'employé",
    "Edit position details": "Modifier les détails du poste",
    "Edit employee details": "Modifier les détails de l'employé",
    "Employee details": "Détails de l'employé",
    "Create new chart": "Créer un nouvel organigramme",
    "range": "plage",
    "Starting value": "Valeur de début",
    "Ending value": "Valeur de fin",
    "Choose a color": "Choisir une couleur",
    "last [n] days": "[n] derniers jours",
    "last [n] weeks": "[n] dernières semaines",
    "last [n] months": "[n] derniers mois",
    "last [n] years": "[n] dernières années",
    "next [n] days": "[n] prochains jours",
    "next [n] weeks": "[n] prochaines semaines",
    "next [n] months": "[n] prochains mois",
    "next [n] years": "[n] prochaines années",
    "yesterday": "hier",
    "tomorrow": "demain",
    "To (optional)": "À (facultatif)",
    "specific date": "date spécifique",
    "removed from your data set": "supprimé de votre jeu de données",
    "created positions for you to maintain": "postes créés que vous devez maintenir",
    "append table": "tableau annexe",
    "Minimum subordinate threshold": "Seuil minimal de subordonnés",
    "Include": "Inclure",
    "Exclude": "Exclure",
    "Favorite field {i}": "Champ favori {i}",
    "Profile picture": "Photo de profil",
    "Employee profile card": "Carte de profil de l'employé",
    "Position profile card": "Carte de profil du poste",
    "Additional {type} information": "Informations {type} supplémentaires",
    "Heading information": "Informations d'en-tête",
    "Fields to": "Champs à",
    "Position start date": "Date de début du poste",
    "Position end date": "Date de fin du poste",
    "Full name": "Nom complet",
    "Employee ID": "Identifiant de l'employé",
    "Position ID": "Identifiant du poste",
    "Record type": "Type d'enregistrement",
    "Record name": "Nom de l'enregistrement",
    "Modification type": "Type de modification",
    "Replace all": "Tout remplacer",
    "Add to existing": "Ajouter aux existants",
    "Append table has existing records": "Le tableau annexe contient des enregistrements existants",
    "Information unavailable": "Information non disponible",
    "Clear vacant positions": "Effacer les postes vacants",
    "Clear vacant positions after": "Effacer les postes vacants après",
    "1 assignee": "1 titulaire",
    "{n} assignees": "{n} affectés",
    "Field name": "Nom du champ",
    "No fields added yet": "Aucun champ ajouté pour le moment",
    "Data sources below are not yet supported for this chart type. For assistance, please reach out to ": "Les sources de données ci-dessous ne sont pas encore prises en charge pour ce type d'organigramme. Pour obtenir de l'aide, veuillez contacter",
    "What type of dataset do you want to ": "Quel type de jeu de données souhaitez-vous",
    "Force queue refresh": "Forcer l'actualisation de la file d'attente",
    "Force queue": "Forcer la file d'attente",
    "Use Auth V1": "Utiliser Auth V1",
    "Plan state": "État du plan",
    "Approval Status": "Statut d'approbation",
    "Approval status": "Statut d'approbation",
    "This plan has the following approver(s) and their approval status:": "Ce plan comporte le ou les approbateurs suivants et leur statut d'approbation :",
    "Draft": "Brouillon",
    "Submitted": "Soumis",
    "Approved": "Approuvé",
    "Rejected": "Rejeté",
    "Withdrawn": "Retiré",
    "Pending": "En attente",
    "Submit Plan for Approval": "Soumettre le plan pour approbation",
    "Plan details": "Détails du plan",
    "Owner": "Propriétaire",
    "Add approvers": "Ajouter des approbateurs",
    "Search for approvers": "Rechercher des approbateurs",
    "Message": "Message",
    "Add a message for approvers": "Ajouter un message pour les approbateurs",
    "Submit for approval": "Soumettre pour approbation",
    "Submit Plan": "Soumettre le plan",
    "Plan Submitted": "Plan soumis",
    "Approve Plan": "Approuver le plan",
    "Approve plan": "Approuver le plan",
    "Reject plan": "Rejeter le plan",
    "Submit plan": "Soumettre le plan",
    "Withdraw plan": "Retirer le plan",
    "No plan approvals have been made yet.": "Aucune approbation de plan n'a encore été effectuée.",
    "Approvals": "Approbations",
    "Reject Plan": "Rejeter le plan",
    "Approval message": "Message d'approbation",
    "Rejection message": "Message de rejet",
    "Approve": "Approuver",
    "Reject": "Rejeter",
    "Submission Info": "Informations de soumission",
    "Submitted by": "Soumis par",
    "Submitted on": "Soumis le",
    "Submission message": "Message de soumission",
    "Approvers": "Approbateurs",
    "Add a message": "Ajouter un message",
    "Grant access": "Accorder l'accès",
    "Withdraw": "Retirer",
    "Withdrawal message": "Message de retrait",
    "Optional message": "Message facultatif",
    "Withdrawn by": "Retiré par",
    "Withdrawn on": "Retiré le",
    "Force calculate": "Forcer le calcul",
    "Force calculate formulas": "Forcer le calcul des formules",
    "Table view": "Vue tableau",
    "Default editable fields": "Champs modifiables par défaut",
    "Choose the default editable fields that you want to show in the {entity} modals.": "Choisissez les champs modifiables par défaut que vous souhaitez afficher dans les fenêtres {entity}.",
    "Plan settings apply to plans created from the selected base chart.": "Les paramètres du plan s'appliquent aux plans créés à partir de l'organigramme de base sélectionné.",
    "Approval settings": "Paramètres d'approbation",
    "Enable plan approvals": "Activer les approbations de plans",
    "Disable plan approval?": "Désactiver l'approbation des plans ?",
    "Disabling plan approval will hide plan approval flows for all plans created from this base chart. Are you sure you want to disable plan approval for this base chart?": "La désactivation de l'approbation des plans masquera les flux d'approbation pour tous les plans créés à partir de cet organigramme de base. Voulez-vous vraiment désactiver l'approbation des plans pour cet organigramme de base ?",
    "When enabled, plans can be submitted for approval and e-mail notifications are sent for status updates.": "Lorsque cette option est activée, les plans peuvent être soumis pour approbation et des notifications par e-mail sont envoyées pour les mises à jour de statut.",
    "Disable": "Désactiver",
    "Show only plans needing my approval": "Afficher uniquement les plans nécessitant mon approbation",
    "Plan requires approval": "Le plan nécessite une approbation",
    "you": "vous",
    "Review changes": "Examiner les modifications",
    "In Review": "En cours d'examen",
    "Manage plan fields": "Gérer les champs du plan",
    "Review plan": "Examiner le plan",
    "This plan is in draft and has no approver information available until it is submitted for approval.": "Ce plan est à l'état de brouillon et aucune information d'approbateur n'est disponible tant qu'il n'est pas soumis pour approbation.",
    "Add language": "Ajouter une langue",
    "Data localization": "Localisation des données",
    "Include field?": "Inclure le champ ?",
    "Include field": "Inclure le champ",
    "Are you sure you want to include this field?": "Voulez-vous vraiment inclure ce champ ?",
    "Search for field": "Rechercher un champ",
    "Delete language": "Supprimer la langue",
    "Are you sure you want to delete this language? All mapped field configurations for this language will be lost.": "Voulez-vous vraiment supprimer cette langue ? Toutes les configurations de champs mappés pour cette langue seront perdues.",
    "Layout type": "Type de disposition",
    "Standard box": "Case standard",
    "Group box": "Case de groupe",
    "Group box style": "Style de case de groupe",
    "Save changes": "Enregistrer les modifications",
    "Display settings": "Paramètres d'affichage",
    "Limit text to a single row": "Limiter le texte à une seule ligne",
    "columns used in the group box": "colonnes utilisées dans la case de groupe",
    "Default to view's box style": "Style de case par défaut de la vue",
    "Group box layouts cannot have columns": "Les dispositions de cases de groupe ne peuvent pas avoir de colonnes",
    "This box layout type is applied to employee boxes.": "Ce type de disposition de case est appliqué aux cases d'employés.",
    "This box layout type is applied to the grouped box that groups the employee records.": "Ce type de disposition de case est appliqué à la case de groupe qui regroupe les enregistrements d'employés.",
    "You do not have any custom group styles created. Create a custom group style in the 'Box styles' panel and apply it to a conditional grouping.": "Vous n'avez aucun style de groupe personnalisé. Créez un style de groupe personnalisé dans le panneau « Styles de case » et appliquez-le à un regroupement conditionnel.",
    "Framed": "Encadré",
    "Condensed": "Condensé",
    "Grouped employee records appear in a list. The ‘Group by field’ value for those grouped records is displayed at the top of the group.": "Les enregistrements d'employés regroupés apparaissent dans une liste. La valeur « Grouper par champ » de ces enregistrements regroupés est affichée en haut du groupe.",
    "A frame is placed around grouped records. Conditional formatting targeting framed grouped records still appear.": "Un cadre est placé autour des enregistrements regroupés. La mise en forme conditionnelle ciblant les enregistrements regroupés encadrés reste visible.",
    "Employee box style": "Style de case d'employé",
    "Default to last used or only created": "Par défaut, dernier utilisé ou seul créé",
    "View name": "Nom de la vue",
    "BudgetedHeadcount": "Effectif budgété",
    "SalaryRollup": "Cumul des salaires",
    "CurrentPositionCost": "Coût du poste actuel",
    "PositionBudgetRollup": "Cumul du budget des postes",
    "PositionCount": "Nombre de postes",
    "SubordinatePositions": "Postes subordonnés",
    "DirectSubordinatePositions": "Postes subordonnés directs",
    "PeerPositions": "Postes pairs",
    "overtarget": "{delta} au-dessus de l'objectif",
    "undertarget": "{delta} en dessous de l'objectif",
    "Metric trend tooltip": "Début : {starting} | Variation : {delta}",
    "Duplicate file or files": "Fichier(s) en double",
    "foldermoveddeleted": "Le dossier est introuvable. Il a peut-être été renommé ou n'existe plus.",
    "foldernotfound": "Dossier introuvable",
    "deleteuser2": "de votre compte",
    "connectionerr": "Erreur de connexion. Veuillez vérifier votre connexion et réessayer.",
    "planconfigupdated": "La configuration du plan a été mise à jour.",
    "planupdatedlatest": "Modifications du plan synchronisées.",
    "talentpoolupdated": "Le vivier de talents a été mis à jour.",
    "functionalchartoption": "Fonction {index}",
    "rowsecallowedfieldsimplicit": "Tous les champs non restreints sont visibles.",
    "formulaerrnooperations": "Ajoutez au moins une opération.",
    "formulaerrnorule": "La définition de la règle est requise.",
    "This field is required": "Ce champ est requis.",
    "Both fields are required": "Les deux champs sont obligatoires.",
    "Add at least one value to the operation": "Ajoutez au moins une valeur à l'opération.",
    "There are required fields missing": "Des champs obligatoires sont manquants.",
    "Maximum number of metrics reached alert": "Vous pouvez suivre jusqu'à {MAX_METRICS} {metrics} à la fois. Pour ajouter une nouvelle métrique, vous devez en supprimer une existante.",
    "No more formulas available to add alert": "Aucune formule disponible à suivre. Les administrateurs peuvent créer des formules dans {chartSettingsFieldsFormulasPath}.",
    "No metrics available to add": "Aucune métrique disponible.",
    "Remove a metric to add a new one": "Supprimez une métrique pour en ajouter une nouvelle.",
    "Add metrics info": "Ajoutez des métriques pour définir des objectifs et suivre les changements.",
    "chartSettingsFieldsFormulasPath": "Paramètres du organigramme : champs et formules",
    "Create Table": "Créer un tableau",
    "Entity details": "Détails de {entity}",
    "planNoChartAccess": "Vous devez avoir accès à l'organigramme source pour afficher ce plan. Contactez votre administrateur pour demander l'accès.",
    "Position Location": "Lieu du poste",
    "Employee SupervisorID": "ID du superviseur de l'employé",
    "Employee Location": "Lieu de l'employé",
    "Position Title": "Titre du poste",
    "Position Division": "Division du poste",
    "Employee Title": "Titre de l'employé",
    "Position Budgeted Salary": "Salaire budgété du poste",
    "Position Cost Center": "Centre de coûts du poste",
    "Position Cost Band Minimum": "Fourchette salariale minimum du poste",
    "Position Cost Band Midpoint": "Fourchette salariale médiane du poste",
    "Position Cost Band Maximum": "Fourchette salariale maximum du poste",
    "Employee Salary": "Rémunération de l'employé",
    "Employee Pay": "Rémunération cumulée de l'employé",
    "Employee Cost Center": "Centre de coûts de l'employé",
    "DesiredHolders": "Effectif cible",
    "Build Position Doc": "Quel poste souhaitez-vous placer en haut de ce {document} ?",
    "levelcharthelp": "Sélectionnez un champ pour créer l'organigramme par niveau. Toutes les branches utiliseront le style Arbre.",
    "Select up to 3 fields": "Sélectionnez jusqu'à 3 champs à afficher en haut de la fiche de profil.",
    "Enable profile starring": "Champs de profil favoris (définis par l'utilisateur)",
    "Enterprise source limit": "Les comptes entreprise peuvent agréger jusqu'à 10 sources de données.",
    "livechartnotfound": "L'organigramme de base associé est introuvable et ne peut pas être synchronisé. Vous pouvez créer de nouveaux organigrammes personnalisés à partir d'organigrammes de base existants.",
    "chartnotfound": "L'organigramme de base associé est introuvable et ne peut pas être synchronisé. Vous pouvez créer de nouveaux organigrammes personnalisés à partir d'organigrammes de base existants. Cet organigramme reste disponible pour la modification ou l'exportation.",
    "changePaylocity": "Pour les problèmes liés à votre intégration Paylocity, ou pour configurer une nouvelle intégration, contactez",
    "changeSage300za": "Le point de terminaison API de cette intégration doit être configuré par le support. Pour le configurer, contactez ",
    "Cannot add plan top box to talent pool": "Impossible d'ajouter la case supérieure du plan au vivier de talents.",
    "Failed to remove talent": "Échec de la suppression du talent.",
    "refreshemail": "Saisissez les adresses e-mail des utilisateurs qui doivent recevoir les alertes.",
    "autoexportemail": "Saisissez les adresses e-mail des utilisateurs qui doivent recevoir les exportations automatiques.",
    "invalidcharwarn": "Certains caractères ne sont pas disponibles pour les noms de champs. Vous pouvez utiliser la fonctionnalité de libellé de champ pour ajouter des caractères comme '$'.",
    "The scope of the export exceeds your account's box limit": "La portée de l'exportation dépasse la limite de cases de votre compte. Veuillez réduire la portée de l'exportation ou contacter clientsuccess@theorgchart.com pour augmenter votre limite.",
    "One or more scope options is disabled because they exceed the maximum box limit for custom charts": "Une ou plusieurs options de portée sont désactivées car elles dépassent la limite de cases pour les organigrammes personnalisés. Un administrateur peut configurer cela dans les paramètres.",
    "invalidemailmessage": "Veuillez saisir une adresse e-mail valide dans la configuration de l'actualisation planifiée pour pouvoir enregistrer les modifications.",
    "autoemailmessage": "Veuillez saisir une adresse e-mail valide dans la configuration de l'exportation automatique pour pouvoir enregistrer les modifications.",
    "Dayforce reset info": "L'API Dayforce détecte les changements uniquement entre la dernière et la prochaine actualisation. Si vous avez apporté des modifications importantes à votre intégration, cliquez sur {resetLabel} pour établir une nouvelle base de données lors de la prochaine synchronisation nocturne. Après la réinitialisation, l'actualisation peut prendre plus de temps.",
    "Confirm reset integration": "Voulez-vous vraiment réinitialiser votre intégration actuelle ? Cette action est irréversible. Avertissement : la prochaine actualisation peut prendre plus de temps.",
    "You are over your seat limit": "Vous avez atteint votre limite de licences Lecture/Écriture. Vous pouvez libérer des licences en convertissant des utilisateurs existants en licences Lecture seule. Pour acheter des licences supplémentaires, contactez",
    "deletesingleuser": "Supprimer l'utilisateur",
    "enableFields": "Autoriser le basculement interactif des champs",
    "Reports to removed": "L'enregistrement n'existe plus. Recherchez un nouveau « Rend compte à » ou annulez la modification du plan pour revenir à la source.",
    "createWebLink": "Créer des liens web",
    "recordDetails": "Détails de l'enregistrement",
    "chartExplorerWarn": "Vous n'avez pas accès à l'explorateur d'organigrammes en raison de votre profil d'interface.",
    "contactAdmin": "Contactez votre administrateur.",
    "Are you sure you want to delete background": "Voulez-vous vraiment supprimer cet arrière-plan ? Les organigrammes liés à cet arrière-plan ne pourront plus le charger.",
    "Are you sure you want to move background": "Voulez-vous vraiment déplacer cet arrière-plan ? Les organigrammes liés à cet arrière-plan pourraient ne plus pouvoir le charger.",
    "transferAttributesInfoText": "Transférez les attributs utilisateur du fournisseur d'identité (IDP) vers l'application pour une gestion améliorée des profils.",
    "transferAttributeLabel": "Transférer les attributs utilisateur",
    "Set default background": "Cliquez ici pour définir l'arrière-plan par défaut",
    "Load field mapping now": "Charger le mappage des champs maintenant ?",
    "Load field mapping info": "Un mappage de champs valide est requis pour créer des organigrammes. OrgChart tentera de déterminer un mappage approprié, mais des ajustements manuels peuvent être nécessaires.",
    "lastrulemessage": "Vous ne pouvez pas supprimer la dernière règle d'une vue. Pour supprimer cette règle, ajoutez d'abord une autre règle à la vue.",
    "duplicatedrop": "Activer pour empêcher l'ajout de doublons au organigramme",
    "deleteuserdelegate1": "Cet utilisateur est associé à au moins un utilisateur secondaire dans d'autres",
    "deleteuserdelegate2": "Si vous supprimez cet utilisateur, tous les utilisateurs secondaires avec le même e-mail dans d'autres comptes seront également supprimés. Voulez-vous vraiment supprimer ces utilisateurs ?",
    "confirmdeletedelegate": "Supprimer les utilisateurs principal et secondaires",
    "denydeletedelegate": "Ne pas supprimer",
    "Send all files to trash": "Voulez-vous vraiment envoyer {fileCount} fichiers du dossier '{folder}' à la corbeille ?",
    "Delete all files trash": "Voulez-vous vraiment supprimer {fileCount} fichiers de la corbeille ? Cette action est irréversible.",
    "Permanently delete file": "Supprimer le fichier définitivement ?",
    "Move files to trash": "Mettre à la corbeille",
    "Move all files to trash": "Mettre les fichiers à la corbeille ?",
    "Delete all files": "Supprimer tous les fichiers ?",
    "Choose unique name": "Veuillez choisir un nom unique.",
    "disableIndexSwitch": "L'option de page d'index n'est disponible que pour les exportations d'organigramme complet. Accédez à l'onglet Général et définissez la portée sur l'organigramme complet.",
    "Generic insufficient permissions": "Vous n'avez pas l'autorisation d'effectuer cette action en raison de votre groupe d'accès ou de votre rôle. Veuillez contacter votre administrateur système.",
    "Folder locked": "Ce dossier est verrouillé. Vous ne pouvez pas modifier le contenu des dossiers verrouillés.",
    "No append tables (long)": "Aucun tableau n'a encore été configuré. Créez un tableau pour gérer et modifier les enregistrements.",
    "New Table (name)": "Nouveau tableau",
    "Modifications shown here (long)": "Tous les types de modifications seront enregistrés ici sous forme de tableau.",
    "Manage tables info (long)": "Gérez vos tableaux existants ou créez-en un nouveau à appliquer à votre organigramme de base.",
    "Additional field in use (long)": "Un nom de champ est utilisé plusieurs fois. Veuillez vérifier le tableau pour vous assurer que tous les noms de champs sont uniques avant d'enregistrer.",
    "Additional field is reserved (long)": "Un ou plusieurs noms de champs sont réservés. Veuillez vérifier le tableau pour vous assurer que tous les noms de champs sont uniques avant d'enregistrer.",
    "Name is reserved": "Nom réservé.",
    "Name already in use": "Nom déjà utilisé.",
    "Errors in form": "Vous avez des modifications non enregistrées, mais des erreurs doivent être résolues avant l'enregistrement. Souhaitez-vous résoudre les problèmes ou annuler vos modifications ?",
    "About append table (long)": "Le tableau annexe vous permet de gérer les enregistrements des organigrammes existants. Recherchez un employé ou un poste existant pour le modifier, déplacer ou supprimer. Vous pouvez également ajouter des enregistrements ou utiliser les boutons de téléchargement pour gérer les enregistrements en masse.",
    "About additional fields (long)": "Utilisez votre tableau annexe pour ajouter de nouveaux champs à vos données. Vous ne pouvez pas renommer les champs supplémentaires une fois créés.",
    "No Table Selected": "Aucun tableau sélectionné",
    "Modification history": "Historique des modifications",
    "Modification history tip": "Toutes les modifications sont enregistrées automatiquement.",
    "Number of modifications": "Nombre de modifications apportées à ce tableau",
    "Number of additional fields": "Nombre de champs ajoutés à ce tableau",
    "Changes have been saved": "Les modifications ont été enregistrées.",
    "An error occurred while saving": "Une erreur s'est produite lors de l'enregistrement.",
    "Active table set": "{tableName} défini comme tableau actif.",
    "Entity not found": "{entity} introuvable",
    "Entity created": "{tableName} créé.",
    "Entity changes saved": "Modifications de {entity} enregistrées.",
    "Are you sure you want to delete entity": "Voulez-vous vraiment supprimer {entity} ?",
    "Entity deleted": "{entity} supprimé.",
    "Entity copied": "Copie de {entity} créée",
    "Entity renamed": "{oldEntity} renommé en {newEntity}",
    "Entity set as default": "{entity} défini par défaut",
    "Entity i": "{entity} {i}",
    "Entity name": "Nom de {entity}",
    "Add entity": "Ajouter {entity}",
    "Create entity": "Créer {entity}",
    "Edit entity": "Modifier {entity}",
    "Copy entity": "Copier {entity}",
    "Entity saved": "{entity} enregistré.",
    "Edit entity details": "Modifier les détails de {entity}",
    "Entity name cannot be empty": "Le nom de {entity} ne peut pas être vide.",
    "Number of entity applied to the chart": "Nombre de {entity} appliqués à l'organigramme.",
    "Fill all fields {entity}": "Tous les champs obligatoires doivent être remplis avant d'enregistrer {entity}.",
    "Invalid date range": "Plage de dates invalide. La date « De » doit être antérieure à la date « À ».",
    "Invalid numeric range": "Plage numérique invalide. La valeur de départ doit être inférieure à la valeur de fin.",
    "Invalid range on criteria {n}": "Plage numérique invalide sur le critère {n}. La valeur de départ doit être inférieure à la valeur de fin.",
    "Invalid date range on criteria {n}": "Plage de dates invalide sur le critère {n}. La date « De » doit être antérieure à la date « À ».",
    "Missing required field": "Champ obligatoire manquant.",
    "Missing required field on criteria {n}": "Champ obligatoire manquant sur le critère {n}.",
    "Criteria {n} {msg}": "Critère {n} : {msg}",
    "Generic default error": "Une erreur a été détectée.",
    "Generic toast error": "Une erreur s'est produite. Veuillez réessayer.",
    "Table name must be at least 4 characters and unique": "Le nom du tableau doit comporter au moins 4 caractères et être unique.",
    "Chart fields changed (long)": "Les champs de l'organigramme ont changé. Veuillez actualiser votre organigramme.",
    "Update Base Chart Mapping": "Mettre à jour le mappage de l'organigramme de base ?",
    "Update Base Chart Mapping (long)": "Souhaitez-vous qu'OrgChart mette à jour le mappage de votre organigramme de base pour utiliser votre nouveau champ de rapport supplémentaire ?",
    "Update Base Chart Mapping (info)": "Le mappage des rapports peut être ajusté dans {mappingPath} sous la section {AuxRepMapping}.",
    "Delete additional field": "Supprimer le champ supplémentaire ?",
    "Delete additional field (long)": "Voulez-vous vraiment supprimer le champ {name} ?",
    "Broken field references warning": "Les références à ce champ (styles de case, profil et autres options de formatage) ne s'afficheront plus correctement.",
    "Additional reports limit": "Le système vous permet d'ajouter jusqu'à quatre affectations de superviseur supplémentaires.",
    "Additional reports info": "Les rapports supplémentaires peuvent être rapidement ajoutés ici et gérés dans {mappingPath}.",
    "mappingPath": "Paramètres du organigramme : mappage",
    "You cannot rename the additional fields once they have been created": "Vous ne pouvez pas renommer les champs supplémentaires une fois créés.",
    "Refresh chart notice": "Actualisez votre organigramme pour voir les dernières modifications.",
    "Confirm copy base chart": "Un organigramme de base est votre fondation et vous n'en avez généralement besoin que d'un seul. Vous pouvez créer plusieurs {customCharts} à partir d'un seul organigramme de base pour modifier le formatage, les lignes hiérarchiques et d'autres paramètres.",
    "Are you sure you want to copy base chart": "Voulez-vous vraiment copier cet organigramme de base ?",
    "Copy base chart": "Copier l'organigramme de base ?",
    "Delete base chart": "Supprimer l'organigramme de base ?",
    "What type of chart are you creating": "Quel type d'organigramme créez-vous ?",
    "Confirm delete base chart": "La suppression d'un organigramme de base le supprimera définitivement. Les plans et organigrammes personnalisés utilisant cet organigramme de base ne pourront plus accéder aux données. Cette action est irréversible.",
    "Base Employee Chart": "Organigramme de base des employés",
    "Base Position Chart": "Organigramme de base des postes",
    "Custom Employee Chart": "Organigramme personnalisé des employés",
    "Custom Position Chart": "Organigramme personnalisé des postes",
    "Employee Chart Plan": "Plan d'organigramme des employés",
    "Position Chart Plan": "Plan d'organigramme des postes",
    "Employee Chart Details": "Un organigramme centré sur les personnes qui visualise les relations entre les employés individuels, montrant les connexions directes indépendamment de la structure formelle des postes.",
    "Position Chart Details": "Un organigramme centré sur les postes qui affiche la hiérarchie formelle de votre organisation basée sur les rôles et les postes plutôt que sur les personnes qui les occupent.",
    "Position Chart Disabled": "Pour activer cette fonctionnalité, veuillez contacter le support client.",
    "Position Chart Coming Soon": "L'organigramme des postes sera bientôt disponible.",
    "Select employee chart type": "Passer à un type d'organigramme d'employés",
    "Select position chart type": "Passer à un type d'organigramme de postes",
    "characters remaining": "{count} caractères restants",
    "Switch chart types": "Changer de type d'organigramme ?",
    "Switch chart type (long)": "Changer le type d'organigramme vous obligera à sélectionner à nouveau une source de données.",
    "Select fields and assign them as either holder fields, position fields, or both": "Sélectionnez les champs et attribuez-les comme champs de titulaire, champs de poste ou les deux à l'aide des boutons ci-dessous.",
    "Chart plan": "Plan {chart}",
    "Plan Objective": "Quel est l'objectif de la création de ce plan ?",
    "planobjective": "Objectif du plan",
    "Plan Objective Help": "En savoir plus sur les objectifs de plan dans notre",
    "Plan Objective Help Link": "Centre d'aide",
    "Assigned Out Of Scope": "Affecté*",
    "Assigned Out Of Scope Info": "Affecté en dehors du périmètre du plan",
    "Choose what type of position data": "Choisissez quel type de données vous souhaitez utiliser pour créer votre organigramme de postes",
    "costband": "Bande de coûts (par employé)",
    "costbandinfo": "Définissez une fourchette de coûts minimum et maximum par employé pour surveiller l'impact budgétaire.",
    "Multi position editor changes info": "Toutes les modifications que vous apportez aux champs suivants s'appliqueront aux {count} {positions} que vous avez sélectionnés.",
    "Reopen position editor changes info": "Vous pouvez {__reopenTheCountPosition__}, mais les employés affectés au moment de la fermeture {__wontBeAutomaticallyReassigned__} au poste.",
    "Successfully updated positions": "{count} {positions} mis à jour avec succès",
    "Failed to update positions": "Échec de la mise à jour des postes. Veuillez réessayer.",
    "costbanderror": "Le minimum de la bande de coûts doit être inférieur au maximum de la bande de coûts",
    "startenddateerror": "La date de début doit être antérieure à la date de fin",
    "staffingtargeterror": "L'objectif d'effectif doit être supérieur à 0",
    "Show more entity": "Afficher plus de {entity}",
    "Show less entity": "Afficher moins de {entity}",
    "staffingtargetinfo": "Représente le nombre maximum souhaité d'employés affectés à ce poste. Vous pouvez toujours affecter autant d'employés que vous le jugez nécessaire.",
    "System generated positions": "Ce champ est généré automatiquement à l'aide de la structure hiérarchique employé à employé.",
    "System generated item": "{item} (Généré par le système)",
    "Pricing and Packaging": "Tarification et offres",
    "accessGroupLimit": "Vous avez atteint la limite d'ajout de groupes d'accès. Veuillez contacter le support à support@theorgchart.com pour obtenir de l'aide",
    "Box count tooltip": "Nombre total de cases dans le {document} actuellement ouvert.",
    "Boxes shown tooltip": "Le nombre de cases affichées dans le {document} actuellement ouvert.",
    "All staged records tooltip": "Nombre total d'enregistrements dans le panneau de transit de l'organigramme personnalisé actuellement ouvert. Les enregistrements peuvent se retrouver dans le panneau de transit si leur superviseur a été filtré de l'organigramme, ou si vous les y avez déplacés manuellement.",
    "Levels tooltip": "Nombre de niveaux organisationnels affichés dans le {document} actuellement ouvert.",
    "Disconnected records tooltip": "Nombre total de cases déconnectées dans l'organigramme actuellement ouvert. Les cases déconnectées peuvent avoir des identifiants de superviseur manquants ou invalides, ou ne pas rendre compte à d'autres enregistrements dans l'arborescence principale de l'organigramme de base.",
    "Employee is unassigned from position": "{employee} a été retiré de {position}.",
    "Employee is assigned to position": "{employee} a été affecté à {position}.",
    "{count} {employees} are assigned to {position}": "{count} {employees} ont été affectés à {position}.",
    "{count} {employees} are unassigned from {position}": "{count} {employees} ont été retirés de {position}.",
    "totalHoldersCount employees are unassigned from entity": "{totalHoldersCountEmployees} ont été retirés de {entity}.",
    "totalHoldersCount employees are unassigned from their positions": "{totalHoldersCountEmployees} ont été retirés de leurs postes.",
    "totalHoldersCount employees are released from entity": "{totalHoldersCountEmployees} ont été libérés de {entity}.",
    "totalHoldersCount employees are released from their positions": "{totalHoldersCountEmployees} ont été libérés de leurs postes.",
    "Subordinate moved to parent": "{subordinate} déplacé vers {parent}.",
    "Subordinate moved from position to position": "{fromPosition} déplacé vers {toPosition}.",
    "Unassigned employees can be found in the Employee List": "Les employés non affectés se trouvent dans la liste des employés.",
    "Are you sure you want to unassign employee from the position position?": "Voulez-vous vraiment retirer {employee} du poste {position} ?",
    "Are you sure you want to unassign totalHoldersCount employees from the position position?": "Voulez-vous vraiment retirer {totalHoldersCountEmployees} du poste {position} ?",
    "Are you sure you want to unassign totalHoldersCount employees from the following positions?": "Voulez-vous vraiment retirer {totalHoldersCountEmployees} des postes suivants ?",
    "Released employees can be found in the Employee List": "Les employés libérés se trouvent dans la liste des employés.",
    "Are you sure you want to release employee from the position position?": "Voulez-vous vraiment libérer {employee} du poste {position} ?",
    "Are you sure you want to release totalHoldersCount employees from the position position?": "Voulez-vous vraiment libérer {totalHoldersCountEmployees} du poste {position} ?",
    "Are you sure you want to release totalHoldersCount employees from the following positions?": "Voulez-vous vraiment libérer {totalHoldersCountEmployees} des postes suivants ?",
    "Reopen position multi": "Rouvrir le(s) poste(s)",
    "Are you sure you want to close the following position?": "Voulez-vous vraiment fermer le {__position__} suivant ?",
    "The entity is closed": "Le {entity} est fermé.",
    "Entities are closed": "{__entities__} sont fermés.",
    "The entity is reopened": "Le {entity} est rouvert.",
    "Entities are reopened": "{__entities__} sont rouverts.",
    "Entity has been reopened": "{entity} a été rouvert.",
    "Entity has been updated": "{entity} a été mis à jour.",
    "eymappingerror": "Aucun mappage défini pour l'organigramme EY. Configurez manuellement le mappage pour terminer le chargement des données de l'organigramme.",
    "Confirm remove assignment": "Voulez-vous vraiment retirer cet employé de ce poste ?",
    "Confirm reassign employee": "Voulez-vous vraiment réaffecter cet employé ?",
    "Employee reassignment": "Cet employé est actuellement affecté à {title} : {id}. Il sera déplacé lorsque vous enregistrerez vos modifications.",
    "Employee unassignment": "Cet employé sera retiré de {title} : {id} lorsque vous enregistrerez vos modifications",
    "autogenerated": "généré automatiquement",
    "How many position copies": "Combien de copies de {title} : {id} souhaitez-vous créer ?",
    "formulasLimit": "Vous avez atteint la limite d'ajout de formules personnalisées. Veuillez contacter le support à support@theorgchart.com pour obtenir de l'aide",
    "overbudget": "au-dessus du budget",
    "underbudget": "sous le budget",
    "Enable cost band info": "Pour voir comment l'affectation d'employés affecte le budget du poste, activez le paramètre de bande de coûts dans Paramètres du organigramme : mappage.",
    "Unable to create positions": "Impossible de créer le(s) poste(s). Veuillez réessayer.",
    "Clone position success": "Le {entity} a été cloné.",
    "How many new position copies": "Combien de copies de postes souhaitez-vous créer ?",
    "Create position success": "Le(s) poste(s) {entity} créé(s).",
    "Position selected": "Poste sélectionné : {title} : {id}",
    "There are number assignment issues": "Il y a {count} {text} avec les employés que vous affectez à ce poste.",
    "assignment state issues": "problème(s) d'état d'affectation",
    "is currently status": "est actuellement {status}",
    "is currently assigned to position": "est actuellement affecté à {title} : {id}.",
    "is currently assigned to position id": "est actuellement affecté à {id}.",
    "assigned and out of scope to": "affecté et hors périmètre à {id}.",
    "assigned and out of scope to position": "affecté et hors périmètre à {title} : {id}.",
    "Are you sure you want to assign them to position": "Voulez-vous vraiment les affecter à {title} : {id} ?",
    "has an unknown assignment status": "a un statut d'affectation inconnu.",
    "conditional rls message": "Passez à la version supérieure pour ajouter la sécurité conditionnelle au niveau des lignes et empêcher les utilisateurs de ne voir que certains champs pour certains enregistrements.",
    "conditional rls template": "Passez à la version supérieure pour ajouter la sécurité {conditional row level} et empêcher les utilisateurs de ne voir que certains champs pour certains enregistrements.",
    "grouping message": "Passez à la version supérieure pour utiliser le regroupement afin de regrouper les employés par emplacement, département ou titre pour des visualisations plus compactes et concises.",
    "grouping template": "Passez à la version supérieure pour utiliser le regroupement afin de regrouper les employés par emplacement, département ou titre pour des visualisations plus {compact and concise}.",
    "Delete plan message": "La suppression de ce plan le supprimera définitivement. Cette action est irréversible.",
    "custom chart trash": "Déplacer l'organigramme personnalisé vers la corbeille",
    "custom chart trash message": "Le déplacement de l'organigramme personnalisé vers la corbeille le retirera de ce dossier. Vous pouvez récupérer les organigrammes personnalisés de la corbeille en les faisant glisser vers un autre dossier.",
    "custom chart delete": "Supprimer l'organigramme personnalisé",
    "custom chart delete message": "La suppression de cet organigramme personnalisé le supprimera définitivement de votre compte. Cette action est irréversible.",
    "Cost band help": "Utilisez les bandes de coûts pour la budgétisation, la comparaison salariale et l'analyse des écarts. Si tous les champs ne sont pas mappés, le système peut générer les valeurs manquantes à l'aide de formules prédéfinies. Pour plus d'informations, consultez notre {Help Center}",
    "Position budget help": "Le calcul du budget du poste utilisera ce champ lorsqu'il est mappé, ou calculera à partir des données de bande de coûts si non mappé.",
    "Plan no longer exists (long)": "Le plan actuellement ouvert a été supprimé par un autre utilisateur. Veuillez choisir un plan existant ou en créer un nouveau pour continuer la planification.",
    "bls upgrade message": "Passez à la version supérieure pour ajouter la sécurité au niveau des branches afin de restreindre les utilisateurs à ne voir que certaines parties de l'organigramme, comme leur département.",
    "bls upgrade template": "Passez à la version supérieure pour ajouter la sécurité {branch level} afin de restreindre les utilisateurs à ne voir que certaines parties de l'organigramme, comme leur département.",
    "plan approvals upgrade message": "Un système d'approbation de plans qui permet un processus de révision et d'approbation contrôlé avec plusieurs approbateurs, un suivi de statut et des notifications par courriel.",
    "plan approvals upgrade template": "Un {plan approval system} qui permet un processus de révision et d'approbation contrôlé avec plusieurs approbateurs, un suivi de statut et des notifications par courriel.",
    "ag upgrade message": "Passez à la version supérieure pour ajouter des groupes d'accès supplémentaires, pour un contrôle granulaire des permissions futures et de la sécurité des données.",
    "ag upgrade template": "Passez à la version supérieure pour ajouter des groupes d'accès supplémentaires, pour un {granular control} des permissions futures et de la sécurité des données.",
    "changes message": "Passez à la version supérieure pour suivre les modifications de données, de formatage et de pagination que vous effectuez sur votre organigramme personnalisé. Auditez qui a effectué chaque modification et annulez facilement les modifications précédentes.",
    "functional chart message": "Passez à la version supérieure pour créer un organigramme fonctionnel afin de visualiser votre organisation par fonction, c.-à-d. par département, et de superposer votre hiérarchie fonctionnelle sur votre structure organisationnelle standard.",
    "formulas message": "Passez à la version supérieure pour ajouter plus de formules afin de calculer des métriques pour des effectifs personnalisés, des cumuls de coûts et plus encore.",
    "formulas template": "Passez à la version supérieure pour ajouter plus de formules afin de {calculate metrics} pour des effectifs personnalisés, des cumuls de coûts et plus encore.",
    "ar upgrade message": "Passez à la version supérieure pour visualiser les employés qui rendent compte à plus d'un superviseur pour une représentation plus fidèle des rôles et responsabilités partagés.",
    "ar upgrade template": "Passez à la version supérieure pour visualiser les employés qui rendent compte à plus d'un superviseur pour une {accurate depiction} des rôles et responsabilités partagés.",
    "auto assign upgrade message": "Passez à la version supérieure pour configurer OrgChart afin d'attribuer automatiquement des groupes d'accès aux utilisateurs en fonction de vos données d'employés.",
    "auto assign upgrade template": "Passez à la version supérieure pour configurer OrgChart afin d'{automatically assign} des groupes d'accès aux utilisateurs en fonction de vos données d'employés.",
    "pit archive message": "Assurez-vous que les organigrammes sont capturés et stockés en toute sécurité grâce aux capacités d'archivage automatique.",
    "pit archive template": "Assurez-vous que les organigrammes sont {securely captured} et stockés grâce aux capacités d'archivage automatique.",
    "pit org message": "Examinez les structures organisationnelles passées pour identifier les tendances en matière d'embauche, de rotation et de changements, vous aidant à prendre des décisions plus éclairées.",
    "pit org template": "Examinez les structures organisationnelles passées pour {identify patterns} en matière d'embauche, de rotation et de changements, vous aidant à prendre des décisions plus éclairées.",
    "pit audit message": "Partagez facilement les organigrammes historiques pour les audits, la conformité et les présentations.",
    "pit audit template": "Partagez facilement les organigrammes {share historical} pour les audits, la conformité et les présentations.",
    "addSourcesLimit": "Vous avez atteint la limite d'ajout de sources de données supplémentaires. Veuillez contacter le support à support@theorgchart.com pour obtenir de l'aide",
    "append message": "Passez à la version supérieure pour ajouter automatiquement des données provenant de systèmes RH supplémentaires ou de fichiers tableur afin de visualiser plus d'informations telles que les postes vacants ou les contractuels.",
    "append template": "Passez à la version supérieure pour ajouter automatiquement des données provenant de {additional HR systems} ou de fichiers tableur afin de visualiser plus d'informations telles que les {vacancies or contractors}.",
    "merge message": "Passez à la version supérieure pour ajouter automatiquement des données provenant de systèmes RH supplémentaires ou de fichiers tableur afin d'enrichir votre visualisation de données avec des informations telles que les responsables secondaires.",
    "merge template": "Passez à la version supérieure pour ajouter automatiquement des données provenant de {additional HR systems} ou de fichiers tableur afin d'enrichir votre visualisation de données avec des informations telles que les {secondary managers}.",
    "planning upgrade message": "Passez à la version supérieure pour planifier en toute confiance avec des données de postes précises, des outils collaboratifs et des aperçus sur les salaires, l'envergure de contrôle et la performance pour guider les décisions structurelles.",
    "plan position data message": "Planifiez stratégiquement pour l'avenir avec des données de postes précises. Analysez les postes et les vacances par salaire, envergure de contrôle, performance et plus encore pour fournir le meilleur aperçu de votre structure.",
    "plan position data template": "Planifiez stratégiquement pour l'avenir avec des données de postes précises. Analysez les {positions and vacancies} par salaire, envergure de contrôle, performance et plus encore pour fournir le meilleur {insight} de votre structure.",
    "track kpis message": "Assurez le succès de vos plans. Analysez l'impact de vos plans proposés en définissant et en suivant des objectifs cibles pour le budget, les effectifs et plus encore.",
    "track kpis template": "Assurez le succès de vos plans. Analysez l'{impact} de vos plans proposés en {setting and tracking} des objectifs cibles pour le budget, les effectifs et plus encore.",
    "collaborate message": "Travaillez aux côtés de vos collègues pour glisser-déposer des postes, déplacer des groupes d'employés et vous assurer que votre équipe est informée de l'impact des changements proposés.",
    "collaborate template": "Travaillez aux côtés de vos collègues pour {drag and drop} des postes, {move groups} d'employés et vous assurer que votre {team is aware} de l'impact des changements proposés.",
    "System calculation requires both Staffing target and Cost band maximum to be mapped": "Le calcul système nécessite que l'objectif d'effectif et le maximum de la bande de coûts soient tous deux mappés.",
    "System generate Position Budget": "Ce champ sera calculé comme suit : Objectif d'effectif × Maximum de la bande de coûts",
    "Cost band max staffing target position budget": "{costBandMax} × {desiredHolders} = Salaire budgété du poste",
    "This is driven by the position budget field": "Ceci est déterminé par le champ {field}.",
    "Record out of scope info": "Pour modifier les détails de cet employé, vous devez l'affecter à un poste dans ce plan.",
    "rlsallowedtoggleinfo": "Les champs autorisés activés sont affichés",
    "rlsrestrictedtoggleinfo": "Les champs restreints activés sont masqués",
    "rlsconditionaltoggleinfo": "Les champs activés sont affichés selon les règles conditionnelles",
    "rlsuserrecordnotfound": "Votre profil de sécurité nécessite votre enregistrement dans cet organigramme, mais votre enregistrement n'a pas pu être trouvé. Veuillez contacter votre administrateur système.",
    "Position Management enables you to visualize your employees and positions separately to gain better insight in your open roles and key position details": "La gestion des postes vous permet de visualiser vos employés et postes séparément pour mieux comprendre vos rôles ouverts et les détails clés des postes.",
    "Multiple parent positions rollup alert": "Certains postes que vous supprimez ont des subordonnés qui leur rendent compte. Que souhaitez-vous faire avec ces postes subordonnés ?",
    "Invalid target value": "La valeur cible doit être un nombre.",
    "noPositionSelectedTooltipInfo": "Sélectionnez un poste pour activer cette action.",
    "onlyActivePositionsSelectedTooltipInfo": "Le(s) poste(s) sélectionné(s) sont actifs.",
    "onlyClosedPositionsSelectedTooltipInfo": "Le(s) poste(s) sélectionné(s) sont fermés et doivent être rouverts pour effectuer des modifications.",
    "multiplePositionsSelectedTooltipInfo": "Sélectionnez un seul poste à cloner à la fois.",
    "closedOrUnassignedPositionsSelectedTooltipInfo": "Le(s) poste(s) sélectionné(s) n'ont pas d'affectations.",
    "Revert all position changes info": "Vous pouvez annuler toutes les modifications associées à ce poste, mais les employés affectés au moment de la fermeture {positionRevertWarning}. Pour rétablir les employés à leur poste d'origine, veuillez accéder à leur fenêtre de détails d'employé.",
    "Revert all position confirm": "Voulez-vous vraiment annuler toutes les modifications apportées à ce poste ?",
    "positionRevertWarning": "ne seront pas automatiquement réaffectés",
    "This action cannot be undone": "Cette action est irréversible.",
    "daterange": "plage de dates",
    "Retain vacant supervisory positions": "Conserver les postes vacants",
    "Retain vacant supervisory positions info": "OrgChart génère des postes vacants dans votre organigramme lorsque des employés sont supprimés de votre source de données. Cela préserve la structure de votre organisation et vous permet de réaffecter ou de planifier ces rôles essentiels. La table d'ajout est utilisée pour gérer ces postes vacants générés par le système.",
    "Retain positions": "Un ou plusieurs employés ont été {removedFromDataSet}. Afin de conserver leurs rôles, OrgChart a {createdPositions} votre structure organisationnelle. Utilisez la {appendTable} pour ajuster ces postes selon vos besoins.",
    "Retain position info": "Conservez les postes dans votre organigramme lorsque les employés affectés sont supprimés de votre source de données. Cela préserve votre structure organisationnelle et vous permet de réaffecter ou de planifier ces rôles essentiels.",
    "Auto purge vacant positions": "Purge automatique des postes vacants",
    "Auto purge vacant positions info": "Supprimez automatiquement les postes vacants après une période définie pour maintenir votre organigramme à jour.",
    "Purge positions after": "Purger les postes après :",
    "Employee profile desc": "La fiche de profil de l'employé affiche les données de l'employé. Choisissez ci-dessous quelles données d'employé vous souhaitez afficher dans la fiche de profil de l'employé.",
    "Position profile desc": "La fiche de profil du poste affiche les données du poste. Choisissez ci-dessous quelles données vous souhaitez afficher dans la fiche de profil du poste.",
    "Additional {type} information desc": "Les informations supplémentaires de {type} sont listées sous les champs favoris.",
    "Position information unavailable": "Les informations de poste ne sont pas disponibles. Veuillez passer à un organigramme de postes pour afficher et gérer les enregistrements de postes.",
    "Retain only vacant with subs": "Conserver uniquement les postes vacants avec des subordonnés",
    "Clear vacant positions after info": "Supprimez les postes vacants générés par le système après une période définie qui ne sont plus nécessaires pour préserver votre structure organisationnelle. Si vous souhaitez toujours conserver ces postes vacants dans votre organigramme, désactivez ce bouton.",
    "__blocked__": "(masqué)",
    "profile preview": "Aperçu du profil",
    "No assignees yet": "Aucun titulaire pour le moment.",
    "blockedmetrictip": "Cette métrique n'est pas disponible, car vous n'êtes pas autorisé à voir toutes les valeurs utilisées pour ce calcul. Pour voir ce nombre, saisissez une valeur de travail pour les champs utilisés pour ce calcul marqués comme « masqué ».",
    "compensationaccesstip": "Vous n'avez pas accès aux données de rémunération réelles de cet employé.",
    "recordeditorcompaccesstip": "Vous n'avez pas accès à la valeur réelle de certains champs. Vous pouvez saisir une valeur de remplacement pour les valeurs masquées à des fins de planification.",
    "No holders in preview": "Tous les postes sont vacants. Aucun titulaire à prévisualiser.",
    "Force queue refresh question": "Forcer l'actualisation de la file d'attente ?",
    "Refresh Queue Info": "Voulez-vous forcer cet organigramme dans la file d'attente d'actualisation immédiatement ? L'organigramme sera actualisé en arrière-plan.",
    "photoRefreshChoice": "Voulez-vous forcer le rechargement de toutes les photos pendant ce processus ?",
    "Chart added to the refresh queue": "Organigramme ajouté à la file d'attente d'actualisation avec succès",
    "Conflict record detected": "Conflit détecté",
    "Maximum approvers allowed. Please remove some approvers.": "Maximum {approverLimit} approbateurs autorisés. Veuillez retirer certains approbateurs.",
    "Plan submitted for approval successfully": "Plan soumis pour approbation avec succès.",
    "Failed to submit plan request": "Échec de la soumission de la demande de plan.",
    "Plan request withdrawn successfully": "Demande de plan retirée avec succès.",
    "Failed to withdraw plan request": "Échec du retrait de la demande de plan.",
    "Plan approved successfully": "Plan approuvé avec succès.",
    "Failed to approve plan": "Échec de l'approbation du plan.",
    "Plan rejected": "Plan rejeté.",
    "Failed to reject plan": "Échec du rejet du plan.",
    "Plan already submitted": "Plan déjà soumis.",
    "No active plan request to withdraw": "Aucune demande de plan active à retirer.",
    "Plan submission withdrawn successfully": "Soumission du plan retirée avec succès.",
    "Failed to submit plan submission": "Échec de la soumission du plan.",
    "Failed to withdraw plan submission": "Échec du retrait de la soumission du plan.",
    "No active plan submission to withdraw": "Aucune soumission de plan active à retirer.",
    "Approvers label": "Approbateur(s)",
    "Some approvers need access": "Certains approbateurs ne peuvent pas accéder au plan",
    "Some approvers need access info": "{reviewersWithoutPlanAccessCount} des {totalReviewerCount} approbateurs que vous ajoutez n'ont pas accès au plan. Accordez-leur un accès en lecture maintenant, ou vous pouvez les ajouter plus tard avant qu'ils ne commencent leur révision.",
    "Select approvers for this plan": "Sélectionner le(s) approbateur(s) pour ce plan",
    "Maximum approvers": "Maximum {approverLimit} approbateurs",
    "Refresh Formula Info": "Voulez-vous forcer le recalcul de toutes les formules pour cet organigramme ? Cela mettra à jour les valeurs calculées sans actualiser l'ensemble de l'organigramme.",
    "Force calculate formulas question": "Forcer le calcul des formules ?",
    "This plan is awaiting approval": "Ce plan est en attente d'approbation de {reviewerNames}.",
    "This plan is locked and cannot be edited.": "Ce plan est {status} et ne peut pas être modifié.",
    "Plan owners can unlock the plan in the Plan Explorer by hovering over the plan": "Les propriétaires du plan peuvent déverrouiller le plan dans l'explorateur de plans en survolant le plan, puis en cliquant sur l'icône ⋮.",
    "You have already approved this plan": "Vous avez déjà approuvé ce plan.",
    "You have already rejected this plan": "Vous avez déjà rejeté ce plan.",
    "LocalizationSettingsDesc": "Ajoutez la possibilité pour vos utilisateurs de consulter les données de leur organigramme dans la langue de leur choix. Ajoutez les mappages de champs souhaités pour les traductions affichées.",
    "NoLocalizationData": "Aucune configuration de langue ajoutée pour le moment.",
    "Closed positions remain in your chart and table view, but can be filtered out": "Les postes fermés restent dans votre organigramme et tableau, mais peuvent être filtrés.",
    "Cannot move record": "Impossible de déplacer l'enregistrement",
    "You cannot move employees to closed positions.": "Vous ne pouvez pas déplacer des employés vers des postes fermés.",
    "You cannot move this record under a closed position.": "Vous ne pouvez pas déplacer cet enregistrement sous un poste fermé.",
    "supportContactGeneric": "votre équipe de support ou de service",
    "genericAccessGroupLimit": "Vous avez atteint la limite d'ajout de groupes d'accès. Veuillez contacter votre équipe de support ou de service pour obtenir de l'aide.",
    "genericFormulasLimit": "Vous avez atteint la limite d'ajout de formules personnalisées. Veuillez contacter votre équipe de support ou de service pour obtenir de l'aide.",
    "genericAddSourcesLimit": "Vous avez atteint la limite d'ajout de sources de données supplémentaires. Veuillez contacter votre équipe de support ou de service pour obtenir de l'aide.",
    "genericBoxLimit": "La portée de l'exportation dépasse la limite de cases de votre compte. Veuillez réduire la portée de l'exportation ou contacter votre équipe de support ou de service pour augmenter votre limite.",
    "genericUnknownError": "Système non configuré. Veuillez contacter votre équipe de support ou de service.",
    "genericSharePointErr": "Échec de la configuration de SharePoint. Veuillez contacter votre équipe de support ou de service.",
    "genericSupportMsg": "Si le problème persiste, veuillez contacter votre équipe de support ou de service.",
    "genericSalesMsg": "Pour plus d'informations, veuillez contacter votre équipe de support ou de service.",
    "genericSupportDeskHelp": "Si le problème persiste, vous pouvez contacter votre équipe de support ou de service.",
    "Immediate days": "Jours immédiats",
    "Preview not available": "Aperçu non disponible. \\n Actualisez votre organigramme et réessayez.",
    "Withdraw plan info message": "Le retrait de ce plan supprimera toutes les approbations et remettra le statut du plan à « Brouillon ». Vous pourrez ensuite apporter des modifications.",
    "blsNavigationRestricted": "Cet enregistrement est en dehors de votre périmètre de sécurité de branche. Vous ne pouvez accéder qu'aux enregistrements au sein de votre branche.",
    "Import Filters": "Filtres d'importation",
    "Allowed legacy filters": "Filtres enregistrés autorisés (hérités)",
    "Allowed legacy highlights": "Mises en évidence enregistrées autorisées (héritées)",
    "Now available: IF/IH": "Disponible maintenant : Filtres et mises en évidence interactifs sur tous les types d'organigrammes",
    "Now available: IF/IH detail": "Utilisez le panneau de droite de l'organigramme pour créer, gérer et partager des filtres et mises en évidence interactifs. Vos filtres enregistrés restent accessibles. Pour en savoir plus sur l'utilisation de {link}, consultez notre documentation d'aide.",
    "Interactive filters and highlights": "filtres et mises en évidence interactifs",
    "Choose a base chart:": "Choisir un organigramme de base :",
    "Employee is unassigned from entity": "{employee} est désaffecté de {entity}.",
    "Employee is released from entity": "{employee} est libéré de {entity}.",
    "planning upgrade template": "{Looking to create a strategic future plan?} Renseignez-vous auprès de nous sur la mise à niveau vers notre {workforce planning module} !",
    "Looking to create a strategic future plan?": "Vous cherchez à créer un plan stratégique pour l'avenir ?",
    "authorBlockedFieldTip": "L'utilisateur qui a effectué cette modification n'avait pas accès à la valeur réelle de {fieldName}.",
    "view library upgrade message": "Passez à la version supérieure pour créer un nombre illimité de vues personnalisées d'organigramme afin d'approfondir votre compréhension de l'organisation. Ajoutez des champs tels que l'ancienneté, le salaire et les performances des employés dans vos cases, améliorez vos organigrammes avec les couleurs de votre marque et un codage couleur des champs, et signalez même les postes vacants.",
    "view library upgrade template": "Passez à la version supérieure pour créer un {unlimited number of custom org chart views} afin d'approfondir votre compréhension de l'organisation. Ajoutez des champs tels que l'ancienneté, le salaire et les performances des employés dans vos cases, améliorez vos organigrammes avec les couleurs de votre marque et un codage couleur des champs, et signalez même les postes vacants.",
    "unlimited number of custom org chart views": "nombre illimité de vues personnalisées d'organigramme",
    "Upgrade to add views": "Mettre à niveau pour ajouter des vues",
    "filters upgrade message": "Passez à la version supérieure pour utiliser des filtres interactifs sur votre organigramme afin d'améliorer la visibilité. Grâce aux filtres, vous pouvez choisir d'afficher uniquement certains enregistrements sur votre organigramme, tels que ceux de certains services, sites et bien plus encore.",
    "filters upgrade template": "Passez à la version supérieure pour utiliser {interactive filters} sur votre organigramme afin d'améliorer la visibilité. Grâce aux filtres, vous pouvez choisir d'afficher uniquement certains enregistrements sur votre organigramme, tels que ceux de certains services, sites et bien plus encore.",
    "interactive filters": "filtres interactifs",
    "highlights upgrade message": "Passez à la version supérieure pour utiliser des mises en évidence interactives sur votre organigramme et mettre instantanément en évidence les employés dans des services, sites et bien plus encore.",
    "highlights upgrade template": "Passez à la version supérieure pour utiliser {interactive highlights} sur votre organigramme et mettre instantanément en évidence les employés dans des services, sites et bien plus encore.",
    "interactive highlights": "mises en évidence interactives",
    "Upgrade to export": "Mettre à niveau pour exporter",
    "export upgrade message": "Passez à la version supérieure pour exporter votre organigramme aux formats PDF, PPT, PNG, SVG, JPEG et XLSX. Obtenez instantanément des organigrammes prêts à la présentation avec un contrôle sur la taille des pages, l'orientation, la portée du graphique et bien plus encore.",
    "export upgrade template": "Passez à la version supérieure pour exporter votre organigramme aux {PDF, PPT, PNG, SVG, JPEG, and XLSX formats}. Obtenez instantanément des organigrammes prêts à la présentation avec un contrôle sur la taille des pages, l'orientation, la portée du graphique et bien plus encore.",
    "PDF, PPT, PNG, SVG, JPEG, and XLSX formats": "formats PDF, PPT, PNG, SVG, JPEG et XLSX",
    "Merge duplicates": "Fusionner les doublons",
    "Merge by field": "Fusionner par champ",
    "The \"{fieldName}\" field is currently excluded from the profile. If you map this field, it will be included in the profile.": "Le champ « {fieldName} » est actuellement exclu du profil. Si vous mappez ce champ, il sera inclus dans le profil.",
    "This box layout type is applied to position boxes.": "Ce type de mise en page est appliqué aux cases de poste.",
    "Create and manage box styles for your charts. Apply box styles with a View.": "Créez et gérez des styles de case pour vos organigrammes. Appliquez des styles de case avec une vue.",
    "Create box style": "Créer un style de case",
    "Search box styles": "Rechercher des styles de case",
    "Applied to:": "Appliqué à :",
    "A to Z": "A à Z",
    "Z to A": "Z à A",
    "Most used": "Les plus utilisés",
    "Least used": "Les moins utilisés",
    "System box styles first": "Styles système en premier",
    "Shared box styles first": "Styles partagés en premier",
    "Employee box styles first": "Styles employé en premier",
    "Position box styles first": "Styles de poste en premier",
    "Group box styles first": "Styles de groupe en premier",
    "Applied to views": "Appliqué aux vues",
    "Not applied to views": "Non appliqué aux vues",
    "Box style library": "Bibliothèque de styles de case",
    "Box style type": "Type de style de case",
    "Reset filters": "Réinitialiser les filtres",
    "Go to a view:": "Accéder à une vue :",
    "views unavailable to access": "{viewCount} vues inaccessibles",
    "The box style is applied to the following views. Click on the view to preview.": "Le style de case est appliqué aux vues suivantes. Cliquez sur une vue pour l'apercevoir.",
    "Apply to new view": "Appliquer à une nouvelle vue",
    "No view rules reference this box style.": "Aucune règle de vue ne fait référence à ce style de case.",
    "Box style name": "Nom du style de case",
    "Back to box styles": "Retour aux styles de case",
    "Edit box style": "Modifier le style de case",
    "Copy box style": "Copier le style de case",
    "Revert box style": "Rétablir le style de case",
    "Delete box style": "Supprimer le style de case",
    "Delete box style?": "Supprimer le style de case ?",
    "Delete box style confirmation": "Cette action supprimera définitivement le style de case de votre bibliothèque. Les vues utilisant ce style reviendront au style système par défaut et devront être réassociées à un style de case.",
    "box style deleted": "Style de case {box style name} supprimé.",
    "The box style could not be deleted": "Impossible de supprimer le style de case. Veuillez réessayer.",
    "copied to box style library": "Style de case {box style name} copié dans la bibliothèque.",
    "The box style could not be copied": "Impossible de copier le style de case. Veuillez réessayer.",
    "box style created": "Style de case {box style name} créé.",
    "box style changes saved": "Modifications du style de case {box style name} enregistrées.",
    "edited": "modifié",
    "box layout editor pending changes banner":
      "Les modifications telles que renommer, copier et supprimer dans l'éditeur de mise en page de case sont en attente jusqu'à leur enregistrement ou leur annulation.",
    "1 box style with unsaved changes": "1 style de case avec des modifications non enregistrées.",
    "{n} box styles with unsaved changes": "{n} styles de case avec des modifications non enregistrées.",
    "1 box style deleted": "1 style de case supprimé.",
    "{n} box styles deleted": "{n} styles de case supprimés.",
    "{n} box styles updated": "{n} styles de case mis à jour.",
    "{n} box styles saved": "{n} styles de case enregistrés.",
    "Keep editing": "Continuer la modification",
    "box style save failed": "Impossible d'enregistrer les styles de case. Veuillez réessayer.",
    "Box style name must be unique": "Le nom du style de case doit être unique",
    "Box style name cannot be empty": "Le nom du style de case ne peut pas être vide",
    "Back to groups": "Retour au regroupement",
    "Delete group": "Supprimer le groupe",
    "Delete group?": "Supprimer le groupe ?",
    "Delete group confirm": "La suppression de ce groupe le retirera de votre liste de groupes.",
    "autoExportUpgradeMessage": "Passez à la version supérieure pour configurer OrgChart afin d'exporter automatiquement les organigrammes de base. Paramétrez OrgChart pour envoyer les organigrammes de base en PDF, PPT ou Excel directement dans les boîtes de réception des parties prenantes.",
    "autoExportUpgradeTemplate": "Passez à la version supérieure pour configurer OrgChart afin d'{automatically export} les organigrammes de base. Paramétrez OrgChart pour envoyer les organigrammes de base en PDF, PPT ou Excel directement dans les boîtes de réception des parties prenantes.",
    "automatically export": "exporter automatiquement",
    "SharePoint": "SharePoint",
    "Test Connection": "Tester la connexion",
    "sharepoint_test_in_progress": "Test en cours…",
    "sharepoint_test_ok": "Connexion établie",
    "sharepoint_test_auth_failed": "Échec de l'authentification — vérifiez le Tenant ID, le Client ID et le Client Secret",
    "sharepoint_test_folder_failed": "Connecté, mais la bibliothèque « Documents partagés » est inaccessible",
    "sharepoint_test_unreachable": "Impossible de joindre SharePoint — vérifiez le domaine et le réseau",
    "sharepoint_test_unknown": "Échec du test de connexion",
    "Audit log": "Journal d'administration",
    "admin log upgrade message":
      "Restez prêt pour un audit toute l'année. Le journal d'administration enregistre les modifications d'utilisateurs, d'autorisations et d'accès dans un relevé horodaté que vos auditeurs peuvent consulter à la demande.",
    "admin log upgrade template":
      "Restez {prêt pour un audit} toute l'année. Le journal d'administration enregistre les modifications d'utilisateurs, d'autorisations et d'accès dans un {relevé horodaté} que vos auditeurs peuvent consulter à la demande.",
    "audit-ready": "prêt pour un audit",
    "timestamped record": "relevé horodaté",
    "auditLog.title": "Journal d'administration",
    "auditLog.totalRecords": "Total des enregistrements",
    "auditLog.error.loadFailed": "Échec du chargement du journal d'administration.",
    "auditLog.error.exportFailed": "Échec de l'exportation du journal d'administration.",
    "auditLog.error.snapshotFailed": "Échec de la génération de l'instantané de sécurité.",
    "auditLog.filter.startDate": "Date de début",
    "auditLog.filter.endDate": "Date de fin",
    "auditLog.filter.eventType": "Type d'événement",
    "auditLog.filter.source": "Source",
    "auditLog.filter.outcome": "Résultat",
    "auditLog.filter.actorId": "ID utilisateur ou e-mail",
    "auditLog.filter.targetId": "ID de cible ou e-mail",
    "auditLog.action.apply": "Appliquer",
    "auditLog.action.reset": "Réinitialiser",
    "auditLog.action.exportCsv": "Exporter en CSV",
    "auditLog.action.exportXlsx": "Exporter le rapport Excel",
    "auditLog.action.generateSnapshot": "Générer un instantané",
    "auditLog.pagination.previous": "Précédent",
    "auditLog.pagination.next": "Suivant",
    "auditLog.pagination.page": "Page",
    "auditLog.column.timestamp": "Horodatage (GMT)",
    "auditLog.column.eventType": "Événement",
    "auditLog.column.outcome": "Résultat",
    "auditLog.column.source": "Source",
    "auditLog.column.actor": "Acteur",
    "auditLog.column.target": "Cible",
    "auditLog.column.diffKeys": "Clés modifiées",
    "auditLog.column.message": "Message",
    "auditLog.event.userCreate": "Utilisateur créé",
    "auditLog.event.userDelete": "Utilisateur supprimé",
    "auditLog.event.userDeleteRequest": "Suppression d'utilisateur demandée",
    "auditLog.event.userRoleChange": "Rôle d'utilisateur modifié",
    "auditLog.event.userPrivChange": "Groupe d'accès ou accès aux organigrammes modifié",
    "auditLog.event.userRlsAssign": "Profil RLS attribué à l'utilisateur",
    "auditLog.event.securityGroupUpdate": "Configuration de groupe d'accès modifiée",
    "auditLog.event.securityRlsProfileUpdate": "Profil de sécurité par ligne modifié",
    "auditLog.event.securityBlsProfileUpdate": "Profil de sécurité par branche modifié",
    "auditLog.event.securityImpersonationToggle": "Paramètre d'usurpation modifié",
    "auditLog.event.securityDirectSigninToggle": "Paramètre de connexion directe modifié",
    "auditLog.event.securityAutoAssignmentChange": "Configuration d'attribution automatique modifiée",
    "auditLog.event.securitySsoConfigChange": "Configuration SSO modifiée",
    "auditLog.event.securityAuthorizationDenied": "Autorisation refusée",
    "auditLog.event.securityUiProfileUpdate": "Profil d'interface modifié",
    "auditLog.event.authLoginImpersonation": "Connexion par usurpation",
    "auditLog.event.auditReportViewed": "Journal d'administration consulté",
    "auditLog.event.auditReportExported": "Journal d'administration exporté",
    "auditLog.event.auditReportExportedXlsx": "Rapport Excel d'administration exporté",
    "auditLog.event.auditSnapshotGenerated": "Instantané de sécurité généré",
    "auditLog.outcome.success": "Succès",
    "auditLog.outcome.denied": "Refusé",
    "auditLog.outcome.failed": "Échec",
    "auditLog.source.manageUsersUi": "Gérer les utilisateurs",
    "auditLog.source.authorizationUi": "Autorisation",
    "auditLog.source.rlsUi": "Sécurité par ligne",
    "auditLog.source.blsUi": "Sécurité par branche",
    "auditLog.source.accessGroupsUi": "Groupes d'accès",
    "auditLog.source.uiProfilesUi": "Profils d'interface",
    "auditLog.source.ssoConfigUi": "Configuration SSO",
    "auditLog.source.auditLogUi": "Journal d'administration",
    "auditLog.source.bulkImport": "Importation en masse",
    "auditLog.source.api": "API",
    "auditLog.source.system": "Système",
    "auditLog.source.unknown": "Inconnu",
    "Welcome to OrgChart!": "Bienvenue dans OrgChart !",
    "In two quick steps, we'll customize your org chart with your logo and brand colors.": "En deux étapes rapides, nous personnaliserons votre organigramme avec votre logo et vos couleurs de marque.",
    "Upload your logo": "1. Téléverser votre logo",
    "Auto-generates a branded background.": "Génère automatiquement un arrière-plan de marque.",
    "Set brand colors": "2. Définir les couleurs de marque",
    "Applied to all org chart system boxes.": "Appliqué à toutes les zones système de l'organigramme.",
    "Skip setup": "Ignorer la configuration",
    "Brand setup": "Configuration de la marque",
    "Step {current} of {total}": "Étape {current} sur {total}",
    "help document": "document d'aide",
    "Drag and drop your file here, or click to browse": "Glissez-déposez votre fichier ici, ou cliquez pour parcourir",
    "file formats": "Format {formats} – max. {size} Mo",
    "Choose colors for your org chart boxes. They will be applied to all default system boxes and views. You can skip this step and edit later in the Box Layout Editor.": "Choisissez les couleurs de vos zones d'organigramme. Elles seront appliquées à toutes les zones et vues système par défaut. Vous pouvez ignorer cette étape et modifier ultérieurement dans l'Éditeur de mise en page.",
    "Box fill color:": "Couleur de remplissage :",
    "Box border color:": "Couleur de bordure :",
    "Preview employee box styles": "Aperçu des styles de zone employé",
    "Finish setup": "Terminer la configuration",
    "Go to chart": "Accéder à l'organigramme",
    "You're all set!": "Tout est prêt !",
    "Your brand is applied.": "Votre marque est appliquée.",
    "Failed to delete file. Please try again.": "Impossible de supprimer le fichier. Veuillez réessayer.",
    "Copy to clipboard": "Copier dans le presse-papiers",
    "Paste from clipboard": "Coller depuis le presse-papiers",
    "Paste views and box styles from clipboard": "Coller les vues et styles de case depuis le presse-papiers",
    "Use the ctrl/cmd V shortcut key to paste your views and box styles from your clipboard.": "Utilisez le raccourci ctrl/cmd V pour coller vos vues et styles de case depuis le presse-papiers.",
    "Failed to import views. Please try again.": "Échec de l'importation des vues. Veuillez réessayer.",
    "Paste from your clipboard.": "Coller depuis votre presse-papiers.",
    "Import views": "Importer les vues",
    "Failed to paste views. Please copy views and box styles and try again.": "Échec du collage des vues. Veuillez copier les vues et styles de case, puis réessayer.",
    "Views and box styles pasted from clipboard.": "Vues et styles de case collés depuis le presse-papiers.",
    "Export views and box styles": "Exporter les vues et styles de case",
    "Views and box styles copied to your clipboard.": "Vues et styles de case copiés dans votre presse-papiers.",
    "Views and box styles imported successfully.": "Vues et styles de case importés avec succès.",
    "No filters created yet": "Aucun filtre créé pour l'instant.",
    "Grouping tab description": "Regroupez les cases par catégorie pour faciliter la lecture de l'organigramme.",
    "No groups created yet": "Aucun groupe créé pour l'instant",
    "No sort keys added yet": "Aucune clé de tri ajoutée pour l'instant",
    "No disconnected records found": "Aucun enregistrement déconnecté trouvé.",
    "No changes have been made yet.": "Aucune modification n'a encore été apportée.",
    "Staging info": "Staging stocke temporairement les enregistrements déconnectés. Faites glisser des enregistrements depuis Staging vers l'organigramme pour établir des liens hiérarchiques. Faites glisser des enregistrements vers Staging pour les déconnecter (les branches se déplacent ensemble).",
    "exportFilenameInvalidChars": "Le nom du fichier ne peut pas contenir : \\ / : * ? \" < > |",
    "Shared filter update error": "Échec de la mise à jour",
    "Shared filter delete error": "Échec de la suppression",
    "Dismiss": "Ignorer",
    "Got it": "Compris",
    "Let's go": "C'est parti",
    "Welcome to Your Charts, Powered by OrgChart!": "Bienvenue dans vos organigrammes, propulsé par OrgChart !",
    "Take the tour to get started and learn more!": "Faites la visite guidée pour commencer et en savoir plus !",
    "21 days": "21 jours",
    "premium org chart features": "fonctionnalités premium d'organigramme",
    "isolvedFreeTrialMessage": "Pendant les 21 prochains jours, vous aurez un accès gratuit aux fonctionnalités premium d'organigramme disponibles uniquement dans isolved, notamment l'exportation d'organigrammes, la mise en évidence d'informations et l'affichage de plusieurs vues.",
    "isolvedFreeTrialTemplate": "Pendant les {21 days} prochains jours, vous aurez un accès gratuit aux {premium org chart features} disponibles uniquement dans isolved, notamment l'exportation d'organigrammes, la mise en évidence d'informations et l'affichage de plusieurs vues.",
    "Click on the view switcher to change the information that is displayed on the chart. Your chart comes with three pre-installed views.": "Cliquez sur le sélecteur de vue pour modifier les informations affichées sur l'organigramme. Votre organigramme est fourni avec trois vues préinstallées.",
    "Use the levels control to increase or decrease the amount of organizational levels displayed on a single page.": "Utilisez le contrôle des niveaux pour augmenter ou diminuer le nombre de niveaux organisationnels affichés sur une seule page.",
    "Create filters to show specific records. For example, filter your chart to just see Full Time employees. Create highlights to illuminate specific records. For example, quickly highlight employees who work in New York.": "Créez des filtres pour afficher des enregistrements spécifiques. Par exemple, filtrez votre organigramme pour n'afficher que les employés à temps plein. Créez des mises en évidence pour illuminer des enregistrements spécifiques. Par exemple, mettez rapidement en évidence les employés qui travaillent à New York.",
    "Instantly get presentation-ready org charts. Export your chart to PPT, PDF, SVG, and additional formats.": "Obtenez instantanément des organigrammes prêts pour la présentation. Exportez votre organigramme en PPT, PDF, SVG et dans d'autres formats.",
    "brandedBackgroundMessage": "Votre logo générera un arrière-plan personnalisé pour votre organigramme. OrgChart vous permet d'avoir plusieurs logos. Veuillez consulter ce document d'aide pour en savoir plus. Cliquez sur « Continuer » pour ignorer cette étape.",
    "brandedBackgroundTemplate": "Votre logo générera un arrière-plan personnalisé pour votre organigramme. OrgChart vous permet d'avoir plusieurs logos. Veuillez consulter {helpdocument} pour en savoir plus. Cliquez sur « Continuer » pour ignorer cette étape.",
    "Brand colors could not be saved. Please try again or skip setup.": "Les couleurs de la marque n'ont pas pu être enregistrées. Veuillez réessayer ou ignorer la configuration.",
    "Logo could not be saved. Please try again or skip setup.": "Le logo n'a pas pu être enregistré. Veuillez réessayer ou ignorer la configuration.",
    "Resource center": "Centre de ressources",
    "Help documentation": "Documentation d'aide",
    "Learn about specific topics": "En savoir plus sur des sujets spécifiques",
    "Submit a support ticket": "Soumettre un ticket de support",
    "Onboarding": "Prise en main",
    "Take a tour of our core features": "Découvrez nos fonctionnalités principales",
    "Entity filter created": "Filtre {entity} créé.",
    "Entity highlight created": "Mise en surbrillance {entity} créée.",
    "Entity group created": "Groupe {entity} créé.",
    "View rule saved": "Règle de vue enregistrée.",
    "Chart scope changes saved": "Modifications de la portée du graphique enregistrées.",
    "Entity rule renamed": "{entity} renommé.",
    "Enter rule definition": "Saisir la définition de la règle",
    "<blank>": "<blank>",
    "SCIMSectionTitle": "Provisionnement SCIM",
    "SCIMUpgradeBody": "Effectuez une mise à niveau pour activer SCIM et gérer le provisionnement des utilisateurs, l'attribution des groupes et la désactivation directement depuis votre IdP.",
    "SCIMUpgradeTemplate": "Effectuez une mise à niveau pour {bold1} et gérer le provisionnement des utilisateurs, l'attribution des groupes et la désactivation {bold2}.",
    "SCIMUpgradeBold1": "activer SCIM",
    "SCIMUpgradeBold2": "directement depuis votre IdP",
    "SCIMTokenPanelIntro": "Émettez un jeton bearer pour votre fournisseur d'identité (par ex. Okta) afin qu'il puisse provisionner, mettre à jour et déprovisionner les utilisateurs via SCIM 2.0. Les jetons ne s'affichent qu'à la création et ne sont pas récupérables ensuite.",
    "SCIMTokenGenerate": "Générer un jeton",
    "SCIMTokenCopy": "Copier",
    "SCIMTokenDismiss": "Fermer",
    "SCIMTokenNewTitle": "Jeton créé",
    "SCIMTokenNewWarning": "Copiez ce jeton maintenant. Il ne pourra plus être affiché.",
    "SCIMTokenNoneActive": "Aucun jeton SCIM n'a été émis pour ce compte.",
    "SCIMTokenCreatedBy": "Créé par",
    "SCIMTokenCreatedAt": "Créé le",
    "SCIMTokenLastUsed": "Dernière utilisation",
    "SCIMTokenListError": "Impossible de charger les jetons SCIM.",
    "SCIMTokenCreateError": "Impossible de créer le jeton SCIM.",
    "SCIMTokenDeleteError": "Impossible de supprimer le jeton SCIM.",
    "SCIMSAMLConflictTitle": "Le provisionnement automatique SCIM et SAML sont tous deux activés",
    "SCIMSAMLConflictBody": "Les deux systèmes peuvent écrire dans les mêmes enregistrements utilisateur. Les attributs SAML prévalent sur les valeurs SCIM à la connexion. Pour éviter toute dérive, désactivez le provisionnement automatique de la configuration SSO ou supprimez le jeton SCIM.",
    "No functional statement": "Aucun énoncé fonctionnel",
    "Functional Statement": "Énoncé fonctionnel",
    "Chart Navigator": "Navigateur d'organigramme",
    "Navigator": "Navigateur",
    "Point in Time": "Point dans le temps",
    "No results": "Aucun résultat",
    "PDF Export Only": "Export PDF uniquement",
    "Include Functional Statements": "Inclure les énoncés fonctionnels",
    "includeFunctionalStatementsHelper": "Ajouter une page avec l'énoncé fonctionnel de chaque unité à la fin de l'exportation",
    "disableFunctionalStatementsSwitch": "Les énoncés fonctionnels ne sont disponibles que pour les exportations d'organigramme complet. Accédez à l'onglet Général et définissez la portée sur l'organigramme complet.",
    "includeExcelFunctionalStatementsHelper": "Ajouter une colonne contenant l'énoncé fonctionnel de chaque unité",
    "isolvedMissingJobDataErrTitle": "Données de poste incomplètes ou manquantes",
    "isolvedMissingJobDataErrAdmin": "Les données de poste sont incomplètes ou manquantes. Vérifiez que les employés ont des responsables et des intitulés de poste assignés, puis l'organigramme se mettra à jour dans l'heure.",
    "isolvedMissingJobDataErrUser": "Les données de poste sont incomplètes ou manquantes. Contactez votre administrateur isolved pour vérifier que les employés ont des responsables et des intitulés de poste assignés.",
    "isolvedMappingMissingManagerTitle": "Relations hiérarchiques du responsable manquantes",
    "isolvedMappingMissingManagerAdmin": "Nous n'avons détecté aucune relation hiérarchique dans votre mappage du superviseur actuel. Des relations hiérarchiques existent avec assigned supervisor ID. Souhaitez-vous mettre à jour votre mappage du superviseur pour utiliser assigned supervisor ID à la place ?",
    "isolvedMappingMissingManagerUser": "Aucune relation hiérarchique n'a été détectée dans isolved pour le mappage du superviseur actuel de votre organigramme. Contactez votre administrateur isolved pour mettre à jour le mappage du superviseur.",
    "isolvedMappingIncompleteManagerTitle": "Relations hiérarchiques du responsable incomplètes",
    "isolvedMappingIncompleteManagerAdmin": "Certains employés n'ont pas de relation hiérarchique dans votre mappage du superviseur actuel. Nous avons détecté que les relations hiérarchiques créées à l'aide de assigned supervisor ID sont plus complètes. Souhaitez-vous mettre à jour votre mappage du superviseur pour utiliser assigned supervisor ID ? Si vous préférez conserver votre mappage actuel, assurez-vous que tous les employés disposent d'une valeur dans isolved.",
    "isolvedMappingIncompleteManagerUser": "Certains employés n'ont pas de relation hiérarchique dans isolved pour le mappage du superviseur actuel de votre organigramme. Contactez votre administrateur isolved pour vérifier le mappage du superviseur.",
    "isolvedMappingMissingSupervisorTitle": "Relations hiérarchiques du superviseur manquantes",
    "isolvedMappingMissingSupervisorAdmin": "Nous n'avons détecté aucune relation hiérarchique dans votre mappage du superviseur actuel. Des relations hiérarchiques existent avec assigned manager ID. Souhaitez-vous mettre à jour votre mappage du superviseur pour utiliser assigned manager ID à la place ?",
    "isolvedMappingMissingSupervisorUser": "Aucune relation hiérarchique n'a été détectée dans isolved pour le mappage du superviseur actuel de votre organigramme. Contactez votre administrateur isolved pour mettre à jour le mappage du superviseur.",
    "isolvedMappingIncompleteSupervisorTitle": "Relations hiérarchiques du superviseur incomplètes",
    "isolvedMappingIncompleteSupervisorAdmin": "Certains employés n'ont pas de relation hiérarchique dans votre mappage du superviseur actuel. Nous avons détecté que les relations hiérarchiques créées à l'aide de assigned manager ID sont plus complètes. Souhaitez-vous mettre à jour votre mappage du superviseur pour utiliser assigned manager ID ? Si vous préférez conserver votre mappage actuel, assurez-vous que tous les employés disposent d'une valeur dans isolved.",
    "isolvedMappingIncompleteSupervisorUser": "Certains employés n'ont pas de relation hiérarchique dans isolved pour le mappage du superviseur actuel de votre organigramme. Contactez votre administrateur isolved pour vérifier le mappage du superviseur.",
    "isolvedMappingNoneDetectedTitle": "Aucune relation hiérarchique détectée",
    "isolvedMappingNoneDetectedAdmin": "Un organigramme ne peut pas être créé, car aucune relation hiérarchique n'a été détectée. Assurez-vous que les employés ont un responsable ou un superviseur assigné dans isolved ; l'organigramme se mettra à jour dans l'heure.",
    "isolvedMappingNoneDetectedUser": "Un organigramme ne peut pas être créé, car aucune relation hiérarchique n'a été détectée dans isolved. Contactez votre administrateur isolved pour vous assurer que les employés ont un responsable ou un superviseur assigné.",
    "isolvedMissingJobIdErrTitle": "Affectation de poste manquante",
    "isolvedMissingJobIdErrAdmin": "Aucun de vos employés isolved n'a d'affectation de poste. Attribuez un poste à chaque employé dans isolved ; l'organigramme se mettra à jour dans l'heure.",
    "isolvedMissingJobIdErrUser": "Aucun employé de votre organisation dans isolved n'a d'affectation de poste. Contactez votre administrateur isolved pour compléter ces postes.",
    "Unlock": "Déverrouiller",
    "Unlock advanced security": "Déverrouillez la sécurité avancée",
    "Unlock plan approvals": "Déverrouillez les approbations de plan",
    "Unlock planning": "Déverrouillez la planification",
    "Unlock point in time": "Déverrouillez Point dans le temps",
    "access groups upgrade message": "Créez des groupes d'accès personnalisés pour contrôler précisément qui peut consulter, modifier et gérer certains organigrammes, dossiers et données au sein de votre organisation.",
    "access groups upgrade template": "Créez des {groupes d'accès personnalisés} pour contrôler précisément qui peut consulter, modifier et gérer certains organigrammes, dossiers et données au sein de votre organisation.",
    "custom access groups": "groupes d'accès personnalisés",
    "ui profiles upgrade message": "Contrôlez l'accès à certains éléments de l'interface, afin que les utilisateurs ne voient que ce dont ils ont besoin.",
    "ui profiles upgrade template": "Contrôlez l'accès à {certains éléments de l'interface}, afin que les utilisateurs ne voient que ce dont ils ont besoin.",
    "certain UI elements": "certains éléments de l'interface",
    "Unlock access groups": "Déverrouillez les groupes d'accès",
    "Unlock UI profiles": "Déverrouillez les Profils d'UI",
    "Unlock Admin Log": "Déverrouillez le journal d'administration",
    "Add to library": "Ajouter à la bibliothèque",
    "Edit record details": "Modifier les détails de l'enregistrement",
  "Agent profile": "Profil de l'agent",
    "Agent profile card": "Carte de profil de l'agent",
    "Agent profile desc": "Choisissez les données à afficher sur les cartes de profil d'agent.",
    "Card header information": "Informations d'en-tête de la carte",
    "About me": "À propos de moi",
    "Lifecycle and governance details": "Détails du cycle de vie et de la gouvernance",
    "Lifecycle and governance": "Cycle de vie et gouvernance",
    "Adoption & activity": "Adoption et activité",
    "Adoption and activity": "Adoption et activité",
    "Additional details": "Détails supplémentaires",
    "view here": "voir ici",
    "Agent audit log": "Journal d'audit",
    "last ran {n} days ago": "dernière exécution il y a {n} jours",
    "Identity": "Identité",
    "Technical": "Technique",
    "Cost": "Coût",
    "Alerts": "Alertes",
    "Action breakdown": "Répartition des actions",
    "1 employee affected": "1 employé concerné",
    "{n} employees affected": "{n} employés concernés",
    "Open alert details": "Ouvrir les détails de l'alerte",
    "Agent name": "Nom de l'agent",
    "Agent type": "Type d'agent",
    "About": "À propos",
    "Detail link": "Lien vers les détails",
    "Last updated": "Dernière mise à jour",
    "Model used": "Modèle utilisé",
    "Models used": "Modèles utilisés",
    "Platform": "Plateforme",
    "Review frequency": "Fréquence de révision",
    "Access scope": "Portée d'accès",
    "Audit log link": "Lien vers le journal d'audit",
    "Date created": "Date de création",
    "Date deployed": "Date de déploiement",
    "Errors prevented": "Erreurs évitées",
    "Auto-corrections": "Corrections automatiques",
    "Items reviewed": "Éléments examinés",
    "Items reviewed (last pay cycle)": "Éléments examinés (dernier cycle de paie)",
    "Time saved": "Temps économisé",
    "Time saved (this month)": "Temps économisé (ce mois-ci)",
    "Active users": "Utilisateurs actifs",
    "Approval rate": "Taux d'approbation",
    "Days since last use": "Jours depuis la dernière utilisation",
    "Requests made": "Demandes effectuées",
    "Sessions": "Sessions",
    "Sessions (this month)": "Sessions (ce mois-ci)",
    "Agent spend": "Dépenses de l'agent",
    "Token spend": "Consommation de jetons",
    "Token spend (this month)": "Consommation de jetons (ce mois-ci)",
    "Critical alerts": "Alertes critiques",
    "Open alerts": "Alertes ouvertes",
    "Top alerts": "Principales alertes",
    "Auto-applied": "Appliqué automatiquement",
    "Resolved": "Résolu",
    "Dismissed": "Ignoré",
    "Full name (Title)": "Nom complet (Titre)",
    "Agent View": "Vue agent",
    "exportFailedTitle": "Échec de l'exportation",
    "exportFailedMsg": "Impossible de créer votre exportation. Veuillez réessayer. Si le problème persiste, contactez le Support technique.",
    "Drill down available": "Exploration vers le bas disponible",
    "Drill up available": "Exploration vers le haut disponible",
    "Drill down": "Explorer vers le bas",
    "Drill up": "Explorer vers le haut",
    "Chart keyboard help": "Organigramme. Utilisez les touches fléchées pour passer d'une case à l'autre, Entrée pour ouvrir les actions de la case, et Alt plus flèche haut ou bas pour explorer. Appuyez sur Tab pour quitter l'organigramme."
}
